/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */
import type {
    DeleteApiAddonsAddonId200,
    DeleteApiBookingDiscountId200,
    DeleteApiBundleOffersId200,
    DeleteApiCalendlyWebhookSubscriptions200,
    DeleteApiCampaignsId200,
    DeleteApiCustomerGroupsId200,
    DeleteApiCustomerGroupsIdCustomers200,
    DeleteApiCustomerGroupsIdCustomersBody,
    DeleteApiDataProcessingAgreementId200,
    DeleteApiDiscountId200,
    DeleteApiDoctorsPortalDoctorsDoctorUuid200,
    DeleteApiExpenseId200,
    DeleteApiFiles200,
    DeleteApiFilesBody,
    DeleteApiGiftCardsId200,
    DeleteApiGiftCardsOnlineId200,
    DeleteApiHealthDeclarationTemplateId200,
    DeleteApiHealthDeclarationTemplatesBulk200,
    DeleteApiHealthDeclarationTemplatesBulkBody,
    DeleteApiIotDevicesDeviceId200,
    DeleteApiLprTreatmentMappingsBulk200,
    DeleteApiLprTreatmentMappingsBulkBody,
    DeleteApiLprTreatmentMappingsId200,
    DeleteApiPaymentsCardId200,
    DeleteApiPaymentsSubscriptionDelete200,
    DeleteApiPaymentsSubscriptionDeleteBody,
    DeleteApiProductCategoriesId200,
    DeleteApiProducts200,
    DeleteApiProductsBody,
    DeleteApiSalesId200,
    DeleteApiSalesIdParams,
    DeleteApiServiceAdvancedReminderTemplatesBulk200,
    DeleteApiServiceAdvancedReminderTemplatesBulkBody,
    DeleteApiServiceAdvancedReminderTemplatesReminderTemplateId200,
    DeleteApiServiceSubscriptionId200,
    DeleteApiServicesServiceIdFormulasFormulaId200,
    DeleteApiSupplierId200,
    DeleteApiUnitsId200,
    DeleteApiWebhooksId200,
    GetApiAddons200,
    GetApiAddonsList200,
    GetApiAdvanceJournalFormats200,
    GetApiAdvanceJournalFormatsId200,
    GetApiAdvanceJournalFormatsParams,
    GetApiAdvanceJournalJobsId200,
    GetApiAdvanceJournalModels200,
    GetApiAdvanceJournalProviders200,
    GetApiAdvanceJournalProvidersId200,
    GetApiAdvanceJournalProvidersParams,
    GetApiAnalyticsAdsPerformance200,
    GetApiAnalyticsAdsPerformanceParams,
    GetApiAnalyticsBookings200,
    GetApiAnalyticsBookingsParams,
    GetApiAnalyticsCustomers200,
    GetApiAnalyticsCustomersParams,
    GetApiAnalyticsEarnings200,
    GetApiAnalyticsEarningsParams,
    GetApiBillyExport200,
    GetApiBillyExportParams,
    GetApiBooking200,
    GetApiBookingDiscountId200,
    GetApiBookingParams,
    GetApiBookingsExportParams,
    GetApiBookingsNoShowReminder200,
    GetApiBundleOfferServiceList200Item,
    GetApiBundleOffers200,
    GetApiBundleOffersCodeBundleOfferCode200,
    GetApiBundleOffersId200,
    GetApiBundleOffersParams,
    GetApiBundleOffersSettings200,
    GetApiBundleOffersSoldIdType200Item,
    GetApiBundleOffersSoldIdTypeParams,
    GetApiCalendlyAuthUrl200,
    GetApiCalendlyAuthUrlParams,
    GetApiCalendlyCallback200,
    GetApiCalendlyCallbackParams,
    GetApiCalendlyStatus200,
    GetApiCampaigns200,
    GetApiCampaignsCampaignIdStatisticsRecipients200Item,
    GetApiCampaignsEmailOverview200,
    GetApiCampaignsEmailOverviewParams,
    GetApiCampaignsId200,
    GetApiCampaignsParams,
    GetApiCashDrawerCashDrawerIdDineroPayload200,
    GetApiCashDrawerEmployeeSummary200,
    GetApiCashDrawerEmployeeSummaryParams,
    GetApiCustomerGroups200,
    GetApiCustomerGroupsId200,
    GetApiCustomerGroupsIdMembers200Item,
    GetApiCustomerGroupsParams,
    GetApiCustomerId200,
    GetApiCustomerIdSalesOverview200,
    GetApiCustomerIdType200,
    GetApiCustomers200,
    GetApiCustomersCustomerIdGroups200Item,
    GetApiCustomersParams,
    GetApiDataProcessingAgreementId200,
    GetApiDataProcessingAgreementIdAcceptances200,
    GetApiDataProcessingAgreementIdAcceptancesParams,
    GetApiDataProcessingAgreements200,
    GetApiDataProcessingAgreementsParams,
    GetApiDataProcessingAgreementsPending200,
    GetApiDineroOrganizations200,
    GetApiDineroOrganizationsOrganizationIdAccounts200,
    GetApiDineroRefreshToken200,
    GetApiDirectWebstorePayments200,
    GetApiDirectWebstorePaymentsParams,
    GetApiDoctorsPortalDoctors200,
    GetApiDoctorsPortalDoctorsDoctorIdDirectories200,
    GetApiDoctorsPortalDoctorsParams,
    GetApiDoctorsPortalLogs200,
    GetApiDoctorsPortalLogsParams,
    GetApiDoctorsPortalMessages200,
    GetApiDoctorsPortalMessagesParams,
    GetApiDoctorsPortalNotifications200,
    GetApiDoctorsPortalNotificationsParams,
    GetApiExpenseCategories200,
    GetApiExpenseCategoriesParams,
    GetApiExpenseId200,
    GetApiExpenses200,
    GetApiExpensesParams,
    GetApiGenerateDiscountCode200,
    GetApiGetCustomerLedgerId200,
    GetApiGetcreditsales200Item,
    GetApiGiftCardOnlineId200,
    GetApiGiftCards200,
    GetApiGiftCardsCodeCode200,
    GetApiGiftCardsId200,
    GetApiGiftCardsListTypeParams,
    GetApiGiftCardsOnlineType200,
    GetApiGiftCardsParams,
    GetApiGiftCardsSettings200,
    GetApiGlobalSearch200,
    GetApiGlobalSearchParams,
    GetApiGoogleCalendarAuthUrl200,
    GetApiGoogleCalendarAuthUrlParams,
    GetApiGoogleCalendarBookingStatusByGroupUuid200,
    GetApiGoogleCalendarBookingStatusByGroupUuidParams,
    GetApiGoogleCalendarCallback200,
    GetApiGoogleCalendarCallbackParams,
    GetApiGoogleCalendarStatus200,
    GetApiGoogleCalendarWebhook200,
    GetApiGoogleCalendarWebhookParams,
    GetApiHealthDeclarationTemplateId200,
    GetApiHealthDeclarationTemplates200,
    GetApiHealthDeclarationTemplatesParams,
    GetApiHealthDeclarations200,
    GetApiHealthDeclarationsParams,
    GetApiImportDataBookingsMetadata200,
    GetApiImportDataCustomersMetadata200,
    GetApiImportDataJournalsMetadata200,
    GetApiImportDataJournalsMetadataParams,
    GetApiImportDataNotifications200,
    GetApiImportDataNotificationsParams,
    GetApiImportDataSampleTypeParams,
    GetApiImportDataServicesMetadata200,
    GetApiInsightsCustomerOutstanding200,
    GetApiInsightsCustomerStatistics200,
    GetApiInsightsCustomerStatisticsParams,
    GetApiInsightsCustomers200,
    GetApiInsightsCustomersParams,
    GetApiInsightsEmployeePaymentsType200,
    GetApiInsightsEmployeePaymentsTypeParams,
    GetApiInsightsGiftCards200,
    GetApiInsightsGiftCardsParams,
    GetApiInsightsPunchCards200,
    GetApiInsightsPunchCardsParams,
    GetApiInsightsSalesDetailsItemTypeIdType200,
    GetApiInsightsSalesDetailsItemTypeIdTypeParams,
    GetApiInsightsSalesEmployeeIdPaymentTypeType200,
    GetApiInsightsSalesEmployeeIdPaymentTypeTypeParams,
    GetApiInsightsSalesType200,
    GetApiInsightsSalesTypeParams,
    GetApiInsightsStockReports200,
    GetApiInsightsStockReportsParams,
    GetApiInsightsSummaryItemTypeType200,
    GetApiInsightsSummaryItemTypeTypeParams,
    GetApiInsightsTaxReportsType200,
    GetApiInsightsTaxReportsTypeParams,
    GetApiInsightsTopCustomers200,
    GetApiInsightsTopCustomersParams,
    GetApiInsightsUniqueCustomers200,
    GetApiInsightsUniqueCustomersParams,
    GetApiInsightsWeeklyTurnoverType200,
    GetApiInsightsWeeklyTurnoverTypeParams,
    GetApiInsightsZipcodeStatistics200,
    GetApiIotConnectionStatus200,
    GetApiIotDevices200,
    GetApiIotDevicesParams,
    GetApiItemTax200Item,
    GetApiKlaviyoConfig200,
    GetApiListBookingDiscounts200,
    GetApiListBookingDiscountsParams,
    GetApiListDiscounts200Item,
    GetApiListSuppliers200Item,
    GetApiLprFormRequests200Item,
    GetApiLprReports200,
    GetApiLprReportsId200,
    GetApiLprReportsParams,
    GetApiLprReportsSummary200,
    GetApiLprSettings200,
    GetApiLprTreatmentMappings200Item,
    GetApiLprTreatmentMappingsParams,
    GetApiMessageLogsOutletId200Item,
    GetApiMobilepayPaymentStatusReference200,
    GetApiPaymentPlan200,
    GetApiPaymentsCard200,
    GetApiPaymentsCardCreateCancel200,
    GetApiPaymentsCardCreateCancelParams,
    GetApiPaymentsCardCreateSuccess200,
    GetApiPaymentsCardCreateSuccessParams,
    GetApiPaymentsSubscriptionCreateCancelPaymentIdParams,
    GetApiPaymentsSubscriptionCreateSuccessPaymentIdParams,
    GetApiPaymentsSubscriptionOutletOutletId200,
    GetApiPreviousSalesItemsCustomerId200,
    GetApiPreviousSalesItemsCustomerIdParams,
    GetApiProductCategories200Item,
    GetApiProductListPrintTypeParams,
    GetApiProductsId200,
    GetApiProductsListing200,
    GetApiProductsListingParams,
    GetApiRecipients200,
    GetApiRecipientsParams,
    GetApiSaleId200,
    GetApiSalesDetailsId200,
    GetApiSalesList200,
    GetApiSalesListParams,
    GetApiSalesListPrintTypeParams,
    GetApiServiceAdvancedReminderTemplates200,
    GetApiServiceAdvancedReminderTemplatesParams,
    GetApiServiceAdvancedReminderTemplatesReminderTemplateId200,
    GetApiServiceAppModules200,
    GetApiServiceGroupsIdDrivingFees200,
    GetApiServiceSubscriptionCustomer200,
    GetApiServiceSubscriptionCustomerParams,
    GetApiServicesDeposit200,
    GetApiServicesServiceIdFormulas200,
    GetApiServicesServiceIdFormulasFormulaId200,
    GetApiSoldBundleOffersIdHistory200Item,
    GetApiStatisticsAppointments200,
    GetApiStatisticsAppointmentsByTime200,
    GetApiStatisticsAppointmentsByTimeParams,
    GetApiStatisticsAppointmentsParams,
    GetApiStatisticsBundleOffers200,
    GetApiStatisticsBundleOffersParams,
    GetApiStatisticsDiscountCodes200,
    GetApiStatisticsDiscountCodesParams,
    GetApiStatisticsExportAppointmentsByTimeParams,
    GetApiStatisticsExportAppointmentsParams,
    GetApiStatisticsExportDiscountCodesParams,
    GetApiStatisticsExportGroupedParams,
    GetApiStatisticsExportServicesParams,
    GetApiStatisticsGrouped200,
    GetApiStatisticsGroupedParams,
    GetApiStatisticsSales200,
    GetApiStatisticsSalesParams,
    GetApiStatisticsSalesSummary200,
    GetApiStatisticsSalesSummaryParams,
    GetApiStatisticsServices200,
    GetApiStatisticsServicesParams,
    GetApiSubscriptionDetails200,
    GetApiSubscriptionDownloadInvoiceId200,
    GetApiSubscriptionInvoices200,
    GetApiSupplierId200,
    GetApiTax200Item,
    GetApiTerminalPaymentLogPaymentId200,
    GetApiTriggerTemplates200,
    GetApiTrustpilotConfig200,
    GetApiUnits200Item,
    GetApiUnitsId200,
    GetApiWebhooks200,
    GetApiWebhooksParams,
    PatchApiBookingStatusUpdate200,
    PatchApiBookingStatusUpdateBody,
    PatchApiBookingStatusUpdateParams,
    PatchApiBookingsNoShowId200,
    PatchApiBookingsNoShowIdBody,
    PatchApiBundleOffersIdStatus200,
    PatchApiBundleOffersIdStatusBody,
    PatchApiCampaignsIdStatus200,
    PatchApiCampaignsIdStatusBody,
    PatchApiDoctorsPortalMessagesReadBulk200,
    PatchApiDoctorsPortalMessagesReadBulkBody,
    PatchApiDoctorsPortalNotificationsRead200,
    PatchApiDoctorsPortalNotificationsReadBody,
    PatchApiEmployeeOpeningHoursEmployeeId200Item,
    PatchApiEmployeeOpeningHoursEmployeeIdBody,
    PatchApiGiftCardsId200,
    PatchApiGiftCardsIdBody,
    PatchApiGiftCardsIdStatus200,
    PatchApiGiftCardsIdStatusBody,
    PatchApiGoogleCalendarSettings200,
    PatchApiGoogleCalendarSettingsBody,
    PatchApiHealthDeclarationTemplatesBulk200,
    PatchApiHealthDeclarationTemplatesBulkBody,
    PatchApiLprReportsId200,
    PatchApiLprReportsIdBody,
    PatchApiServiceAdvancedReminderTemplatesBulk200,
    PatchApiServiceAdvancedReminderTemplatesBulkBody,
    PatchApiServiceAdvancedReminderTemplatesReminderTemplateId200,
    PatchApiServiceAdvancedReminderTemplatesReminderTemplateIdBody,
    PatchApiServiceAppModulesModuleKey200,
    PatchApiServiceAppModulesModuleKeyBody,
    PatchApiServiceGroupsIdDrivingFees200,
    PatchApiServiceGroupsIdDrivingFeesBody,
    PatchApiServicesDeposit200,
    PatchApiServicesDepositBody,
    PatchApiSoldBundleOffersId200,
    PatchApiSoldBundleOffersIdBody,
    PostApiAbortCardPayment200,
    PostApiAbortCardPaymentBody,
    PostApiAddonsUpsert200,
    PostApiAddonsUpsertBody,
    PostApiAdvanceJournalJobs201,
    PostApiAdvanceJournalJobsBody,
    PostApiAdvanceJournalProviders201,
    PostApiAdvanceJournalProvidersBody,
    PostApiBillingInfo200,
    PostApiBillingInfoBody,
    PostApiBookingDiscount201,
    PostApiBookingDiscountBody,
    PostApiBundleOffers201,
    PostApiBundleOffersBody,
    PostApiBundleOffersUse200,
    PostApiBundleOffersUseBody,
    PostApiCalendlyDisconnect200,
    PostApiCalendlyWebhook200,
    PostApiCalendlyWebhookBody,
    PostApiCampaigns201,
    PostApiCampaignsBody,
    PostApiCampaignsIdSendTestEmail200,
    PostApiCampaignsIdSendTestEmailBody,
    PostApiCampaignsIdTrigger200,
    PostApiCampaignsStatistics200Item,
    PostApiCampaignsStatisticsBody,
    PostApiCashDrawerClose200,
    PostApiCashDrawerCloseBody,
    PostApiCashDrawerOpen201,
    PostApiCashDrawerOpenBody,
    PostApiCheckBookingDiscount200,
    PostApiCheckBookingDiscountBody,
    PostApiCommunicationTemplates200,
    PostApiCommunicationTemplatesBody,
    PostApiCprLookup200,
    PostApiCprLookupBody,
    PostApiCustomerGroups201,
    PostApiCustomerGroupsBody,
    PostApiCustomerGroupsIdCustomers200,
    PostApiCustomerGroupsIdCustomersBody,
    PostApiDataProcessingAgreementIdAccept201,
    PostApiDataProcessingAgreementIdAcceptBody,
    PostApiDataProcessingAgreements201,
    PostApiDataProcessingAgreementsBody,
    PostApiDirectWebstorePaymentsTransactionIdCredit200,
    PostApiDirectWebstorePaymentsTransactionIdCreditBody,
    PostApiDiscount201,
    PostApiDiscountBody,
    PostApiDoctorsPortalInvite201,
    PostApiDoctorsPortalInviteBody,
    PostApiDoctorsPortalPublicLogin200,
    PostApiDoctorsPortalPublicLoginBody,
    PostApiDoctorsPortalPublicLoginResendOtp200,
    PostApiDoctorsPortalPublicLoginResendOtpBody,
    PostApiDoctorsPortalPublicLoginVerifyOtp200,
    PostApiDoctorsPortalPublicLoginVerifyOtpBody,
    PostApiDoctorsPortalPublicSignupRequestOtp201,
    PostApiDoctorsPortalPublicSignupRequestOtpBody,
    PostApiDoctorsPortalPublicSignupResendOtp200,
    PostApiDoctorsPortalPublicSignupResendOtpBody,
    PostApiDoctorsPortalPublicSignupVerifyOtp201,
    PostApiDoctorsPortalPublicSignupVerifyOtpBody,
    PostApiEconomicConnectBody,
    PostApiEconomicSyncSalesBody,
    PostApiExpense201,
    PostApiExpenseBody,
    PostApiFilesUpload201,
    PostApiGatewayapiWebhook200,
    PostApiGatewayapiWebhookBody,
    PostApiGatewayapiWebhookCampaignId200,
    PostApiGatewayapiWebhookCampaignIdBody,
    PostApiGiftCards201,
    PostApiGiftCardsBody,
    PostApiGiftCardsIdUse200,
    PostApiGiftCardsIdUseBody,
    PostApiGiftCardsOnline201,
    PostApiGiftCardsOnlineBody,
    PostApiGiftCardsSendEmail200,
    PostApiGiftCardsSendEmailBody,
    PostApiGoogleCalendarBookingSync200,
    PostApiGoogleCalendarBookingSyncBody,
    PostApiGoogleCalendarBookingSyncByGroupUuid200,
    PostApiGoogleCalendarBookingSyncByGroupUuidBody,
    PostApiGoogleCalendarDisconnect200,
    PostApiGoogleCalendarSyncHolidays200,
    PostApiGoogleCalendarSyncHolidaysBody,
    PostApiGoogleCalendarSyncSchedule200,
    PostApiGoogleCalendarSyncScheduleBody,
    PostApiGoogleCalendarWebhook200,
    PostApiGoogleCalendarWebhookParams,
    PostApiHealthDeclarationBookingBookingIdSendEmail200,
    PostApiHealthDeclarationBookingBookingIdSendEmailParams,
    PostApiHealthDeclarationTemplates201,
    PostApiHealthDeclarationTemplatesBody,
    PostApiHealthDeclarationsGroupBookingGroupBookingUuid201,
    PostApiImportDataBookings202,
    PostApiImportDataBookingsBody,
    PostApiImportDataBookingsParams,
    PostApiImportDataCustomers202,
    PostApiImportDataCustomersBody,
    PostApiImportDataCustomersParams,
    PostApiImportDataJournals202,
    PostApiImportDataJournalsBody,
    PostApiImportDataJournalsParams,
    PostApiImportDataNotificationsIdRead200,
    PostApiImportDataServices202,
    PostApiImportDataServicesBody,
    PostApiImportDataServicesParams,
    PostApiIotDevices201,
    PostApiIotDevicesBody,
    PostApiIotValidateToken200,
    PostApiIotValidateTokenBody,
    PostApiItemTax201,
    PostApiItemTaxBody,
    PostApiKlaviyo200,
    PostApiKlaviyoBody,
    PostApiKlaviyoDisconnect200,
    PostApiKlaviyoSyncCustomer200,
    PostApiKlaviyoSyncCustomerBody,
    PostApiLprFormRequests201,
    PostApiLprFormRequestsBody,
    PostApiLprReportsIdRemove200,
    PostApiLprReportsIdRestore200,
    PostApiLprReportsIdSubmit200,
    PostApiLprReportsIdUndo200,
    PostApiLprReportsSubmitAll202,
    PostApiLprSksCodesSearch200,
    PostApiLprSksCodesSearchBody,
    PostApiLprTreatmentMappings200,
    PostApiLprTreatmentMappingsBody,
    PostApiMakeCardPayment200,
    PostApiMakeCardPaymentBody,
    PostApiMarketingSetPermissionByPercentage200,
    PostApiMarketingSetPermissionByPercentageBody,
    PostApiMobilepayCreateMobilepayOrder201,
    PostApiMobilepayCreateMobilepayOrderBody,
    PostApiMobilepayWebhook200,
    PostApiMobilepayWebhookBody,
    PostApiPaymentsCard200,
    PostApiPaymentsSubscriptionCreate200,
    PostApiPaymentsSubscriptionCreateBody,
    PostApiPaymentsSubscriptionPay200,
    PostApiPaymentsSubscriptionPayBody,
    PostApiPaymentsSubscriptionRenewalOverdue200,
    PostApiPaymentsSubscriptionStart201,
    PostApiPaymentsSubscriptionStartBody,
    PostApiPaymentsWebhook200,
    PostApiPaymentsWebhookBody,
    PostApiProduct201,
    PostApiProductBody,
    PostApiProductCategories201,
    PostApiProductCategoriesBody,
    PostApiSale201,
    PostApiSaleBody,
    PostApiSendSalesEmail200,
    PostApiSendSalesEmailBody,
    PostApiServiceAdvancedReminderTemplates201,
    PostApiServiceAdvancedReminderTemplatesBody,
    PostApiServiceSubscription200,
    PostApiServiceSubscription201,
    PostApiServiceSubscriptionBody,
    PostApiServicesServiceIdFormulas201,
    PostApiServicesServiceIdFormulasBody,
    PostApiServicesSync200,
    PostApiServicesSyncBody,
    PostApiSoldBundleOffersSendEmail200,
    PostApiSoldBundleOffersSendEmailBody,
    PostApiStock200,
    PostApiStockBody,
    PostApiSupplier201,
    PostApiSupplierBody,
    PostApiTax201,
    PostApiTaxBody,
    PostApiTrustpilot200,
    PostApiTrustpilotBody,
    PostApiTrustpilotDisconnect200,
    PostApiTrustpilotSendTest200,
    PostApiTrustpilotSendTestBody,
    PostApiUnits201,
    PostApiUnitsBody,
    PostApiWebhooks201,
    PostApiWebhooksBody,
    PutApiBookingDiscountId200,
    PutApiBookingDiscountIdBody,
    PutApiBundleOffersId200,
    PutApiBundleOffersIdBody,
    PutApiBundleOffersSettings200,
    PutApiBundleOffersSettingsBody,
    PutApiCampaignsCampaignIdStatisticsRecipients200,
    PutApiCampaignsCampaignIdStatisticsRecipientsBody,
    PutApiCampaignsId200,
    PutApiCampaignsIdBody,
    PutApiCatalogSequence200,
    PutApiCatalogSequenceBody,
    PutApiCreditSaleIdBody,
    PutApiCustomerGroupsId200,
    PutApiCustomerGroupsIdBody,
    PutApiDataProcessingAgreementId200,
    PutApiDataProcessingAgreementIdBody,
    PutApiDineroConfig200,
    PutApiDineroConfigBody,
    PutApiDiscountId200,
    PutApiDiscountIdBody,
    PutApiEconomicConfigBody,
    PutApiEditSalesId200,
    PutApiEditSalesIdBody,
    PutApiExpenseId200,
    PutApiExpenseIdBody,
    PutApiGiftCardsOnlineId200,
    PutApiGiftCardsOnlineIdBody,
    PutApiGiftCardsSettings200,
    PutApiGiftCardsSettingsBody,
    PutApiHealthDeclarationId200,
    PutApiHealthDeclarationIdBody,
    PutApiHealthDeclarationTemplateId200,
    PutApiHealthDeclarationTemplateIdBody,
    PutApiIotDevicesDeviceId200,
    PutApiIotDevicesDeviceIdBody,
    PutApiLprSettings200,
    PutApiLprSettingsBody,
    PutApiLprTreatmentMappingsBulk200,
    PutApiLprTreatmentMappingsBulkBody,
    PutApiLprTreatmentMappingsId200,
    PutApiLprTreatmentMappingsIdBody,
    PutApiPaymentsSubscriptionEdit200,
    PutApiPaymentsSubscriptionEditBody,
    PutApiProductCategoriesId200,
    PutApiProductCategoriesIdBody,
    PutApiProductId200,
    PutApiProductIdBody,
    PutApiServiceSubscriptionId200,
    PutApiServiceSubscriptionIdBody,
    PutApiServicesEmployeeAssignEmployeeId200,
    PutApiServicesEmployeeAssignEmployeeIdBody,
    PutApiServicesServiceIdFormulas200,
    PutApiServicesServiceIdFormulasBody,
    PutApiServicesServiceIdFormulasFormulaId200,
    PutApiServicesServiceIdFormulasFormulaIdBody,
    PutApiSupplierId200,
    PutApiSupplierIdBody,
    PutApiUnitsId200,
    PutApiUnitsIdBody,
    PutApiUpdateProducts200Item,
    PutApiUpdateProductsBody,
    PutApiWebhooksId200,
    PutApiWebhooksIdBody,
} from './models';

import { customFetcher } from './client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getApi = () => {
    const getHealth = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/health`, method: 'GET' }, options);
    };

    const getReady = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/ready`, method: 'GET' }, options);
    };

    const getApiMessageLogsOutletId = (
        outletId: number,
        options?: SecondParameter<typeof customFetcher<GetApiMessageLogsOutletId200Item[]>>,
    ) => {
        return customFetcher<GetApiMessageLogsOutletId200Item[]>(
            { url: `/api/message-logs/${outletId}`, method: 'GET' },
            options,
        );
    };

    /**
     * Create a new product category
     */
    const postApiProductCategories = (
        postApiProductCategoriesBody: PostApiProductCategoriesBody,
        options?: SecondParameter<typeof customFetcher<PostApiProductCategories201>>,
    ) => {
        return customFetcher<PostApiProductCategories201>(
            {
                url: `/api/product-categories`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiProductCategoriesBody,
            },
            options,
        );
    };

    /**
     * Get all product categories
     */
    const getApiProductCategories = (
        options?: SecondParameter<typeof customFetcher<GetApiProductCategories200Item[]>>,
    ) => {
        return customFetcher<GetApiProductCategories200Item[]>(
            { url: `/api/product-categories`, method: 'GET' },
            options,
        );
    };

    /**
     * Update product and category display order for grouped catalog UI
     */
    const putApiCatalogSequence = (
        putApiCatalogSequenceBody: PutApiCatalogSequenceBody,
        options?: SecondParameter<typeof customFetcher<PutApiCatalogSequence200>>,
    ) => {
        return customFetcher<PutApiCatalogSequence200>(
            {
                url: `/api/catalog/sequence`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiCatalogSequenceBody,
            },
            options,
        );
    };

    /**
     * Update a product category
     */
    const putApiProductCategoriesId = (
        id: string,
        putApiProductCategoriesIdBody: PutApiProductCategoriesIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiProductCategoriesId200>>,
    ) => {
        return customFetcher<PutApiProductCategoriesId200>(
            {
                url: `/api/product-categories/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiProductCategoriesIdBody,
            },
            options,
        );
    };

    /**
     * Delete a product category
     */
    const deleteApiProductCategoriesId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiProductCategoriesId200>>,
    ) => {
        return customFetcher<DeleteApiProductCategoriesId200>(
            { url: `/api/product-categories/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * List units (outlet-scoped + global default units). Each item includes isDefault (true for global units).
     */
    const getApiUnits = (options?: SecondParameter<typeof customFetcher<GetApiUnits200Item[]>>) => {
        return customFetcher<GetApiUnits200Item[]>({ url: `/api/units`, method: 'GET' }, options);
    };

    /**
     * Create a new unit
     */
    const postApiUnits = (
        postApiUnitsBody: PostApiUnitsBody,
        options?: SecondParameter<typeof customFetcher<PostApiUnits201>>,
    ) => {
        return customFetcher<PostApiUnits201>(
            {
                url: `/api/units`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiUnitsBody,
            },
            options,
        );
    };

    /**
     * Get a unit by id
     */
    const getApiUnitsId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiUnitsId200>>) => {
        return customFetcher<GetApiUnitsId200>({ url: `/api/units/${id}`, method: 'GET' }, options);
    };

    /**
     * Update an existing outlet-scoped unit (default/global units cannot be updated)
     */
    const putApiUnitsId = (
        id: string,
        putApiUnitsIdBody: PutApiUnitsIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiUnitsId200>>,
    ) => {
        return customFetcher<PutApiUnitsId200>(
            {
                url: `/api/units/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiUnitsIdBody,
            },
            options,
        );
    };

    /**
     * Delete an outlet-scoped unit (default/global units cannot be deleted)
     */
    const deleteApiUnitsId = (id: string, options?: SecondParameter<typeof customFetcher<DeleteApiUnitsId200>>) => {
        return customFetcher<DeleteApiUnitsId200>({ url: `/api/units/${id}`, method: 'DELETE' }, options);
    };

    /**
     * Create a new product category
     */
    const postApiProduct = (
        postApiProductBody: PostApiProductBody,
        options?: SecondParameter<typeof customFetcher<PostApiProduct201>>,
    ) => {
        return customFetcher<PostApiProduct201>(
            {
                url: `/api/product`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiProductBody,
            },
            options,
        );
    };

    /**
     * Get all products
     */
    const getApiProductsId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiProductsId200>>) => {
        return customFetcher<GetApiProductsId200>({ url: `/api/products/${id}`, method: 'GET' }, options);
    };

    /**
     * Update a product
     */
    const putApiProductId = (
        id: string,
        putApiProductIdBody: PutApiProductIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiProductId200>>,
    ) => {
        return customFetcher<PutApiProductId200>(
            {
                url: `/api/product/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiProductIdBody,
            },
            options,
        );
    };

    /**
     * Delete a product
     */
    const deleteApiProducts = (
        deleteApiProductsBody: DeleteApiProductsBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiProducts200>>,
    ) => {
        return customFetcher<DeleteApiProducts200>(
            {
                url: `/api/products`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiProductsBody,
            },
            options,
        );
    };

    /**
     * Update multiple products
     */
    const putApiUpdateProducts = (
        putApiUpdateProductsBody: PutApiUpdateProductsBody,
        options?: SecondParameter<typeof customFetcher<PutApiUpdateProducts200Item[]>>,
    ) => {
        return customFetcher<PutApiUpdateProducts200Item[]>(
            {
                url: `/api/update-products`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiUpdateProductsBody,
            },
            options,
        );
    };

    /**
     * Get all products with pagination and text search
     */
    const getApiProductsListing = (
        params: GetApiProductsListingParams,
        options?: SecondParameter<typeof customFetcher<GetApiProductsListing200>>,
    ) => {
        return customFetcher<GetApiProductsListing200>(
            { url: `/api/products-listing`, method: 'GET', params },
            options,
        );
    };

    /**
     * Create a new supplier
     */
    const postApiSupplier = (
        postApiSupplierBody: PostApiSupplierBody,
        options?: SecondParameter<typeof customFetcher<PostApiSupplier201>>,
    ) => {
        return customFetcher<PostApiSupplier201>(
            {
                url: `/api/supplier`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiSupplierBody,
            },
            options,
        );
    };

    /**
     * Get all suppliers
     */
    const getApiSupplierId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiSupplierId200>>) => {
        return customFetcher<GetApiSupplierId200>({ url: `/api/supplier/${id}`, method: 'GET' }, options);
    };

    /**
     * Update a supplier
     */
    const putApiSupplierId = (
        id: string,
        putApiSupplierIdBody: PutApiSupplierIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiSupplierId200>>,
    ) => {
        return customFetcher<PutApiSupplierId200>(
            {
                url: `/api/supplier/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiSupplierIdBody,
            },
            options,
        );
    };

    /**
     * Delete a supplier
     */
    const deleteApiSupplierId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiSupplierId200>>,
    ) => {
        return customFetcher<DeleteApiSupplierId200>({ url: `/api/supplier/${id}`, method: 'DELETE' }, options);
    };

    /**
     * Get all suppliers
     */
    const getApiListSuppliers = (options?: SecondParameter<typeof customFetcher<GetApiListSuppliers200Item[]>>) => {
        return customFetcher<GetApiListSuppliers200Item[]>({ url: `/api/list-suppliers`, method: 'GET' }, options);
    };

    /**
     * Update a product stock
     */
    const postApiStock = (
        postApiStockBody: PostApiStockBody,
        options?: SecondParameter<typeof customFetcher<PostApiStock200>>,
    ) => {
        return customFetcher<PostApiStock200>(
            {
                url: `/api/stock`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiStockBody,
            },
            options,
        );
    };

    /**
     * Get category list print
     */
    const getApiCategoryListPrintIdType = (
        id: string,
        type: 'html' | 'pdf',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/category-list-print/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * Get supplier list print
     */
    const getApiSupplierListPrintType = (
        type: 'html' | 'pdf' | 'csv' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/supplier-list-print/${type}`, method: 'GET' }, options);
    };

    /**
     * Get product list print
     */
    const getApiProductListPrintType = (
        params?: GetApiProductListPrintTypeParams,
        type: 'html' | 'pdf' | 'csv' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/product-list-print/${type}`, method: 'GET', params }, options);
    };

    /**
     * test cron
     */
    const getApiPaymentsChargeSubscription = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/payments/chargeSubscription`, method: 'GET' }, options);
    };

    /**
     * webhook for billwork
     */
    const postApiPaymentsWebhook = (
        postApiPaymentsWebhookBody: PostApiPaymentsWebhookBody,
        options?: SecondParameter<typeof customFetcher<PostApiPaymentsWebhook200>>,
    ) => {
        return customFetcher<PostApiPaymentsWebhook200>(
            {
                url: `/api/payments/webhook`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiPaymentsWebhookBody,
            },
            options,
        );
    };

    /**
     * Pay for a specific subscription up to a given date
     */
    const postApiPaymentsSubscriptionPay = (
        postApiPaymentsSubscriptionPayBody: PostApiPaymentsSubscriptionPayBody,
        options?: SecondParameter<typeof customFetcher<PostApiPaymentsSubscriptionPay200>>,
    ) => {
        return customFetcher<PostApiPaymentsSubscriptionPay200>(
            {
                url: `/api/payments/subscription/pay`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiPaymentsSubscriptionPayBody,
            },
            options,
        );
    };

    /**
     * Start a new subscription
     */
    const postApiPaymentsSubscriptionStart = (
        postApiPaymentsSubscriptionStartBody: PostApiPaymentsSubscriptionStartBody,
        options?: SecondParameter<typeof customFetcher<PostApiPaymentsSubscriptionStart201>>,
    ) => {
        return customFetcher<PostApiPaymentsSubscriptionStart201>(
            {
                url: `/api/payments/subscription/start`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiPaymentsSubscriptionStartBody,
            },
            options,
        );
    };

    /**
     * Edit subscription details
     */
    const putApiPaymentsSubscriptionEdit = (
        putApiPaymentsSubscriptionEditBody: PutApiPaymentsSubscriptionEditBody,
        options?: SecondParameter<typeof customFetcher<PutApiPaymentsSubscriptionEdit200>>,
    ) => {
        return customFetcher<PutApiPaymentsSubscriptionEdit200>(
            {
                url: `/api/payments/subscription/edit`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiPaymentsSubscriptionEditBody,
            },
            options,
        );
    };

    /**
     * Get all subscriptions for a specific outlet with their payment logs
     */
    const getApiPaymentsSubscriptionOutletOutletId = (
        outletId: number,
        options?: SecondParameter<typeof customFetcher<GetApiPaymentsSubscriptionOutletOutletId200>>,
    ) => {
        return customFetcher<GetApiPaymentsSubscriptionOutletOutletId200>(
            { url: `/api/payments/subscription/outlet/${outletId}`, method: 'GET' },
            options,
        );
    };

    /**
     * Redirect to admin frontend after subscription payment
     */
    const getApiPaymentsSubscriptionCreateSuccessPaymentId = (
        paymentId: string,
        params?: GetApiPaymentsSubscriptionCreateSuccessPaymentIdParams,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            { url: `/api/payments/subscription-create/success/${paymentId}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Redirect to admin frontend after subscription payment
     */
    const getApiPaymentsSubscriptionCreateCancelPaymentId = (
        paymentId: string,
        params?: GetApiPaymentsSubscriptionCreateCancelPaymentIdParams,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            { url: `/api/payments/subscription-create/cancel/${paymentId}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Frisbii recurring session callback for add-card success/cancel. Validates session and returns redirect_url.
     */
    const getApiPaymentsCardCreateSuccess = (
        params?: GetApiPaymentsCardCreateSuccessParams,
        options?: SecondParameter<typeof customFetcher<GetApiPaymentsCardCreateSuccess200>>,
    ) => {
        return customFetcher<GetApiPaymentsCardCreateSuccess200>(
            { url: `/api/payments/card-create/success`, method: 'GET', params },
            options,
        );
    };

    /**
     * Frisbii recurring session callback for add-card success/cancel. Validates session and returns redirect_url.
     */
    const getApiPaymentsCardCreateCancel = (
        params?: GetApiPaymentsCardCreateCancelParams,
        options?: SecondParameter<typeof customFetcher<GetApiPaymentsCardCreateCancel200>>,
    ) => {
        return customFetcher<GetApiPaymentsCardCreateCancel200>(
            { url: `/api/payments/card-create/cancel`, method: 'GET', params },
            options,
        );
    };

    /**
     * Delete a subscription by subscription ID and outlet ID (soft delete)
     */
    const deleteApiPaymentsSubscriptionDelete = (
        deleteApiPaymentsSubscriptionDeleteBody: DeleteApiPaymentsSubscriptionDeleteBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiPaymentsSubscriptionDelete200>>,
    ) => {
        return customFetcher<DeleteApiPaymentsSubscriptionDelete200>(
            {
                url: `/api/payments/subscription/delete`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiPaymentsSubscriptionDeleteBody,
            },
            options,
        );
    };

    /**
     * Create a Frisbii checkout charge session. Outlet ID is taken from the Bearer token (JWT sub).
     */
    const postApiPaymentsSubscriptionCreate = (
        postApiPaymentsSubscriptionCreateBody: PostApiPaymentsSubscriptionCreateBody,
        options?: SecondParameter<typeof customFetcher<PostApiPaymentsSubscriptionCreate200>>,
    ) => {
        return customFetcher<PostApiPaymentsSubscriptionCreate200>(
            {
                url: `/api/payments/subscription/create`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiPaymentsSubscriptionCreateBody,
            },
            options,
        );
    };

    /**
     * Create a one-time Frisbii charge session for the outlet active FIIND_SUBSCRIPTION. No request body; outlet is taken from the Bearer token (JWT sub).
     */
    const postApiPaymentsSubscriptionRenewalOverdue = (
        options?: SecondParameter<typeof customFetcher<PostApiPaymentsSubscriptionRenewalOverdue200>>,
    ) => {
        return customFetcher<PostApiPaymentsSubscriptionRenewalOverdue200>(
            { url: `/api/payments/subscription/renewal-overdue`, method: 'POST' },
            options,
        );
    };

    /**
     * List Frisbii payment methods for the outlet. Outlet ID is taken from the Bearer token (JWT sub).
     */
    const getApiPaymentsCard = (options?: SecondParameter<typeof customFetcher<GetApiPaymentsCard200>>) => {
        return customFetcher<GetApiPaymentsCard200>({ url: `/api/payments/card`, method: 'GET' }, options);
    };

    /**
     * Create a Frisbii recurring checkout session to add a payment method. Outlet ID is taken from the Bearer token (JWT sub).
     */
    const postApiPaymentsCard = (options?: SecondParameter<typeof customFetcher<PostApiPaymentsCard200>>) => {
        return customFetcher<PostApiPaymentsCard200>({ url: `/api/payments/card`, method: 'POST' }, options);
    };

    /**
     * Delete a Frisbii payment method/card by id. Outlet ID is taken from the Bearer token (JWT sub).
     */
    const deleteApiPaymentsCardId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiPaymentsCardId200>>,
    ) => {
        return customFetcher<DeleteApiPaymentsCardId200>(
            { url: `/api/payments/card/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Create a sale with full transaction, taxes, item and discount details
     */
    const postApiSale = (
        postApiSaleBody: PostApiSaleBody,
        options?: SecondParameter<typeof customFetcher<PostApiSale201>>,
    ) => {
        return customFetcher<PostApiSale201>(
            {
                url: `/api/sale`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiSaleBody,
            },
            options,
        );
    };

    /**
     * test cron
     */
    const getApiSaleId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiSaleId200>>) => {
        return customFetcher<GetApiSaleId200>({ url: `/api/sale/${id}`, method: 'GET' }, options);
    };

    /**
     * test cron
     */
    const getApiSalesList = (
        params?: GetApiSalesListParams,
        options?: SecondParameter<typeof customFetcher<GetApiSalesList200>>,
    ) => {
        return customFetcher<GetApiSalesList200>({ url: `/api/sales-list`, method: 'GET', params }, options);
    };

    /**
     * Get full sale details with related data
     */
    const getApiSalesDetailsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiSalesDetailsId200>>,
    ) => {
        return customFetcher<GetApiSalesDetailsId200>({ url: `/api/sales-details/${id}`, method: 'GET' }, options);
    };

    /**
     * Get previous sales with full item details for a customer
     */
    const getApiPreviousSalesItemsCustomerId = (
        customerId: number,
        params?: GetApiPreviousSalesItemsCustomerIdParams,
        options?: SecondParameter<typeof customFetcher<GetApiPreviousSalesItemsCustomerId200>>,
    ) => {
        return customFetcher<GetApiPreviousSalesItemsCustomerId200>(
            { url: `/api/previous-sales-items/${customerId}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get full sale details with related data
     */
    const getApiGetCustomerLedgerId = (
        id: number,
        options?: SecondParameter<typeof customFetcher<GetApiGetCustomerLedgerId200>>,
    ) => {
        return customFetcher<GetApiGetCustomerLedgerId200>(
            { url: `/api/get-customer-ledger/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * Get full sale details with related data
     */
    const getApiGetcreditsales = (options?: SecondParameter<typeof customFetcher<GetApiGetcreditsales200Item[]>>) => {
        return customFetcher<GetApiGetcreditsales200Item[]>({ url: `/api/getcreditsales`, method: 'GET' }, options);
    };

    /**
     * Send sales invoice via email with PDF attachment
     */
    const postApiSendSalesEmail = (
        postApiSendSalesEmailBody: PostApiSendSalesEmailBody,
        options?: SecondParameter<typeof customFetcher<PostApiSendSalesEmail200>>,
    ) => {
        return customFetcher<PostApiSendSalesEmail200>(
            {
                url: `/api/send-sales-email`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiSendSalesEmailBody,
            },
            options,
        );
    };

    /**
     * Soft-delete a sale (requires open cash drawer). Optional query: refundServiceConsumption=true restocks formula consumption.
     */
    const deleteApiSalesId = (
        id: string,
        params?: DeleteApiSalesIdParams,
        options?: SecondParameter<typeof customFetcher<DeleteApiSalesId200>>,
    ) => {
        return customFetcher<DeleteApiSalesId200>({ url: `/api/sales/${id}`, method: 'DELETE', params }, options);
    };

    /**
     * Send sales SMS
     */
    const putApiCreditSaleId = (
        id: string,
        putApiCreditSaleIdBody: PutApiCreditSaleIdBody,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            {
                url: `/api/credit-sale/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiCreditSaleIdBody,
            },
            options,
        );
    };

    /**
     * Edit a sale with full transaction, taxes, item and discount details
     */
    const putApiEditSalesId = (
        id: string,
        putApiEditSalesIdBody: PutApiEditSalesIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiEditSalesId200>>,
    ) => {
        return customFetcher<PutApiEditSalesId200>(
            {
                url: `/api/edit-sales/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiEditSalesIdBody,
            },
            options,
        );
    };

    /**
     * Print sales list
     */
    const getApiSalesListPrintType = (
        params?: GetApiSalesListPrintTypeParams,
        type: 'html' | 'pdf' | 'csv' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/sales-list-print/${type}`, method: 'GET', params }, options);
    };

    /**
     * Process card payment through IoT terminal
     */
    const postApiMakeCardPayment = (
        postApiMakeCardPaymentBody: PostApiMakeCardPaymentBody,
        options?: SecondParameter<typeof customFetcher<PostApiMakeCardPayment200>>,
    ) => {
        return customFetcher<PostApiMakeCardPayment200>(
            {
                url: `/api/make-card-payment`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiMakeCardPaymentBody,
            },
            options,
        );
    };

    /**
     * Abort a pending card payment through IoT terminal
     */
    const postApiAbortCardPayment = (
        postApiAbortCardPaymentBody: PostApiAbortCardPaymentBody,
        options?: SecondParameter<typeof customFetcher<PostApiAbortCardPayment200>>,
    ) => {
        return customFetcher<PostApiAbortCardPayment200>(
            {
                url: `/api/abort-card-payment`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiAbortCardPaymentBody,
            },
            options,
        );
    };

    /**
     * List Direct Webstore (marketplace) online payments
     */
    const getApiDirectWebstorePayments = (
        params?: GetApiDirectWebstorePaymentsParams,
        options?: SecondParameter<typeof customFetcher<GetApiDirectWebstorePayments200>>,
    ) => {
        return customFetcher<GetApiDirectWebstorePayments200>(
            { url: `/api/direct-webstore-payments`, method: 'GET', params },
            options,
        );
    };

    /**
     * Credit (refund) a direct webstore online payment via Bambora
     */
    const postApiDirectWebstorePaymentsTransactionIdCredit = (
        transactionId: string,
        postApiDirectWebstorePaymentsTransactionIdCreditBody: PostApiDirectWebstorePaymentsTransactionIdCreditBody,
        options?: SecondParameter<typeof customFetcher<PostApiDirectWebstorePaymentsTransactionIdCredit200>>,
    ) => {
        return customFetcher<PostApiDirectWebstorePaymentsTransactionIdCredit200>(
            {
                url: `/api/direct-webstore-payments/${transactionId}/credit`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDirectWebstorePaymentsTransactionIdCreditBody,
            },
            options,
        );
    };

    /**
     * Get latest terminal payment log by payment ID
     */
    const getApiTerminalPaymentLogPaymentId = (
        paymentId: string,
        options?: SecondParameter<typeof customFetcher<GetApiTerminalPaymentLogPaymentId200>>,
    ) => {
        return customFetcher<GetApiTerminalPaymentLogPaymentId200>(
            { url: `/api/terminal-payment-log/${paymentId}`, method: 'GET' },
            options,
        );
    };

    /**
     * Get invoice html or pdf by id
     */
    const getApiInvoiceIdType = (
        id: string,
        type: 'html' | 'pdf',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/invoice/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * Get invoice html or pdf by id
     */
    const getApiGiftcardInvoiceIdType = (
        id: string,
        type: 'html' | 'pdf',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/giftcard-invoice/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * create discount
     */
    const postApiDiscount = (
        postApiDiscountBody: PostApiDiscountBody,
        options?: SecondParameter<typeof customFetcher<PostApiDiscount201>>,
    ) => {
        return customFetcher<PostApiDiscount201>(
            {
                url: `/api/discount`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDiscountBody,
            },
            options,
        );
    };

    /**
     * update discount
     */
    const putApiDiscountId = (
        id: string,
        putApiDiscountIdBody: PutApiDiscountIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiDiscountId200>>,
    ) => {
        return customFetcher<PutApiDiscountId200>(
            {
                url: `/api/discount/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiDiscountIdBody,
            },
            options,
        );
    };

    /**
     * delete discount
     */
    const deleteApiDiscountId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiDiscountId200>>,
    ) => {
        return customFetcher<DeleteApiDiscountId200>({ url: `/api/discount/${id}`, method: 'DELETE' }, options);
    };

    /**
     * list discount
     */
    const getApiListDiscounts = (options?: SecondParameter<typeof customFetcher<GetApiListDiscounts200Item[]>>) => {
        return customFetcher<GetApiListDiscounts200Item[]>({ url: `/api/list-discounts`, method: 'GET' }, options);
    };

    /**
     * Create a booking discount code
     */
    const postApiBookingDiscount = (
        postApiBookingDiscountBody: PostApiBookingDiscountBody,
        options?: SecondParameter<typeof customFetcher<PostApiBookingDiscount201>>,
    ) => {
        return customFetcher<PostApiBookingDiscount201>(
            {
                url: `/api/booking-discount`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiBookingDiscountBody,
            },
            options,
        );
    };

    /**
     * Generate a discount code that is unique for the authenticated outlet (same code may exist on other outlets)
     */
    const getApiGenerateDiscountCode = (
        options?: SecondParameter<typeof customFetcher<GetApiGenerateDiscountCode200>>,
    ) => {
        return customFetcher<GetApiGenerateDiscountCode200>(
            { url: `/api/generate-discount-code`, method: 'GET' },
            options,
        );
    };

    /**
     * Check a booking discount code for the authenticated outlet. Pass groupBookingUuid on booking edit to grandfather expired codes and only recalc newly added lines.
     */
    const postApiCheckBookingDiscount = (
        postApiCheckBookingDiscountBody: PostApiCheckBookingDiscountBody,
        options?: SecondParameter<typeof customFetcher<PostApiCheckBookingDiscount200>>,
    ) => {
        return customFetcher<PostApiCheckBookingDiscount200>(
            {
                url: `/api/check-booking-discount`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCheckBookingDiscountBody,
            },
            options,
        );
    };

    /**
     * Get booking discount by ID
     */
    const getApiBookingDiscountId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiBookingDiscountId200>>,
    ) => {
        return customFetcher<GetApiBookingDiscountId200>(
            { url: `/api/booking-discount/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * Update a booking discount code
     */
    const putApiBookingDiscountId = (
        id: string,
        putApiBookingDiscountIdBody: PutApiBookingDiscountIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiBookingDiscountId200>>,
    ) => {
        return customFetcher<PutApiBookingDiscountId200>(
            {
                url: `/api/booking-discount/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiBookingDiscountIdBody,
            },
            options,
        );
    };

    /**
     * Soft delete a booking discount code
     */
    const deleteApiBookingDiscountId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiBookingDiscountId200>>,
    ) => {
        return customFetcher<DeleteApiBookingDiscountId200>(
            { url: `/api/booking-discount/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * List booking discounts for outlet with pagination and sorting
     */
    const getApiListBookingDiscounts = (
        params?: GetApiListBookingDiscountsParams,
        options?: SecondParameter<typeof customFetcher<GetApiListBookingDiscounts200>>,
    ) => {
        return customFetcher<GetApiListBookingDiscounts200>(
            { url: `/api/list-booking-discounts`, method: 'GET', params },
            options,
        );
    };

    /**
     * test cron
     */
    const postApiTax = (
        postApiTaxBody: PostApiTaxBody,
        options?: SecondParameter<typeof customFetcher<PostApiTax201>>,
    ) => {
        return customFetcher<PostApiTax201>(
            { url: `/api/tax`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: postApiTaxBody },
            options,
        );
    };

    /**
     * test cron
     */
    const getApiTax = (options?: SecondParameter<typeof customFetcher<GetApiTax200Item[]>>) => {
        return customFetcher<GetApiTax200Item[]>({ url: `/api/tax`, method: 'GET' }, options);
    };

    /**
     * for the creating new item tax
     */
    const postApiItemTax = (
        postApiItemTaxBody: PostApiItemTaxBody,
        options?: SecondParameter<typeof customFetcher<PostApiItemTax201>>,
    ) => {
        return customFetcher<PostApiItemTax201>(
            {
                url: `/api/item-tax`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiItemTaxBody,
            },
            options,
        );
    };

    /**
     * test cron
     */
    const getApiItemTax = (options?: SecondParameter<typeof customFetcher<GetApiItemTax200Item[]>>) => {
        return customFetcher<GetApiItemTax200Item[]>({ url: `/api/item-tax`, method: 'GET' }, options);
    };

    /**
     * Open a new cash drawer. If no previous cash drawer exists for the employee, openingCash is required. Otherwise, closing cash from previous session will be used as opening cash.
     */
    const postApiCashDrawerOpen = (
        postApiCashDrawerOpenBody: PostApiCashDrawerOpenBody,
        options?: SecondParameter<typeof customFetcher<PostApiCashDrawerOpen201>>,
    ) => {
        return customFetcher<PostApiCashDrawerOpen201>(
            {
                url: `/api/cash-drawer/open`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCashDrawerOpenBody,
            },
            options,
        );
    };

    /**
     * Get cash drawer summary by employee ID and date range. The fromDate is automatically determined from the last closed cash drawer's end date, or from the current open cash drawer's start date if no closed drawer exists. Also returns closed cash drawer history and vs-yesterday comparison for revenue, card payments, cash, and drawer difference.
     */
    const getApiCashDrawerEmployeeSummary = (
        params: GetApiCashDrawerEmployeeSummaryParams,
        options?: SecondParameter<typeof customFetcher<GetApiCashDrawerEmployeeSummary200>>,
    ) => {
        return customFetcher<GetApiCashDrawerEmployeeSummary200>(
            { url: `/api/cash-drawer/employee-summary`, method: 'GET', params },
            options,
        );
    };

    /**
     * Close the current cash drawer and create a new one with the closing cash as opening cash
     */
    const postApiCashDrawerClose = (
        postApiCashDrawerCloseBody: PostApiCashDrawerCloseBody,
        options?: SecondParameter<typeof customFetcher<PostApiCashDrawerClose200>>,
    ) => {
        return customFetcher<PostApiCashDrawerClose200>(
            {
                url: `/api/cash-drawer/close`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCashDrawerCloseBody,
            },
            options,
        );
    };

    /**
     * Get Dinero voucher payload for a closed cash drawer
     */
    const getApiCashDrawerCashDrawerIdDineroPayload = (
        cashDrawerId: string,
        options?: SecondParameter<typeof customFetcher<GetApiCashDrawerCashDrawerIdDineroPayload200>>,
    ) => {
        return customFetcher<GetApiCashDrawerCashDrawerIdDineroPayload200>(
            { url: `/api/cash-drawer/${cashDrawerId}/dinero-payload`, method: 'GET' },
            options,
        );
    };

    /**
     * Export bookings data to CSV format
     */
    const getApiBookingsExport = (
        params: GetApiBookingsExportParams,
        options?: SecondParameter<typeof customFetcher<unknown>>,
    ) => {
        return customFetcher<unknown>({ url: `/api/bookings/export`, method: 'GET', params }, options);
    };

    /**
     * Get all no-show bookings that require reminders based on outlet settings. This endpoint filters bookings by: 1) Status = NOSHOW, 2) Outlet settings with OnlineBooking.noShow.enable = true, 3) Date calculation (booking_datetime_start + reminder_days = today), 4) Payment status (not paid or partially paid)
     * @summary Retrieve no-show bookings for reminder processing
     */
    const getApiBookingsNoShowReminder = (
        options?: SecondParameter<typeof customFetcher<GetApiBookingsNoShowReminder200>>,
    ) => {
        return customFetcher<GetApiBookingsNoShowReminder200>(
            { url: `/api/bookings/no-show-reminder`, method: 'GET' },
            options,
        );
    };

    /**
     * Update a no-show booking to a regular booking
     */
    const patchApiBookingsNoShowId = (
        id: number,
        patchApiBookingsNoShowIdBody: PatchApiBookingsNoShowIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiBookingsNoShowId200>>,
    ) => {
        return customFetcher<PatchApiBookingsNoShowId200>(
            {
                url: `/api/bookings/no-show/${id}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiBookingsNoShowIdBody,
            },
            options,
        );
    };

    /**
     * Create a new expense
     */
    const postApiExpense = (
        postApiExpenseBody: PostApiExpenseBody,
        options?: SecondParameter<typeof customFetcher<PostApiExpense201>>,
    ) => {
        return customFetcher<PostApiExpense201>(
            {
                url: `/api/expense`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiExpenseBody,
            },
            options,
        );
    };

    /**
     * Get expense by ID
     */
    const getApiExpenseId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiExpenseId200>>) => {
        return customFetcher<GetApiExpenseId200>({ url: `/api/expense/${id}`, method: 'GET' }, options);
    };

    /**
     * Update an expense
     */
    const putApiExpenseId = (
        id: string,
        putApiExpenseIdBody: PutApiExpenseIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiExpenseId200>>,
    ) => {
        return customFetcher<PutApiExpenseId200>(
            {
                url: `/api/expense/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiExpenseIdBody,
            },
            options,
        );
    };

    /**
     * Delete an expense
     */
    const deleteApiExpenseId = (id: string, options?: SecondParameter<typeof customFetcher<DeleteApiExpenseId200>>) => {
        return customFetcher<DeleteApiExpenseId200>({ url: `/api/expense/${id}`, method: 'DELETE' }, options);
    };

    /**
     * List expenses with pagination and filtering
     */
    const getApiExpenses = (
        params?: GetApiExpensesParams,
        options?: SecondParameter<typeof customFetcher<GetApiExpenses200>>,
    ) => {
        return customFetcher<GetApiExpenses200>({ url: `/api/expenses`, method: 'GET', params }, options);
    };

    /**
     * List expense categories with pagination and filtering
     */
    const getApiExpenseCategories = (
        params?: GetApiExpenseCategoriesParams,
        options?: SecondParameter<typeof customFetcher<GetApiExpenseCategories200>>,
    ) => {
        return customFetcher<GetApiExpenseCategories200>(
            { url: `/api/expense-categories`, method: 'GET', params },
            options,
        );
    };

    /**
     * List advance journal formats with pagination. outletId optional (omit = all outlets). Excludes default templates (setup_name null). source=all|manual|automation. Optional keyword searches setup_name and setup_description. List omits format JSON; each item includes outletName.
     */
    const getApiAdvanceJournalFormats = (
        params?: GetApiAdvanceJournalFormatsParams,
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalFormats200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalFormats200>(
            { url: `/api/advance-journal/formats`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get one advance journal format by id (includes format JSON + outlet name).
     */
    const getApiAdvanceJournalFormatsId = (
        id: number,
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalFormatsId200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalFormatsId200>(
            { url: `/api/advance-journal/formats/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * List global AI providers (API key omitted). Optional filters: provider, model, isActive.
     */
    const getApiAdvanceJournalProviders = (
        params?: GetApiAdvanceJournalProvidersParams,
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalProviders200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalProviders200>(
            { url: `/api/advance-journal/providers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Create global AI provider. Body: provider (openai|anthropic|claude), apiKey, model, optional isActive. Jobs route by provider name; keys starting with sk-ant- always use Anthropic.
     */
    const postApiAdvanceJournalProviders = (
        postApiAdvanceJournalProvidersBody: PostApiAdvanceJournalProvidersBody,
        options?: SecondParameter<typeof customFetcher<PostApiAdvanceJournalProviders201>>,
    ) => {
        return customFetcher<PostApiAdvanceJournalProviders201>(
            {
                url: `/api/advance-journal/providers`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiAdvanceJournalProvidersBody,
            },
            options,
        );
    };

    /**
     * Get one AI provider by id
     */
    const getApiAdvanceJournalProvidersId = (
        id: number,
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalProvidersId200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalProvidersId200>(
            { url: `/api/advance-journal/providers/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * List providers/models already configured in the database (no hardcoded catalog)
     */
    const getApiAdvanceJournalModels = (
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalModels200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalModels200>(
            { url: `/api/advance-journal/models`, method: 'GET' },
            options,
        );
    };

    /**
     * Create async AI job (multipart/form-data). Returns a pending job id immediately; poll GET /advance-journal/jobs/{id} until status is completed or failed.
     */
    const postApiAdvanceJournalJobs = (
        postApiAdvanceJournalJobsBody: PostApiAdvanceJournalJobsBody,
        options?: SecondParameter<typeof customFetcher<PostApiAdvanceJournalJobs201>>,
    ) => {
        const formData = new FormData();
        formData.append(`outletId`, postApiAdvanceJournalJobsBody.outletId.toString());
        if (postApiAdvanceJournalJobsBody.prompt !== undefined) {
            formData.append(`prompt`, postApiAdvanceJournalJobsBody.prompt);
        }
        if (postApiAdvanceJournalJobsBody.remarks !== undefined) {
            formData.append(`remarks`, postApiAdvanceJournalJobsBody.remarks);
        }
        if (postApiAdvanceJournalJobsBody.autoAdjust !== undefined) {
            formData.append(`autoAdjust`, postApiAdvanceJournalJobsBody.autoAdjust.toString());
        }
        if (postApiAdvanceJournalJobsBody.providerId !== undefined) {
            formData.append(`providerId`, postApiAdvanceJournalJobsBody.providerId.toString());
        }
        if (postApiAdvanceJournalJobsBody.files !== undefined) {
            postApiAdvanceJournalJobsBody.files.forEach((value) => formData.append(`files`, value));
        }

        return customFetcher<PostApiAdvanceJournalJobs201>(
            {
                url: `/api/advance-journal/jobs`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            },
            options,
        );
    };

    /**
     * Poll AI job by id until completed or failed. Returns id, outletId, outletName, status, remarks, errorMessage, autoAdjust, createdAt, outputFormat.
     */
    const getApiAdvanceJournalJobsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiAdvanceJournalJobsId200>>,
    ) => {
        return customFetcher<GetApiAdvanceJournalJobsId200>(
            { url: `/api/advance-journal/jobs/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * List customers with search functionality, outstanding amount calculation, and unused/partially used gift cards
     */
    const getApiCustomers = (
        params?: GetApiCustomersParams,
        options?: SecondParameter<typeof customFetcher<GetApiCustomers200>>,
    ) => {
        return customFetcher<GetApiCustomers200>({ url: `/api/customers`, method: 'GET', params }, options);
    };

    /**
     * Get complete customer details including outstanding amount and total turnover
     */
    const getApiCustomerId = (id: number, options?: SecondParameter<typeof customFetcher<GetApiCustomerId200>>) => {
        return customFetcher<GetApiCustomerId200>({ url: `/api/customer/${id}`, method: 'GET' }, options);
    };

    /**
     * Get customer sales overview with period aggregates and sales by type
     */
    const getApiCustomerIdSalesOverview = (
        id: number,
        options?: SecondParameter<typeof customFetcher<GetApiCustomerIdSalesOverview200>>,
    ) => {
        return customFetcher<GetApiCustomerIdSalesOverview200>(
            { url: `/api/customer/${id}/sales-overview`, method: 'GET' },
            options,
        );
    };

    /**
     * Get customer by ID and type
     */
    const getApiCustomerIdType = (
        id: number,
        type: 'giftcard' | 'punchcard' | 'productsale' | 'salelist',
        options?: SecondParameter<typeof customFetcher<GetApiCustomerIdType200>>,
    ) => {
        return customFetcher<GetApiCustomerIdType200>({ url: `/api/customer/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * Export all customers to CSV (excludes deleted customers, filtered by outlet)
     */
    const getApiCustomersExport = (options?: SecondParameter<typeof customFetcher<string>>) => {
        return customFetcher<string>({ url: `/api/customers/export`, method: 'GET' }, options);
    };

    /**
     * Lightweight global search for customers (name/email/phone) and bookings (customer name or service name). Outlet-scoped. Requires q with at least 2 characters for results.
     */
    const getApiGlobalSearch = (
        params: GetApiGlobalSearchParams,
        options?: SecondParameter<typeof customFetcher<GetApiGlobalSearch200>>,
    ) => {
        return customFetcher<GetApiGlobalSearch200>({ url: `/api/global-search`, method: 'GET', params }, options);
    };

    /**
     * Create a new customer group
     */
    const postApiCustomerGroups = (
        postApiCustomerGroupsBody: PostApiCustomerGroupsBody,
        options?: SecondParameter<typeof customFetcher<PostApiCustomerGroups201>>,
    ) => {
        return customFetcher<PostApiCustomerGroups201>(
            {
                url: `/api/customer-groups`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCustomerGroupsBody,
            },
            options,
        );
    };

    /**
     * List all customer groups for an outlet (includes global suggestions with outletId: null)
     */
    const getApiCustomerGroups = (
        params?: GetApiCustomerGroupsParams,
        options?: SecondParameter<typeof customFetcher<GetApiCustomerGroups200>>,
    ) => {
        return customFetcher<GetApiCustomerGroups200>({ url: `/api/customer-groups`, method: 'GET', params }, options);
    };

    /**
     * Update an existing customer group
     */
    const putApiCustomerGroupsId = (
        id: string,
        putApiCustomerGroupsIdBody: PutApiCustomerGroupsIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiCustomerGroupsId200>>,
    ) => {
        return customFetcher<PutApiCustomerGroupsId200>(
            {
                url: `/api/customer-groups/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiCustomerGroupsIdBody,
            },
            options,
        );
    };

    /**
     * Get a customer group by ID with its members
     */
    const getApiCustomerGroupsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiCustomerGroupsId200>>,
    ) => {
        return customFetcher<GetApiCustomerGroupsId200>({ url: `/api/customer-groups/${id}`, method: 'GET' }, options);
    };

    /**
     * Delete a customer group (soft delete)
     */
    const deleteApiCustomerGroupsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiCustomerGroupsId200>>,
    ) => {
        return customFetcher<DeleteApiCustomerGroupsId200>(
            { url: `/api/customer-groups/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Add customers to a customer group
     */
    const postApiCustomerGroupsIdCustomers = (
        id: string,
        postApiCustomerGroupsIdCustomersBody: PostApiCustomerGroupsIdCustomersBody,
        options?: SecondParameter<typeof customFetcher<PostApiCustomerGroupsIdCustomers200>>,
    ) => {
        return customFetcher<PostApiCustomerGroupsIdCustomers200>(
            {
                url: `/api/customer-groups/${id}/customers`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCustomerGroupsIdCustomersBody,
            },
            options,
        );
    };

    /**
     * Remove customers from a customer group
     */
    const deleteApiCustomerGroupsIdCustomers = (
        id: string,
        deleteApiCustomerGroupsIdCustomersBody: DeleteApiCustomerGroupsIdCustomersBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiCustomerGroupsIdCustomers200>>,
    ) => {
        return customFetcher<DeleteApiCustomerGroupsIdCustomers200>(
            {
                url: `/api/customer-groups/${id}/customers`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiCustomerGroupsIdCustomersBody,
            },
            options,
        );
    };

    /**
     * Get all members of a customer group
     */
    const getApiCustomerGroupsIdMembers = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiCustomerGroupsIdMembers200Item[]>>,
    ) => {
        return customFetcher<GetApiCustomerGroupsIdMembers200Item[]>(
            { url: `/api/customer-groups/${id}/members`, method: 'GET' },
            options,
        );
    };

    /**
     * Get all customer groups that a customer belongs to
     */
    const getApiCustomersCustomerIdGroups = (
        customerId: number,
        options?: SecondParameter<typeof customFetcher<GetApiCustomersCustomerIdGroups200Item[]>>,
    ) => {
        return customFetcher<GetApiCustomersCustomerIdGroups200Item[]>(
            { url: `/api/customers/${customerId}/groups`, method: 'GET' },
            options,
        );
    };

    /**
     * Create a new gift card with amount and optional recipient name, personal message, and custom gift card code ❌ Do not use it directly. It will be used in the sales
     * @summary Create a new gift card ❌
     */
    const postApiGiftCards = (
        postApiGiftCardsBody: PostApiGiftCardsBody,
        options?: SecondParameter<typeof customFetcher<PostApiGiftCards201>>,
    ) => {
        return customFetcher<PostApiGiftCards201>(
            {
                url: `/api/gift-cards`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGiftCardsBody,
            },
            options,
        );
    };

    /**
     * Get paginated list of gift cards with optional filters
     * @summary List gift cards
     */
    const getApiGiftCards = (
        params?: GetApiGiftCardsParams,
        options?: SecondParameter<typeof customFetcher<GetApiGiftCards200>>,
    ) => {
        return customFetcher<GetApiGiftCards200>({ url: `/api/gift-cards`, method: 'GET', params }, options);
    };

    /**
     * Retrieve a gift card by its unique ID
     * @summary Get gift card by ID
     */
    const getApiGiftCardsId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiGiftCardsId200>>) => {
        return customFetcher<GetApiGiftCardsId200>({ url: `/api/gift-cards/${id}`, method: 'GET' }, options);
    };

    /**
     * Update gift card fields including customerId, originalValue, residueValue, expiryDate, recipientName, note, and status
     * @summary Update gift card
     */
    const patchApiGiftCardsId = (
        id: string,
        patchApiGiftCardsIdBody: PatchApiGiftCardsIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiGiftCardsId200>>,
    ) => {
        return customFetcher<PatchApiGiftCardsId200>(
            {
                url: `/api/gift-cards/${id}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiGiftCardsIdBody,
            },
            options,
        );
    };

    /**
     * Soft delete a gift card. Only unused gift cards can be deleted.
     * @summary Delete gift card
     */
    const deleteApiGiftCardsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiGiftCardsId200>>,
    ) => {
        return customFetcher<DeleteApiGiftCardsId200>({ url: `/api/gift-cards/${id}`, method: 'DELETE' }, options);
    };

    /**
     * Retrieve a gift card by its code
     * @summary Get gift card by code
     */
    const getApiGiftCardsCodeCode = (
        code: string,
        options?: SecondParameter<typeof customFetcher<GetApiGiftCardsCodeCode200>>,
    ) => {
        return customFetcher<GetApiGiftCardsCodeCode200>(
            { url: `/api/gift-cards/code/${code}`, method: 'GET' },
            options,
        );
    };

    /**
     * Retrieve gift card settings for the current outlet
     * @summary Get gift card settings
     */
    const getApiGiftCardsSettings = (options?: SecondParameter<typeof customFetcher<GetApiGiftCardsSettings200>>) => {
        return customFetcher<GetApiGiftCardsSettings200>({ url: `/api/gift-cards/settings`, method: 'GET' }, options);
    };

    /**
     * Update gift card settings including tax, expiry months, design settings, colors, and predefined amounts
     * @summary Update gift card settings
     */
    const putApiGiftCardsSettings = (
        putApiGiftCardsSettingsBody: PutApiGiftCardsSettingsBody,
        options?: SecondParameter<typeof customFetcher<PutApiGiftCardsSettings200>>,
    ) => {
        return customFetcher<PutApiGiftCardsSettings200>(
            {
                url: `/api/gift-cards/settings`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiGiftCardsSettingsBody,
            },
            options,
        );
    };

    /**
     * Update the status of a gift card (BLOCKED, EXPIRED, USED, UNUSED, PARTIALLY_USED)
     * @summary Update gift card status
     */
    const patchApiGiftCardsIdStatus = (
        id: string,
        patchApiGiftCardsIdStatusBody: PatchApiGiftCardsIdStatusBody,
        options?: SecondParameter<typeof customFetcher<PatchApiGiftCardsIdStatus200>>,
    ) => {
        return customFetcher<PatchApiGiftCardsIdStatus200>(
            {
                url: `/api/gift-cards/${id}/status`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiGiftCardsIdStatusBody,
            },
            options,
        );
    };

    /**
     * Use a gift card by deducting an amount from its balance ❌ Do not use it directly. It will be used in the sales
     * @summary Use gift card ❌
     */
    const postApiGiftCardsIdUse = (
        id: string,
        postApiGiftCardsIdUseBody: PostApiGiftCardsIdUseBody,
        options?: SecondParameter<typeof customFetcher<PostApiGiftCardsIdUse200>>,
    ) => {
        return customFetcher<PostApiGiftCardsIdUse200>(
            {
                url: `/api/gift-cards/${id}/use`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGiftCardsIdUseBody,
            },
            options,
        );
    };

    /**
     * Send a gift card PDF to the customer email address
     * @summary Send gift card by email
     */
    const postApiGiftCardsSendEmail = (
        postApiGiftCardsSendEmailBody: PostApiGiftCardsSendEmailBody,
        options?: SecondParameter<typeof customFetcher<PostApiGiftCardsSendEmail200>>,
    ) => {
        return customFetcher<PostApiGiftCardsSendEmail200>(
            {
                url: `/api/gift-cards/send-email`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGiftCardsSendEmailBody,
            },
            options,
        );
    };

    /**
     * Get gifcards list for print
     */
    const getApiGiftCardsListType = (
        params?: GetApiGiftCardsListTypeParams,
        type: 'html' | 'pdf' | 'csv' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/gift-cards-list/${type}`, method: 'GET', params }, options);
    };

    /**
     * Create a new online gift card template that can be purchased by customers
     * @summary Create online gift card template
     */
    const postApiGiftCardsOnline = (
        postApiGiftCardsOnlineBody: PostApiGiftCardsOnlineBody,
        options?: SecondParameter<typeof customFetcher<PostApiGiftCardsOnline201>>,
    ) => {
        return customFetcher<PostApiGiftCardsOnline201>(
            {
                url: `/api/gift-cards/online`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGiftCardsOnlineBody,
            },
            options,
        );
    };

    /**
     * Get a single online gift card template by ID or list all templates with optional filters
     * @summary Get online gift card template(s)
     */
    const getApiGiftCardsOnlineType = (
        type: 'csv' | 'json' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiGiftCardsOnlineType200>>,
    ) => {
        return customFetcher<GetApiGiftCardsOnlineType200>(
            { url: `/api/gift-cards/online/${type}`, method: 'GET' },
            options,
        );
    };

    /**
     * Retrieve an online gift card template by its unique ID
     * @summary Get online gift card template by ID
     */
    const getApiGiftCardOnlineId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiGiftCardOnlineId200>>,
    ) => {
        return customFetcher<GetApiGiftCardOnlineId200>({ url: `/api/gift-card/online/${id}`, method: 'GET' }, options);
    };

    /**
     * Update an online gift card template
     * @summary Update online gift card template
     */
    const putApiGiftCardsOnlineId = (
        id: string,
        putApiGiftCardsOnlineIdBody: PutApiGiftCardsOnlineIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiGiftCardsOnlineId200>>,
    ) => {
        return customFetcher<PutApiGiftCardsOnlineId200>(
            {
                url: `/api/gift-cards/online/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiGiftCardsOnlineIdBody,
            },
            options,
        );
    };

    /**
     * Soft delete an online gift card template
     * @summary Delete online gift card template
     */
    const deleteApiGiftCardsOnlineId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiGiftCardsOnlineId200>>,
    ) => {
        return customFetcher<DeleteApiGiftCardsOnlineId200>(
            { url: `/api/gift-cards/online/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Create a new bundle offer with name, description, services, and other details
     * @summary Create a new bundle offer
     */
    const postApiBundleOffers = (
        postApiBundleOffersBody: PostApiBundleOffersBody,
        options?: SecondParameter<typeof customFetcher<PostApiBundleOffers201>>,
    ) => {
        return customFetcher<PostApiBundleOffers201>(
            {
                url: `/api/bundle-offers`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiBundleOffersBody,
            },
            options,
        );
    };

    /**
     * Get paginated list of bundle offers with optional filters
     * @summary List bundle offers
     */
    const getApiBundleOffers = (
        params?: GetApiBundleOffersParams,
        options?: SecondParameter<typeof customFetcher<GetApiBundleOffers200>>,
    ) => {
        return customFetcher<GetApiBundleOffers200>({ url: `/api/bundle-offers`, method: 'GET', params }, options);
    };

    /**
     * Retrieve a bundle offer by its unique ID
     * @summary Get bundle offer by ID
     */
    const getApiBundleOffersId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiBundleOffersId200>>,
    ) => {
        return customFetcher<GetApiBundleOffersId200>({ url: `/api/bundle-offers/${id}`, method: 'GET' }, options);
    };

    /**
     * Update an existing bundle offer with new information
     * @summary Update bundle offer
     */
    const putApiBundleOffersId = (
        id: string,
        putApiBundleOffersIdBody: PutApiBundleOffersIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiBundleOffersId200>>,
    ) => {
        return customFetcher<PutApiBundleOffersId200>(
            {
                url: `/api/bundle-offers/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiBundleOffersIdBody,
            },
            options,
        );
    };

    /**
     * Delete a bundle offer by its ID
     * @summary Delete bundle offer
     */
    const deleteApiBundleOffersId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiBundleOffersId200>>,
    ) => {
        return customFetcher<DeleteApiBundleOffersId200>(
            { url: `/api/bundle-offers/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Get all sold instances of a specific bundle offer
     * @summary Get sold bundle offers
     */
    const getApiBundleOffersSoldIdType = (
        id: string,
        params?: GetApiBundleOffersSoldIdTypeParams,
        type: 'csv' | 'json' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiBundleOffersSoldIdType200Item[]>>,
    ) => {
        return customFetcher<GetApiBundleOffersSoldIdType200Item[]>(
            { url: `/api/bundle-offers/sold/${id}/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Send a punch card PDF to the customer email address
     * @summary Send sold bundle offer (punch card) by email
     */
    const postApiSoldBundleOffersSendEmail = (
        postApiSoldBundleOffersSendEmailBody: PostApiSoldBundleOffersSendEmailBody,
        options?: SecondParameter<typeof customFetcher<PostApiSoldBundleOffersSendEmail200>>,
    ) => {
        return customFetcher<PostApiSoldBundleOffersSendEmail200>(
            {
                url: `/api/sold-bundle-offers/send-email`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiSoldBundleOffersSendEmailBody,
            },
            options,
        );
    };

    /**
     * Get usage history of a specific sold bundle offer
     * @summary Get sold bundle offer usage history
     */
    const getApiSoldBundleOffersIdHistory = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiSoldBundleOffersIdHistory200Item[]>>,
    ) => {
        return customFetcher<GetApiSoldBundleOffersIdHistory200Item[]>(
            { url: `/api/sold-bundle-offers/${id}/history`, method: 'GET' },
            options,
        );
    };

    /**
     * Retrieve bundle offer details using the bundle offer code
     * @summary Get bundle offer by code
     */
    const getApiBundleOffersCodeBundleOfferCode = (
        bundleOfferCode: string,
        options?: SecondParameter<typeof customFetcher<GetApiBundleOffersCodeBundleOfferCode200>>,
    ) => {
        return customFetcher<GetApiBundleOffersCodeBundleOfferCode200>(
            { url: `/api/bundle-offers/code/${bundleOfferCode}`, method: 'GET' },
            options,
        );
    };

    /**
     * Update the status of a sold bundle offer
     * @summary Update bundle offer status
     */
    const patchApiBundleOffersIdStatus = (
        id: string,
        patchApiBundleOffersIdStatusBody: PatchApiBundleOffersIdStatusBody,
        options?: SecondParameter<typeof customFetcher<PatchApiBundleOffersIdStatus200>>,
    ) => {
        return customFetcher<PatchApiBundleOffersIdStatus200>(
            {
                url: `/api/bundle-offers/${id}/status`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiBundleOffersIdStatusBody,
            },
            options,
        );
    };

    /**
     * Update specific fields of a sold bundle offer
     * @summary Update sold bundle offer
     */
    const patchApiSoldBundleOffersId = (
        id: string,
        patchApiSoldBundleOffersIdBody: PatchApiSoldBundleOffersIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiSoldBundleOffersId200>>,
    ) => {
        return customFetcher<PatchApiSoldBundleOffersId200>(
            {
                url: `/api/sold-bundle-offers/${id}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiSoldBundleOffersIdBody,
            },
            options,
        );
    };

    /**
     * Retrieve bundle offer settings for the current outlet
     * @summary Get bundle offer settings
     */
    const getApiBundleOffersSettings = (
        options?: SecondParameter<typeof customFetcher<GetApiBundleOffersSettings200>>,
    ) => {
        return customFetcher<GetApiBundleOffersSettings200>(
            { url: `/api/bundle-offers/settings`, method: 'GET' },
            options,
        );
    };

    /**
     * Update bundle offer settings for the current outlet
     * @summary Update bundle offer settings
     */
    const putApiBundleOffersSettings = (
        putApiBundleOffersSettingsBody: PutApiBundleOffersSettingsBody,
        options?: SecondParameter<typeof customFetcher<PutApiBundleOffersSettings200>>,
    ) => {
        return customFetcher<PutApiBundleOffersSettings200>(
            {
                url: `/api/bundle-offers/settings`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiBundleOffersSettingsBody,
            },
            options,
        );
    };

    /**
     * Use a bundle offer by consuming services and updating residue
     * @summary Use bundle offer ❌
     */
    const postApiBundleOffersUse = (
        postApiBundleOffersUseBody: PostApiBundleOffersUseBody,
        options?: SecondParameter<typeof customFetcher<PostApiBundleOffersUse200>>,
    ) => {
        return customFetcher<PostApiBundleOffersUse200>(
            {
                url: `/api/bundle-offers/use`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiBundleOffersUseBody,
            },
            options,
        );
    };

    /**
     * To get service list id & name
     */
    const getApiBundleOfferServiceList = (
        options?: SecondParameter<typeof customFetcher<GetApiBundleOfferServiceList200Item[]>>,
    ) => {
        return customFetcher<GetApiBundleOfferServiceList200Item[]>(
            { url: `/api/bundleOffer/service-list`, method: 'GET' },
            options,
        );
    };

    /**
     * Export services data to CSV format
     */
    const getApiServicesExport = (options?: SecondParameter<typeof customFetcher<string>>) => {
        return customFetcher<string>({ url: `/api/services/export`, method: 'GET' }, options);
    };

    /**
     * Get services grouped by service groups with limited fields
     */
    const getApiServicesDeposit = (options?: SecondParameter<typeof customFetcher<GetApiServicesDeposit200>>) => {
        return customFetcher<GetApiServicesDeposit200>({ url: `/api/services/deposit`, method: 'GET' }, options);
    };

    /**
     * Update service deposits. Only updates services where isSpecial=false and isCancellationOffer=false
     */
    const patchApiServicesDeposit = (
        patchApiServicesDepositBody: PatchApiServicesDepositBody,
        options?: SecondParameter<typeof customFetcher<PatchApiServicesDeposit200>>,
    ) => {
        return customFetcher<PatchApiServicesDeposit200>(
            {
                url: `/api/services/deposit`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiServicesDepositBody,
            },
            options,
        );
    };

    /**
     * Get driving fees for a service group by service group ID
     */
    const getApiServiceGroupsIdDrivingFees = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiServiceGroupsIdDrivingFees200>>,
    ) => {
        return customFetcher<GetApiServiceGroupsIdDrivingFees200>(
            { url: `/api/service-groups/${id}/driving-fees`, method: 'GET' },
            options,
        );
    };

    /**
     * Update driving fees for a service group by service group ID
     */
    const patchApiServiceGroupsIdDrivingFees = (
        id: string,
        patchApiServiceGroupsIdDrivingFeesBody: PatchApiServiceGroupsIdDrivingFeesBody,
        options?: SecondParameter<typeof customFetcher<PatchApiServiceGroupsIdDrivingFees200>>,
    ) => {
        return customFetcher<PatchApiServiceGroupsIdDrivingFees200>(
            {
                url: `/api/service-groups/${id}/driving-fees`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiServiceGroupsIdDrivingFeesBody,
            },
            options,
        );
    };

    /**
     * Sync a service across all outlets with the same phone number. If service is deleted (or syncService is disabled on the source service), it will be deleted in other outlets too. Services are tracked by services.sync_id.
     */
    const postApiServicesSync = (
        postApiServicesSyncBody: PostApiServicesSyncBody,
        options?: SecondParameter<typeof customFetcher<PostApiServicesSync200>>,
    ) => {
        return customFetcher<PostApiServicesSync200>(
            {
                url: `/api/services/sync`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiServicesSyncBody,
            },
            options,
        );
    };

    /**
     * Assign or remove employee to/from services. Uses push/pop logic: services in array are assigned, services not in array are removed.
     */
    const putApiServicesEmployeeAssignEmployeeId = (
        employeeId: string,
        putApiServicesEmployeeAssignEmployeeIdBody: PutApiServicesEmployeeAssignEmployeeIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiServicesEmployeeAssignEmployeeId200>>,
    ) => {
        return customFetcher<PutApiServicesEmployeeAssignEmployeeId200>(
            {
                url: `/api/services/employee-assign/${employeeId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiServicesEmployeeAssignEmployeeIdBody,
            },
            options,
        );
    };

    /**
     * List active formulas for a service. trackInventoryConsumption is on the response root; formula lines are in formulas.
     */
    const getApiServicesServiceIdFormulas = (
        serviceId: string,
        options?: SecondParameter<typeof customFetcher<GetApiServicesServiceIdFormulas200>>,
    ) => {
        return customFetcher<GetApiServicesServiceIdFormulas200>(
            { url: `/api/services/${serviceId}/formulas`, method: 'GET' },
            options,
        );
    };

    /**
     * Create multiple formulas for a single service. Unit is resolved from the product base unit in DB, or the global default (abbreviation Nos). Optional trackInventoryConsumption updates the parent service flag in the same request. Response has trackInventoryConsumption on the root and created rows in formulas.
     */
    const postApiServicesServiceIdFormulas = (
        serviceId: string,
        postApiServicesServiceIdFormulasBody: PostApiServicesServiceIdFormulasBody,
        options?: SecondParameter<typeof customFetcher<PostApiServicesServiceIdFormulas201>>,
    ) => {
        return customFetcher<PostApiServicesServiceIdFormulas201>(
            {
                url: `/api/services/${serviceId}/formulas`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiServicesServiceIdFormulasBody,
            },
            options,
        );
    };

    /**
     * Sync service formulas: update existing rows by formulaId, create rows when isNew is true, and soft-delete any existing formulas not included in the payload. Unit is resolved from the product base unit in DB, or the global default (abbreviation Nos). Optional trackInventoryConsumption updates the parent service flag in the same request. Response has trackInventoryConsumption on the root and all active formulas.
     */
    const putApiServicesServiceIdFormulas = (
        serviceId: string,
        putApiServicesServiceIdFormulasBody: PutApiServicesServiceIdFormulasBody,
        options?: SecondParameter<typeof customFetcher<PutApiServicesServiceIdFormulas200>>,
    ) => {
        return customFetcher<PutApiServicesServiceIdFormulas200>(
            {
                url: `/api/services/${serviceId}/formulas`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiServicesServiceIdFormulasBody,
            },
            options,
        );
    };

    /**
     * Get one service formula by ID
     */
    const getApiServicesServiceIdFormulasFormulaId = (
        serviceId: string,
        formulaId: string,
        options?: SecondParameter<typeof customFetcher<GetApiServicesServiceIdFormulasFormulaId200>>,
    ) => {
        return customFetcher<GetApiServicesServiceIdFormulasFormulaId200>(
            { url: `/api/services/${serviceId}/formulas/${formulaId}`, method: 'GET' },
            options,
        );
    };

    /**
     * Update one service formula. Unit is resolved from the product base unit in DB, or the global default (abbreviation Nos). Optional trackInventoryConsumption updates the parent service flag. Response includes trackInventoryConsumption.
     */
    const putApiServicesServiceIdFormulasFormulaId = (
        serviceId: string,
        formulaId: string,
        putApiServicesServiceIdFormulasFormulaIdBody: PutApiServicesServiceIdFormulasFormulaIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiServicesServiceIdFormulasFormulaId200>>,
    ) => {
        return customFetcher<PutApiServicesServiceIdFormulasFormulaId200>(
            {
                url: `/api/services/${serviceId}/formulas/${formulaId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiServicesServiceIdFormulasFormulaIdBody,
            },
            options,
        );
    };

    /**
     * Soft-delete one service formula
     */
    const deleteApiServicesServiceIdFormulasFormulaId = (
        serviceId: string,
        formulaId: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiServicesServiceIdFormulasFormulaId200>>,
    ) => {
        return customFetcher<DeleteApiServicesServiceIdFormulasFormulaId200>(
            { url: `/api/services/${serviceId}/formulas/${formulaId}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Get appointment statistics with pagination
     */
    const getApiStatisticsAppointments = (
        params?: GetApiStatisticsAppointmentsParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsAppointments200>>,
    ) => {
        return customFetcher<GetApiStatisticsAppointments200>(
            { url: `/api/statistics/appointments`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get service statistics for bar chart and list display
     */
    const getApiStatisticsServices = (
        params?: GetApiStatisticsServicesParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsServices200>>,
    ) => {
        return customFetcher<GetApiStatisticsServices200>(
            { url: `/api/statistics/services`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get grouped statistics by weekly, monthly, or yearly periods
     */
    const getApiStatisticsGrouped = (
        params: GetApiStatisticsGroupedParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsGrouped200>>,
    ) => {
        return customFetcher<GetApiStatisticsGrouped200>(
            { url: `/api/statistics/grouped`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get sales statistics grouped by daily, weekly, monthly, or yearly periods
     */
    const getApiStatisticsSales = (
        params: GetApiStatisticsSalesParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsSales200>>,
    ) => {
        return customFetcher<GetApiStatisticsSales200>(
            { url: `/api/statistics/sales`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get sales summary statistics including subtotal, tax, net total, and counts of services/products sold
     */
    const getApiStatisticsSalesSummary = (
        params: GetApiStatisticsSalesSummaryParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsSalesSummary200>>,
    ) => {
        return customFetcher<GetApiStatisticsSalesSummary200>(
            { url: `/api/statistics/sales-summary`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get bundle offer statistics including sales, usage, and value metrics
     */
    const getApiStatisticsBundleOffers = (
        params: GetApiStatisticsBundleOffersParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsBundleOffers200>>,
    ) => {
        return customFetcher<GetApiStatisticsBundleOffers200>(
            { url: `/api/statistics/bundle-offers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get discount code statistics including usage and revenue metrics
     */
    const getApiStatisticsDiscountCodes = (
        params: GetApiStatisticsDiscountCodesParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsDiscountCodes200>>,
    ) => {
        return customFetcher<GetApiStatisticsDiscountCodes200>(
            { url: `/api/statistics/discount-codes`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get appointment statistics grouped by time slots (24 hours) or week days
     */
    const getApiStatisticsAppointmentsByTime = (
        params: GetApiStatisticsAppointmentsByTimeParams,
        options?: SecondParameter<typeof customFetcher<GetApiStatisticsAppointmentsByTime200>>,
    ) => {
        return customFetcher<GetApiStatisticsAppointmentsByTime200>(
            { url: `/api/statistics/appointments-by-time`, method: 'GET', params },
            options,
        );
    };

    /**
     * Export appointment statistics to CSV
     */
    const getApiStatisticsExportAppointments = (
        params?: GetApiStatisticsExportAppointmentsParams,
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/statistics/export/appointments`, method: 'GET', params }, options);
    };

    /**
     * Export service statistics to CSV
     */
    const getApiStatisticsExportServices = (
        params?: GetApiStatisticsExportServicesParams,
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/statistics/export/services`, method: 'GET', params }, options);
    };

    /**
     * Export grouped statistics to CSV
     */
    const getApiStatisticsExportGrouped = (
        params: GetApiStatisticsExportGroupedParams,
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/statistics/export/grouped`, method: 'GET', params }, options);
    };

    /**
     * Export appointment by time statistics to CSV
     */
    const getApiStatisticsExportAppointmentsByTime = (
        params: GetApiStatisticsExportAppointmentsByTimeParams,
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>(
            { url: `/api/statistics/export/appointments-by-time`, method: 'GET', params },
            options,
        );
    };

    /**
     * Export discount code statistics to CSV
     */
    const getApiStatisticsExportDiscountCodes = (
        params: GetApiStatisticsExportDiscountCodesParams,
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/statistics/export/discount-codes`, method: 'GET', params }, options);
    };

    /**
     * Bookings analytics: performance, quick stats, trends, and breakdown charts
     */
    const getApiAnalyticsBookings = (
        params?: GetApiAnalyticsBookingsParams,
        options?: SecondParameter<typeof customFetcher<GetApiAnalyticsBookings200>>,
    ) => {
        return customFetcher<GetApiAnalyticsBookings200>(
            { url: `/api/analytics/bookings`, method: 'GET', params },
            options,
        );
    };

    /**
     * Earnings analytics: revenue overview, insights, trends, and treatment/category charts
     */
    const getApiAnalyticsEarnings = (
        params?: GetApiAnalyticsEarningsParams,
        options?: SecondParameter<typeof customFetcher<GetApiAnalyticsEarnings200>>,
    ) => {
        return customFetcher<GetApiAnalyticsEarnings200>(
            { url: `/api/analytics/earnings`, method: 'GET', params },
            options,
        );
    };

    /**
     * Customer analytics: customer base metrics, new customers per month chart, and top customers
     */
    const getApiAnalyticsCustomers = (
        params?: GetApiAnalyticsCustomersParams,
        options?: SecondParameter<typeof customFetcher<GetApiAnalyticsCustomers200>>,
    ) => {
        return customFetcher<GetApiAnalyticsCustomers200>(
            { url: `/api/analytics/customers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Ads performance overview across connected channels (Meta, Instagram, Google)
     */
    const getApiAnalyticsAdsPerformance = (
        params?: GetApiAnalyticsAdsPerformanceParams,
        options?: SecondParameter<typeof customFetcher<GetApiAnalyticsAdsPerformance200>>,
    ) => {
        return customFetcher<GetApiAnalyticsAdsPerformance200>(
            { url: `/api/analytics/ads-performance`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get sales insights
     */
    const getApiInsightsSalesType = (
        params?: GetApiInsightsSalesTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsSalesType200>>,
    ) => {
        return customFetcher<GetApiInsightsSalesType200>(
            { url: `/api/insights/sales/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get weekly turnover data with optional date filtering and chart grouping (daily/weekly/monthly/yearly). Supports both DD-MM-YYYY and YYYY-MM-DD date formats.
     */
    const getApiInsightsWeeklyTurnoverType = (
        params?: GetApiInsightsWeeklyTurnoverTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsWeeklyTurnoverType200>>,
    ) => {
        return customFetcher<GetApiInsightsWeeklyTurnoverType200>(
            { url: `/api/insights/weekly-turnover/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get product/service summary with sales data, quantities, and profit analysis
     */
    const getApiInsightsSummaryItemTypeType = (
        itemType: 'product' | 'service',
        params?: GetApiInsightsSummaryItemTypeTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsSummaryItemTypeType200>>,
    ) => {
        return customFetcher<GetApiInsightsSummaryItemTypeType200>(
            { url: `/api/insights/summary/${itemType}/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get detailed sales information for products or services
     */
    const getApiInsightsSalesDetailsItemTypeIdType = (
        itemType: 'product' | 'service',
        id: string,
        params?: GetApiInsightsSalesDetailsItemTypeIdTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsSalesDetailsItemTypeIdType200>>,
    ) => {
        return customFetcher<GetApiInsightsSalesDetailsItemTypeIdType200>(
            { url: `/api/insights/sales-details/${itemType}/${id}/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get employee-wise payment breakdown with all payment methods
     */
    const getApiInsightsEmployeePaymentsType = (
        params?: GetApiInsightsEmployeePaymentsTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsEmployeePaymentsType200>>,
    ) => {
        return customFetcher<GetApiInsightsEmployeePaymentsType200>(
            { url: `/api/insights/employee-payments/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get all sales by employee and payment type with sales ID, invoice ID, payment method, and net total
     */
    const getApiInsightsSalesEmployeeIdPaymentTypeType = (
        employeeId: string,
        paymentType:
            | 'cash'
            | 'card'
            | 'punchCard'
            | 'giftCard'
            | 'outstanding'
            | 'bankTransfer'
            | 'mobilePay'
            | 'receivable',
        params?: GetApiInsightsSalesEmployeeIdPaymentTypeTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsSalesEmployeeIdPaymentTypeType200>>,
    ) => {
        return customFetcher<GetApiInsightsSalesEmployeeIdPaymentTypeType200>(
            { url: `/api/insights/sales/${employeeId}/${paymentType}/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get stock reports with product inventory status, including stock levels, values, and summary statistics
     */
    const getApiInsightsStockReports = (
        params?: GetApiInsightsStockReportsParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsStockReports200>>,
    ) => {
        return customFetcher<GetApiInsightsStockReports200>(
            { url: `/api/insights/stock-reports`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get tax reports with filtering by tax type (tax/no tax) and detailed turnover analysis
     */
    const getApiInsightsTaxReportsType = (
        params?: GetApiInsightsTaxReportsTypeParams,
        type: 'json' | 'csv' = 'json',
        options?: SecondParameter<typeof customFetcher<GetApiInsightsTaxReportsType200>>,
    ) => {
        return customFetcher<GetApiInsightsTaxReportsType200>(
            { url: `/api/insights/tax-reports/${type}`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get list of customers with optional CSV export and status filtering
     */
    const getApiInsightsCustomers = (
        params?: GetApiInsightsCustomersParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsCustomers200>>,
    ) => {
        return customFetcher<GetApiInsightsCustomers200>(
            { url: `/api/insights/customers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get zip code statistics showing number of customers per zip code and city
     */
    const getApiInsightsZipcodeStatistics = (
        options?: SecondParameter<typeof customFetcher<GetApiInsightsZipcodeStatistics200>>,
    ) => {
        return customFetcher<GetApiInsightsZipcodeStatistics200>(
            { url: `/api/insights/zipcode-statistics`, method: 'GET' },
            options,
        );
    };

    /**
     * Get top 100 customers by revenue within a date range
     */
    const getApiInsightsTopCustomers = (
        params: GetApiInsightsTopCustomersParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsTopCustomers200>>,
    ) => {
        return customFetcher<GetApiInsightsTopCustomers200>(
            { url: `/api/insights/top-customers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get customer statistics grouped by employee within a date range. Optionally filter by specific employee.
     */
    const getApiInsightsCustomerStatistics = (
        params: GetApiInsightsCustomerStatisticsParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsCustomerStatistics200>>,
    ) => {
        return customFetcher<GetApiInsightsCustomerStatistics200>(
            { url: `/api/insights/customer-statistics`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get unique customer statistics and aggregated data within a date range. Optionally filter by specific employee.
     */
    const getApiInsightsUniqueCustomers = (
        params: GetApiInsightsUniqueCustomersParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsUniqueCustomers200>>,
    ) => {
        return customFetcher<GetApiInsightsUniqueCustomers200>(
            { url: `/api/insights/unique-customers`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get customer outstanding invoices with summary totals, overdue amounts over 30 days, and open invoice list
     */
    const getApiInsightsCustomerOutstanding = (
        options?: SecondParameter<typeof customFetcher<GetApiInsightsCustomerOutstanding200>>,
    ) => {
        return customFetcher<GetApiInsightsCustomerOutstanding200>(
            { url: `/api/insights/customer/outstanding`, method: 'GET' },
            options,
        );
    };

    /**
     * Get gift card insights with active card KPIs, total balance, expiring-soon count, and a list of active gift cards
     */
    const getApiInsightsGiftCards = (
        params?: GetApiInsightsGiftCardsParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsGiftCards200>>,
    ) => {
        return customFetcher<GetApiInsightsGiftCards200>(
            { url: `/api/insights/gift-cards`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get punch card insights with active card KPIs, remaining punches, expiring-soon count, and a list of active punch cards with services
     */
    const getApiInsightsPunchCards = (
        params?: GetApiInsightsPunchCardsParams,
        options?: SecondParameter<typeof customFetcher<GetApiInsightsPunchCards200>>,
    ) => {
        return customFetcher<GetApiInsightsPunchCards200>(
            { url: `/api/insights/punch-cards`, method: 'GET', params },
            options,
        );
    };

    /**
     * Create a new payment
     */
    const postApiMobilepayCreateMobilepayOrder = (
        postApiMobilepayCreateMobilepayOrderBody: PostApiMobilepayCreateMobilepayOrderBody,
        options?: SecondParameter<typeof customFetcher<PostApiMobilepayCreateMobilepayOrder201>>,
    ) => {
        return customFetcher<PostApiMobilepayCreateMobilepayOrder201>(
            {
                url: `/api/mobilepay/create-mobilepay-order`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiMobilepayCreateMobilepayOrderBody,
            },
            options,
        );
    };

    /**
     * Check payment status manually
     */
    const getApiMobilepayPaymentStatusReference = (
        reference: string,
        options?: SecondParameter<typeof customFetcher<GetApiMobilepayPaymentStatusReference200>>,
    ) => {
        return customFetcher<GetApiMobilepayPaymentStatusReference200>(
            { url: `/api/mobilepay/payment-status/${reference}`, method: 'GET' },
            options,
        );
    };

    /**
     * MobilePay webhook endpoint
     */
    const postApiMobilepayWebhook = (
        postApiMobilepayWebhookBody: PostApiMobilepayWebhookBody,
        options?: SecondParameter<typeof customFetcher<PostApiMobilepayWebhook200>>,
    ) => {
        return customFetcher<PostApiMobilepayWebhook200>(
            {
                url: `/api/mobilepay/webhook`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiMobilepayWebhookBody,
            },
            options,
        );
    };

    /**
     * Validate IoT token by outlet phone number, API key, and MAC address
     */
    const postApiIotValidateToken = (
        postApiIotValidateTokenBody: PostApiIotValidateTokenBody,
        options?: SecondParameter<typeof customFetcher<PostApiIotValidateToken200>>,
    ) => {
        return customFetcher<PostApiIotValidateToken200>(
            {
                url: `/api/iot/validate-token`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiIotValidateTokenBody,
            },
            options,
        );
    };

    /**
     * GatewayAPI webhook endpoint for campaign SMS status updates (delivery reports)
     */
    const postApiGatewayapiWebhook = (
        postApiGatewayapiWebhookBody: PostApiGatewayapiWebhookBody,
        options?: SecondParameter<typeof customFetcher<PostApiGatewayapiWebhook200>>,
    ) => {
        return customFetcher<PostApiGatewayapiWebhook200>(
            {
                url: `/api/gatewayapi/webhook`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGatewayapiWebhookBody,
            },
            options,
        );
    };

    /**
     * GatewayAPI webhook endpoint with campaign ID for SMS status updates (no JWT verification)
     */
    const postApiGatewayapiWebhookCampaignId = (
        campaignId: string,
        postApiGatewayapiWebhookCampaignIdBody: PostApiGatewayapiWebhookCampaignIdBody,
        options?: SecondParameter<typeof customFetcher<PostApiGatewayapiWebhookCampaignId200>>,
    ) => {
        return customFetcher<PostApiGatewayapiWebhookCampaignId200>(
            {
                url: `/api/gatewayapi/webhook/${campaignId}`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGatewayapiWebhookCampaignIdBody,
            },
            options,
        );
    };

    const getApiEmailUnsubscribe = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/email/unsubscribe`, method: 'GET' }, options);
    };

    const postApiEmailUnsubscribeConfirm = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/email/unsubscribe/confirm`, method: 'POST' }, options);
    };

    /**
     * Get Closed cash drawer and return printable summary (PDF/HTML)
     */
    const getApiCashDrawerIdType = (
        id: string,
        type: 'html' | 'pdf' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/cash-drawer/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * Get no show fee receipt printable summary (PDF/HTML)
     */
    const getApiNoShowIdType = (
        id: string,
        type: 'html' | 'pdf' = 'html',
        options?: SecondParameter<typeof customFetcher<string>>,
    ) => {
        return customFetcher<string>({ url: `/api/no-show/${id}/${type}`, method: 'GET' }, options);
    };

    /**
     * Get all bookings in a group by token. Token contains outlet ID, employee details, and group booking UUID
     * @summary Retrieve all bookings in a group
     */
    const getApiBooking = (
        params: GetApiBookingParams,
        options?: SecondParameter<typeof customFetcher<GetApiBooking200>>,
    ) => {
        return customFetcher<GetApiBooking200>({ url: `/api/booking`, method: 'GET', params }, options);
    };

    /**
     * Update status of all bookings in a group using JWT token. Token contains outlet ID, employee details, and group booking UUID
     * @summary ❌ Update status of all bookings in a group ❌ Do not use it instead use python endpoint
     */
    const patchApiBookingStatusUpdate = (
        patchApiBookingStatusUpdateBody: PatchApiBookingStatusUpdateBody,
        params: PatchApiBookingStatusUpdateParams,
        options?: SecondParameter<typeof customFetcher<PatchApiBookingStatusUpdate200>>,
    ) => {
        return customFetcher<PatchApiBookingStatusUpdate200>(
            {
                url: `/api/booking/statusUpdate`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiBookingStatusUpdateBody,
                params,
            },
            options,
        );
    };

    /**
     * Refresh Dinero access token using refresh token
     */
    const getApiDineroRefreshToken = (options?: SecondParameter<typeof customFetcher<GetApiDineroRefreshToken200>>) => {
        return customFetcher<GetApiDineroRefreshToken200>({ url: `/api/dinero/refresh-token`, method: 'GET' }, options);
    };

    /**
     * Get list of Dinero organizations for an outlet
     */
    const getApiDineroOrganizations = (
        options?: SecondParameter<typeof customFetcher<GetApiDineroOrganizations200>>,
    ) => {
        return customFetcher<GetApiDineroOrganizations200>(
            { url: `/api/dinero/organizations`, method: 'GET' },
            options,
        );
    };

    /**
     * Get list of Dinero account entries for an organization
     */
    const getApiDineroOrganizationsOrganizationIdAccounts = (
        organizationId: string,
        options?: SecondParameter<typeof customFetcher<GetApiDineroOrganizationsOrganizationIdAccounts200>>,
    ) => {
        return customFetcher<GetApiDineroOrganizationsOrganizationIdAccounts200>(
            { url: `/api/dinero/organizations/${organizationId}/accounts`, method: 'GET' },
            options,
        );
    };

    /**
     * Update Dinero configuration for an outlet
     */
    const putApiDineroConfig = (
        putApiDineroConfigBody: PutApiDineroConfigBody,
        options?: SecondParameter<typeof customFetcher<PutApiDineroConfig200>>,
    ) => {
        return customFetcher<PutApiDineroConfig200>(
            {
                url: `/api/dinero/config`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiDineroConfigBody,
            },
            options,
        );
    };

    const getApiDineroWebhook = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/dinero-webhook`, method: 'GET' }, options);
    };

    const postApiDineroWebhook = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/dinero-webhook`, method: 'POST' }, options);
    };

    /**
     * Get list of all addons for an outlet
     * @summary List addons
     */
    const getApiAddons = (options?: SecondParameter<typeof customFetcher<GetApiAddons200>>) => {
        return customFetcher<GetApiAddons200>({ url: `/api/addons`, method: 'GET' }, options);
    };

    /**
     * Delete a specific addon by addonId. If addonId is dinero (1), also deletes dinero tokens.
     * @summary Delete addon by addonId
     */
    const deleteApiAddonsAddonId = (
        addonId: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiAddonsAddonId200>>,
    ) => {
        return customFetcher<DeleteApiAddonsAddonId200>({ url: `/api/addons/${addonId}`, method: 'DELETE' }, options);
    };

    /**
     * Create or update addon configuration for an outlet by addon name. If addon already exists, it will be updated. If not, it will be created.
     * @summary Upsert addon by name
     */
    const postApiAddonsUpsert = (
        postApiAddonsUpsertBody: PostApiAddonsUpsertBody,
        options?: SecondParameter<typeof customFetcher<PostApiAddonsUpsert200>>,
    ) => {
        return customFetcher<PostApiAddonsUpsert200>(
            {
                url: `/api/addons/upsert`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiAddonsUpsertBody,
            },
            options,
        );
    };

    /**
     * Returns the full addon mapping object (addon id -> config).
     * @summary Get default addons
     */
    const getApiAddonsList = (options?: SecondParameter<typeof customFetcher<GetApiAddonsList200>>) => {
        return customFetcher<GetApiAddonsList200>({ url: `/api/addons-list`, method: 'GET' }, options);
    };

    /**
     * Generate CSV export for Billy accounting system with configurable chart of accounts mapping
     * @summary Export sales data to Billy accounting format
     */
    const getApiBillyExport = (
        params: GetApiBillyExportParams,
        options?: SecondParameter<typeof customFetcher<GetApiBillyExport200>>,
    ) => {
        return customFetcher<GetApiBillyExport200>({ url: `/api/billy/export`, method: 'GET', params }, options);
    };

    /**
     * Get list of IoT devices for an outlet
     */
    const getApiIotDevices = (
        params?: GetApiIotDevicesParams,
        options?: SecondParameter<typeof customFetcher<GetApiIotDevices200>>,
    ) => {
        return customFetcher<GetApiIotDevices200>({ url: `/api/iot/devices`, method: 'GET', params }, options);
    };

    /**
     * Create a new IoT device for an outlet
     */
    const postApiIotDevices = (
        postApiIotDevicesBody: PostApiIotDevicesBody,
        options?: SecondParameter<typeof customFetcher<PostApiIotDevices201>>,
    ) => {
        return customFetcher<PostApiIotDevices201>(
            {
                url: `/api/iot/devices`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiIotDevicesBody,
            },
            options,
        );
    };

    /**
     * Update an IoT device MAC address
     */
    const putApiIotDevicesDeviceId = (
        deviceId: string,
        putApiIotDevicesDeviceIdBody: PutApiIotDevicesDeviceIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiIotDevicesDeviceId200>>,
    ) => {
        return customFetcher<PutApiIotDevicesDeviceId200>(
            {
                url: `/api/iot/devices/${deviceId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiIotDevicesDeviceIdBody,
            },
            options,
        );
    };

    /**
     * Delete an IoT device
     */
    const deleteApiIotDevicesDeviceId = (
        deviceId: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiIotDevicesDeviceId200>>,
    ) => {
        return customFetcher<DeleteApiIotDevicesDeviceId200>(
            { url: `/api/iot/devices/${deviceId}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Get IoT connection status
     */
    const getApiIotConnectionStatus = (
        options?: SecondParameter<typeof customFetcher<GetApiIotConnectionStatus200>>,
    ) => {
        return customFetcher<GetApiIotConnectionStatus200>(
            { url: `/api/iot/connection-status`, method: 'GET' },
            options,
        );
    };

    /**
     * Get Google OAuth authorization URL
     */
    const getApiGoogleCalendarAuthUrl = (
        params?: GetApiGoogleCalendarAuthUrlParams,
        options?: SecondParameter<typeof customFetcher<GetApiGoogleCalendarAuthUrl200>>,
    ) => {
        return customFetcher<GetApiGoogleCalendarAuthUrl200>(
            { url: `/api/google-calendar/auth-url`, method: 'GET', params },
            options,
        );
    };

    /**
     * Handle Google OAuth callback
     */
    const getApiGoogleCalendarCallback = (
        params: GetApiGoogleCalendarCallbackParams,
        options?: SecondParameter<typeof customFetcher<GetApiGoogleCalendarCallback200>>,
    ) => {
        return customFetcher<GetApiGoogleCalendarCallback200>(
            { url: `/api/google-calendar/callback`, method: 'GET', params },
            options,
        );
    };

    /**
     * Disconnect Google Calendar. Optional body: { deleteSyncedOpeningHours?: boolean }. If true, deletes opening hours, holidays, and schedules from Google Calendar (API) then soft-deletes all google_calendar_sync records. If false or omitted (or no body): only soft-deletes all google_calendar_sync records (no Google API calls). No body is required.
     */
    const postApiGoogleCalendarDisconnect = (
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarDisconnect200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarDisconnect200>(
            { url: `/api/google-calendar/disconnect`, method: 'POST' },
            options,
        );
    };

    /**
     * Check Google Calendar connection status
     */
    const getApiGoogleCalendarStatus = (
        options?: SecondParameter<typeof customFetcher<GetApiGoogleCalendarStatus200>>,
    ) => {
        return customFetcher<GetApiGoogleCalendarStatus200>(
            { url: `/api/google-calendar/status`, method: 'GET' },
            options,
        );
    };

    /**
     * Sync a booking to Google Calendar and update booking_sync table
     */
    const postApiGoogleCalendarBookingSync = (
        postApiGoogleCalendarBookingSyncBody: PostApiGoogleCalendarBookingSyncBody,
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarBookingSync200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarBookingSync200>(
            {
                url: `/api/google-calendar/booking-sync`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGoogleCalendarBookingSyncBody,
            },
            options,
        );
    };

    /**
     * Sync all bookings in a group to Google Calendar and/or process service subscriptions using group booking UUID
     */
    const postApiGoogleCalendarBookingSyncByGroupUuid = (
        postApiGoogleCalendarBookingSyncByGroupUuidBody: PostApiGoogleCalendarBookingSyncByGroupUuidBody,
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarBookingSyncByGroupUuid200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarBookingSyncByGroupUuid200>(
            {
                url: `/api/google-calendar/booking-sync-by-group-uuid`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGoogleCalendarBookingSyncByGroupUuidBody,
            },
            options,
        );
    };

    /**
     * Get booking status by group booking UUID
     */
    const getApiGoogleCalendarBookingStatusByGroupUuid = (
        params: GetApiGoogleCalendarBookingStatusByGroupUuidParams,
        options?: SecondParameter<typeof customFetcher<GetApiGoogleCalendarBookingStatusByGroupUuid200>>,
    ) => {
        return customFetcher<GetApiGoogleCalendarBookingStatusByGroupUuid200>(
            { url: `/api/google-calendar/booking-status-by-group-uuid`, method: 'GET', params },
            options,
        );
    };

    /**
     * Sync outlet schedules (closed days / before-after hours) to Google Calendar for the current employee
     */
    const postApiGoogleCalendarSyncSchedule = (
        postApiGoogleCalendarSyncScheduleBody: PostApiGoogleCalendarSyncScheduleBody,
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarSyncSchedule200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarSyncSchedule200>(
            {
                url: `/api/google-calendar/sync-schedule`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGoogleCalendarSyncScheduleBody,
            },
            options,
        );
    };

    /**
     * Sync outlet holidays to Google Calendar for the current employee
     */
    const postApiGoogleCalendarSyncHolidays = (
        postApiGoogleCalendarSyncHolidaysBody: PostApiGoogleCalendarSyncHolidaysBody,
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarSyncHolidays200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarSyncHolidays200>(
            {
                url: `/api/google-calendar/sync-holidays`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiGoogleCalendarSyncHolidaysBody,
            },
            options,
        );
    };

    /**
     * Update Google Calendar settings (e.g. syncOpeningHours). When turning off, optionally remove schedule/holiday/opening-hours events from Google Calendar via deleteSyncedOpeningHours. When turning on, syncs holidays and schedules.
     */
    const patchApiGoogleCalendarSettings = (
        patchApiGoogleCalendarSettingsBody: PatchApiGoogleCalendarSettingsBody,
        options?: SecondParameter<typeof customFetcher<PatchApiGoogleCalendarSettings200>>,
    ) => {
        return customFetcher<PatchApiGoogleCalendarSettings200>(
            {
                url: `/api/google-calendar/settings`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiGoogleCalendarSettingsBody,
            },
            options,
        );
    };

    /**
     * Google Calendar webhook endpoint for receiving notifications
     */
    const getApiGoogleCalendarWebhook = (
        params?: GetApiGoogleCalendarWebhookParams,
        options?: SecondParameter<typeof customFetcher<GetApiGoogleCalendarWebhook200>>,
    ) => {
        return customFetcher<GetApiGoogleCalendarWebhook200>(
            { url: `/api/google-calendar/webhook`, method: 'GET', params },
            options,
        );
    };

    /**
     * Google Calendar webhook endpoint for receiving notifications
     */
    const postApiGoogleCalendarWebhook = (
        params?: PostApiGoogleCalendarWebhookParams,
        options?: SecondParameter<typeof customFetcher<PostApiGoogleCalendarWebhook200>>,
    ) => {
        return customFetcher<PostApiGoogleCalendarWebhook200>(
            { url: `/api/google-calendar/webhook`, method: 'POST', params },
            options,
        );
    };

    /**
     * Get Calendly OAuth authorization URL
     */
    const getApiCalendlyAuthUrl = (
        params?: GetApiCalendlyAuthUrlParams,
        options?: SecondParameter<typeof customFetcher<GetApiCalendlyAuthUrl200>>,
    ) => {
        return customFetcher<GetApiCalendlyAuthUrl200>(
            { url: `/api/calendly/auth-url`, method: 'GET', params },
            options,
        );
    };

    /**
     * Handle Calendly OAuth callback
     */
    const getApiCalendlyCallback = (
        params: GetApiCalendlyCallbackParams,
        options?: SecondParameter<typeof customFetcher<GetApiCalendlyCallback200>>,
    ) => {
        return customFetcher<GetApiCalendlyCallback200>(
            { url: `/api/calendly/callback`, method: 'GET', params },
            options,
        );
    };

    /**
     * Disconnect Calendly
     */
    const postApiCalendlyDisconnect = (
        options?: SecondParameter<typeof customFetcher<PostApiCalendlyDisconnect200>>,
    ) => {
        return customFetcher<PostApiCalendlyDisconnect200>(
            { url: `/api/calendly/disconnect`, method: 'POST' },
            options,
        );
    };

    /**
     * Check Calendly connection status
     */
    const getApiCalendlyStatus = (options?: SecondParameter<typeof customFetcher<GetApiCalendlyStatus200>>) => {
        return customFetcher<GetApiCalendlyStatus200>({ url: `/api/calendly/status`, method: 'GET' }, options);
    };

    /**
     * Delete all Calendly webhook subscriptions for the current outlet/employee. Does not disconnect OAuth.
     */
    const deleteApiCalendlyWebhookSubscriptions = (
        options?: SecondParameter<typeof customFetcher<DeleteApiCalendlyWebhookSubscriptions200>>,
    ) => {
        return customFetcher<DeleteApiCalendlyWebhookSubscriptions200>(
            { url: `/api/calendly/webhook-subscriptions`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Calendly webhook for invitee.created and invitee.canceled (verify X_CALDNLY_SIGNATURE when CALENDLY_WEBHOOK_SIGNING_KEY is set)
     */
    const postApiCalendlyWebhook = (
        postApiCalendlyWebhookBody: PostApiCalendlyWebhookBody,
        options?: SecondParameter<typeof customFetcher<PostApiCalendlyWebhook200>>,
    ) => {
        return customFetcher<PostApiCalendlyWebhook200>(
            {
                url: `/api/calendly/webhook`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCalendlyWebhookBody,
            },
            options,
        );
    };

    const postApiEconomicConnect = (
        postApiEconomicConnectBody: PostApiEconomicConnectBody,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            {
                url: `/api/economic/connect`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiEconomicConnectBody,
            },
            options,
        );
    };

    const postApiEconomicDisconnect = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/economic/disconnect`, method: 'POST' }, options);
    };

    const getApiEconomicConfig = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/economic/config`, method: 'GET' }, options);
    };

    const putApiEconomicConfig = (
        putApiEconomicConfigBody: PutApiEconomicConfigBody,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            {
                url: `/api/economic/config`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiEconomicConfigBody,
            },
            options,
        );
    };

    const getApiEconomicSetupData = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/economic/setup-data`, method: 'GET' }, options);
    };

    const postApiEconomicSyncSales = (
        postApiEconomicSyncSalesBody: PostApiEconomicSyncSalesBody,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            {
                url: `/api/economic/sync-sales`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiEconomicSyncSalesBody,
            },
            options,
        );
    };

    /**
     * Look up a person in the Danish CPR register by CPR number
     */
    const postApiCprLookup = (
        postApiCprLookupBody: PostApiCprLookupBody,
        options?: SecondParameter<typeof customFetcher<PostApiCprLookup200>>,
    ) => {
        return customFetcher<PostApiCprLookup200>(
            {
                url: `/api/cpr/lookup`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCprLookupBody,
            },
            options,
        );
    };

    /**
     * Submit an LPR access request; emailed to LPR_REQUEST_EMAIL. Does not require the LPR addon.
     */
    const postApiLprFormRequests = (
        postApiLprFormRequestsBody: PostApiLprFormRequestsBody,
        options?: SecondParameter<typeof customFetcher<PostApiLprFormRequests201>>,
    ) => {
        return customFetcher<PostApiLprFormRequests201>(
            {
                url: `/api/lpr/form-requests`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiLprFormRequestsBody,
            },
            options,
        );
    };

    /**
     * List the outlet LPR access requests
     */
    const getApiLprFormRequests = (options?: SecondParameter<typeof customFetcher<GetApiLprFormRequests200Item[]>>) => {
        return customFetcher<GetApiLprFormRequests200Item[]>({ url: `/api/lpr/form-requests`, method: 'GET' }, options);
    };

    /**
     * Get LPR settings for the outlet (null until saved)
     */
    const getApiLprSettings = (options?: SecondParameter<typeof customFetcher<GetApiLprSettings200>>) => {
        return customFetcher<GetApiLprSettings200>({ url: `/api/lpr/settings`, method: 'GET' }, options);
    };

    /**
     * Create or update LPR settings. Changing the reporting start date or automatic reporting re-aligns the report queue.
     */
    const putApiLprSettings = (
        putApiLprSettingsBody: PutApiLprSettingsBody,
        options?: SecondParameter<typeof customFetcher<PutApiLprSettings200>>,
    ) => {
        return customFetcher<PutApiLprSettings200>(
            {
                url: `/api/lpr/settings`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiLprSettingsBody,
            },
            options,
        );
    };

    /**
     * List treatment mappings. includeUnmapped=true returns every service with mapping or null.
     */
    const getApiLprTreatmentMappings = (
        params?: GetApiLprTreatmentMappingsParams,
        options?: SecondParameter<typeof customFetcher<GetApiLprTreatmentMappings200Item[]>>,
    ) => {
        return customFetcher<GetApiLprTreatmentMappings200Item[]>(
            { url: `/api/lpr/treatment-mappings`, method: 'GET', params },
            options,
        );
    };

    /**
     * Map one treatment (service) to SKS codes
     */
    const postApiLprTreatmentMappings = (
        postApiLprTreatmentMappingsBody: PostApiLprTreatmentMappingsBody,
        options?: SecondParameter<typeof customFetcher<PostApiLprTreatmentMappings200>>,
    ) => {
        return customFetcher<PostApiLprTreatmentMappings200>(
            {
                url: `/api/lpr/treatment-mappings`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiLprTreatmentMappingsBody,
            },
            options,
        );
    };

    /**
     * Bulk map treatments: { serviceIds, ...codes } applies the same codes to many services, { items: [{ serviceId, ...codes }] } sets codes per service. All-or-nothing.
     */
    const putApiLprTreatmentMappingsBulk = (
        putApiLprTreatmentMappingsBulkBody: PutApiLprTreatmentMappingsBulkBody,
        options?: SecondParameter<typeof customFetcher<PutApiLprTreatmentMappingsBulk200>>,
    ) => {
        return customFetcher<PutApiLprTreatmentMappingsBulk200>(
            {
                url: `/api/lpr/treatment-mappings/bulk`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiLprTreatmentMappingsBulkBody,
            },
            options,
        );
    };

    /**
     * Bulk soft delete treatment mappings
     */
    const deleteApiLprTreatmentMappingsBulk = (
        deleteApiLprTreatmentMappingsBulkBody: DeleteApiLprTreatmentMappingsBulkBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiLprTreatmentMappingsBulk200>>,
    ) => {
        return customFetcher<DeleteApiLprTreatmentMappingsBulk200>(
            {
                url: `/api/lpr/treatment-mappings/bulk`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiLprTreatmentMappingsBulkBody,
            },
            options,
        );
    };

    /**
     * Update a treatment mapping by id
     */
    const putApiLprTreatmentMappingsId = (
        id: string,
        putApiLprTreatmentMappingsIdBody: PutApiLprTreatmentMappingsIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiLprTreatmentMappingsId200>>,
    ) => {
        return customFetcher<PutApiLprTreatmentMappingsId200>(
            {
                url: `/api/lpr/treatment-mappings/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiLprTreatmentMappingsIdBody,
            },
            options,
        );
    };

    /**
     * Soft delete a treatment mapping by id
     */
    const deleteApiLprTreatmentMappingsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiLprTreatmentMappingsId200>>,
    ) => {
        return customFetcher<DeleteApiLprTreatmentMappingsId200>(
            { url: `/api/lpr/treatment-mappings/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Search currently valid SKS codes by code prefix or Danish text. Only the allowlisted codes (src/domain/lpr/data/sks-allowlist.ts) are synced. type=sks: diagnosis + procedure codes (recordTypes: ["dia"] or ["pro"] narrows); type=staff: personnel codes (AP...). Returns { items: [{ code, text, recordType, validFrom, validTo }], total, page, limit }.
     */
    const postApiLprSksCodesSearch = (
        postApiLprSksCodesSearchBody: PostApiLprSksCodesSearchBody,
        options?: SecondParameter<typeof customFetcher<PostApiLprSksCodesSearch200>>,
    ) => {
        return customFetcher<PostApiLprSksCodesSearch200>(
            {
                url: `/api/lpr/sks-codes/search`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiLprSksCodesSearchBody,
            },
            options,
        );
    };

    /**
     * Tab counts, automatic reporting flag and next automatic run time
     */
    const getApiLprReportsSummary = (options?: SecondParameter<typeof customFetcher<GetApiLprReportsSummary200>>) => {
        return customFetcher<GetApiLprReportsSummary200>({ url: `/api/lpr/reports/summary`, method: 'GET' }, options);
    };

    /**
     * List report rows for one tab (pending, queue, reported, errors, removed). With reportId, returns that report detail instead.
     */
    const getApiLprReports = (
        params?: GetApiLprReportsParams,
        options?: SecondParameter<typeof customFetcher<GetApiLprReports200>>,
    ) => {
        return customFetcher<GetApiLprReports200>({ url: `/api/lpr/reports`, method: 'GET', params }, options);
    };

    /**
     * Report all: send every Pending report in the background; they end in Reported or Errors
     */
    const postApiLprReportsSubmitAll = (
        options?: SecondParameter<typeof customFetcher<PostApiLprReportsSubmitAll202>>,
    ) => {
        return customFetcher<PostApiLprReportsSubmitAll202>(
            { url: `/api/lpr/reports/submit-all`, method: 'POST' },
            options,
        );
    };

    /**
     * Report detail with the effective payload (CPR masked). id is resolved by format: a UUID is looked up as the report id, an integer as the booking id (one report per booking). 404 when no report matches.
     */
    const getApiLprReportsId = (
        id: string | string,
        options?: SecondParameter<typeof customFetcher<GetApiLprReportsId200>>,
    ) => {
        return customFetcher<GetApiLprReportsId200>({ url: `/api/lpr/reports/${id}`, method: 'GET' }, options);
    };

    /**
     * Edit per-report overrides (Pending, Queue or Errors only). null clears a field.
     */
    const patchApiLprReportsId = (
        id: string,
        patchApiLprReportsIdBody: PatchApiLprReportsIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiLprReportsId200>>,
    ) => {
        return customFetcher<PatchApiLprReportsId200>(
            {
                url: `/api/lpr/reports/${id}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiLprReportsIdBody,
            },
            options,
        );
    };

    /**
     * Report now: send one report to LPR synchronously; ends in Reported or Errors
     */
    const postApiLprReportsIdSubmit = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiLprReportsIdSubmit200>>,
    ) => {
        return customFetcher<PostApiLprReportsIdSubmit200>(
            { url: `/api/lpr/reports/${id}/submit`, method: 'POST' },
            options,
        );
    };

    /**
     * Move a queued report back to Pending
     */
    const postApiLprReportsIdUndo = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiLprReportsIdUndo200>>,
    ) => {
        return customFetcher<PostApiLprReportsIdUndo200>(
            { url: `/api/lpr/reports/${id}/undo`, method: 'POST' },
            options,
        );
    };

    /**
     * Remove a report (Pending, Queue or Errors) so it is never sent. Optional body: { reason }
     */
    const postApiLprReportsIdRemove = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiLprReportsIdRemove200>>,
    ) => {
        return customFetcher<PostApiLprReportsIdRemove200>(
            { url: `/api/lpr/reports/${id}/remove`, method: 'POST' },
            options,
        );
    };

    /**
     * Restore a removed report to Pending
     */
    const postApiLprReportsIdRestore = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiLprReportsIdRestore200>>,
    ) => {
        return customFetcher<PostApiLprReportsIdRestore200>(
            { url: `/api/lpr/reports/${id}/restore`, method: 'POST' },
            options,
        );
    };

    const postApiInspectionGroupBookingGroupBookingUuidCreateSales = (
        groupBookingUuid: string,
        options?: SecondParameter<typeof customFetcher<void>>,
    ) => {
        return customFetcher<void>(
            { url: `/api/inspection/group-booking/${groupBookingUuid}/create-sales`, method: 'POST' },
            options,
        );
    };

    /**
     * Get trustpilot configuration for an outlet
     */
    const getApiTrustpilotConfig = (options?: SecondParameter<typeof customFetcher<GetApiTrustpilotConfig200>>) => {
        return customFetcher<GetApiTrustpilotConfig200>({ url: `/api/trustpilot/config`, method: 'GET' }, options);
    };

    /**
     * Create or update trustpilot configuration for an outlet
     */
    const postApiTrustpilot = (
        postApiTrustpilotBody: PostApiTrustpilotBody,
        options?: SecondParameter<typeof customFetcher<PostApiTrustpilot200>>,
    ) => {
        return customFetcher<PostApiTrustpilot200>(
            {
                url: `/api/trustpilot`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiTrustpilotBody,
            },
            options,
        );
    };

    /**
     * Delete trustpilot configuration for an outlet
     */
    const postApiTrustpilotDisconnect = (
        options?: SecondParameter<typeof customFetcher<PostApiTrustpilotDisconnect200>>,
    ) => {
        return customFetcher<PostApiTrustpilotDisconnect200>(
            { url: `/api/trustpilot/disconnect`, method: 'POST' },
            options,
        );
    };

    /**
     * Send a test Trustpilot review request to a test email and/or phone number
     */
    const postApiTrustpilotSendTest = (
        postApiTrustpilotSendTestBody: PostApiTrustpilotSendTestBody,
        options?: SecondParameter<typeof customFetcher<PostApiTrustpilotSendTest200>>,
    ) => {
        return customFetcher<PostApiTrustpilotSendTest200>(
            {
                url: `/api/trustpilot/send-test`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiTrustpilotSendTestBody,
            },
            options,
        );
    };

    /**
     * Get klaviyo configuration for an outlet
     */
    const getApiKlaviyoConfig = (options?: SecondParameter<typeof customFetcher<GetApiKlaviyoConfig200>>) => {
        return customFetcher<GetApiKlaviyoConfig200>({ url: `/api/klaviyo/config`, method: 'GET' }, options);
    };

    /**
     * Create or update klaviyo configuration for an outlet
     */
    const postApiKlaviyo = (
        postApiKlaviyoBody: PostApiKlaviyoBody,
        options?: SecondParameter<typeof customFetcher<PostApiKlaviyo200>>,
    ) => {
        return customFetcher<PostApiKlaviyo200>(
            {
                url: `/api/klaviyo`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiKlaviyoBody,
            },
            options,
        );
    };

    /**
     * Delete klaviyo configuration for an outlet
     */
    const postApiKlaviyoDisconnect = (options?: SecondParameter<typeof customFetcher<PostApiKlaviyoDisconnect200>>) => {
        return customFetcher<PostApiKlaviyoDisconnect200>({ url: `/api/klaviyo/disconnect`, method: 'POST' }, options);
    };

    /**
     * Sync a customer from outlet_customers table to Klaviyo, delete customer is not supported by Klaviyo
     */
    const postApiKlaviyoSyncCustomer = (
        postApiKlaviyoSyncCustomerBody: PostApiKlaviyoSyncCustomerBody,
        options?: SecondParameter<typeof customFetcher<PostApiKlaviyoSyncCustomer200>>,
    ) => {
        return customFetcher<PostApiKlaviyoSyncCustomer200>(
            {
                url: `/api/klaviyo/sync-customer`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiKlaviyoSyncCustomerBody,
            },
            options,
        );
    };

    /**
     * List all marketing campaigns with statistics
     */
    const getApiCampaigns = (
        params?: GetApiCampaignsParams,
        options?: SecondParameter<typeof customFetcher<GetApiCampaigns200>>,
    ) => {
        return customFetcher<GetApiCampaigns200>({ url: `/api/campaigns`, method: 'GET', params }, options);
    };

    /**
     * Create a new marketing campaign
     */
    const postApiCampaigns = (
        postApiCampaignsBody: PostApiCampaignsBody,
        options?: SecondParameter<typeof customFetcher<PostApiCampaigns201>>,
    ) => {
        return customFetcher<PostApiCampaigns201>(
            {
                url: `/api/campaigns`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCampaignsBody,
            },
            options,
        );
    };

    /**
     * Get a single campaign by ID with full details including conditions
     */
    const getApiCampaignsId = (id: string, options?: SecondParameter<typeof customFetcher<GetApiCampaignsId200>>) => {
        return customFetcher<GetApiCampaignsId200>({ url: `/api/campaigns/${id}`, method: 'GET' }, options);
    };

    /**
     * Update a marketing campaign (campaignType cannot be changed)
     */
    const putApiCampaignsId = (
        id: string,
        putApiCampaignsIdBody: PutApiCampaignsIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiCampaignsId200>>,
    ) => {
        return customFetcher<PutApiCampaignsId200>(
            {
                url: `/api/campaigns/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiCampaignsIdBody,
            },
            options,
        );
    };

    /**
     * Delete a marketing campaign (soft delete)
     */
    const deleteApiCampaignsId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiCampaignsId200>>,
    ) => {
        return customFetcher<DeleteApiCampaignsId200>({ url: `/api/campaigns/${id}`, method: 'DELETE' }, options);
    };

    /**
     * Update marketing campaign isActive status
     */
    const patchApiCampaignsIdStatus = (
        id: string,
        patchApiCampaignsIdStatusBody: PatchApiCampaignsIdStatusBody,
        options?: SecondParameter<typeof customFetcher<PatchApiCampaignsIdStatus200>>,
    ) => {
        return customFetcher<PatchApiCampaignsIdStatus200>(
            {
                url: `/api/campaigns/${id}/status`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiCampaignsIdStatusBody,
            },
            options,
        );
    };

    /**
     * Trigger a marketing campaign manually
     */
    const postApiCampaignsIdTrigger = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiCampaignsIdTrigger200>>,
    ) => {
        return customFetcher<PostApiCampaignsIdTrigger200>(
            { url: `/api/campaigns/${id}/trigger`, method: 'POST' },
            options,
        );
    };

    const getApiCampaignsTestCronJob = (options?: SecondParameter<typeof customFetcher<void>>) => {
        return customFetcher<void>({ url: `/api/campaigns/test-cron-job`, method: 'GET' }, options);
    };

    /**
     * List marketing recipients
     */
    const getApiRecipients = (
        params?: GetApiRecipientsParams,
        options?: SecondParameter<typeof customFetcher<GetApiRecipients200>>,
    ) => {
        return customFetcher<GetApiRecipients200>({ url: `/api/recipients`, method: 'GET', params }, options);
    };

    /**
     * Get aggregated campaign statistics. Returns one object with totals for campaigns having campaign_status in ["COMPLETED", "TRIGGERED"].
     */
    const postApiCampaignsStatistics = (
        postApiCampaignsStatisticsBody: PostApiCampaignsStatisticsBody,
        options?: SecondParameter<typeof customFetcher<PostApiCampaignsStatistics200Item[]>>,
    ) => {
        return customFetcher<PostApiCampaignsStatistics200Item[]>(
            {
                url: `/api/campaigns/statistics`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCampaignsStatisticsBody,
            },
            options,
        );
    };

    /**
     * Get campaign statistics recipients (email, name, phone, status) for DRAFT/SCHEDULED campaigns that are not TRIGGER type
     */
    const getApiCampaignsCampaignIdStatisticsRecipients = (
        campaignId: string,
        options?: SecondParameter<typeof customFetcher<GetApiCampaignsCampaignIdStatisticsRecipients200Item[]>>,
    ) => {
        return customFetcher<GetApiCampaignsCampaignIdStatisticsRecipients200Item[]>(
            { url: `/api/campaigns/${campaignId}/statistics/recipients`, method: 'GET' },
            options,
        );
    };

    /**
     * Sync campaign recipients with the provided list. Adds new recipients and marks removed ones as SKIPPED. Only works for DRAFT campaigns with EMAIL or SMS type.
     */
    const putApiCampaignsCampaignIdStatisticsRecipients = (
        campaignId: string,
        putApiCampaignsCampaignIdStatisticsRecipientsBody: PutApiCampaignsCampaignIdStatisticsRecipientsBody,
        options?: SecondParameter<typeof customFetcher<PutApiCampaignsCampaignIdStatisticsRecipients200>>,
    ) => {
        return customFetcher<PutApiCampaignsCampaignIdStatisticsRecipients200>(
            {
                url: `/api/campaigns/${campaignId}/statistics/recipients`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiCampaignsCampaignIdStatisticsRecipientsBody,
            },
            options,
        );
    };

    /**
     * Send a test email to the test email address configured in the campaign. If testEmail and subject are provided, they will be used; otherwise, values from the database will be used.
     */
    const postApiCampaignsIdSendTestEmail = (
        id: string,
        postApiCampaignsIdSendTestEmailBody: PostApiCampaignsIdSendTestEmailBody,
        options?: SecondParameter<typeof customFetcher<PostApiCampaignsIdSendTestEmail200>>,
    ) => {
        return customFetcher<PostApiCampaignsIdSendTestEmail200>(
            {
                url: `/api/campaigns/${id}/send-test-email`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCampaignsIdSendTestEmailBody,
            },
            options,
        );
    };

    /**
     * Get all trigger templates (campaigns with type TRIGGER and outletId = null)
     */
    const getApiTriggerTemplates = (options?: SecondParameter<typeof customFetcher<GetApiTriggerTemplates200>>) => {
        return customFetcher<GetApiTriggerTemplates200>({ url: `/api/trigger-templates`, method: 'GET' }, options);
    };

    /**
     * Get email campaign overview with statistics and top campaigns
     */
    const getApiCampaignsEmailOverview = (
        params?: GetApiCampaignsEmailOverviewParams,
        options?: SecondParameter<typeof customFetcher<GetApiCampaignsEmailOverview200>>,
    ) => {
        return customFetcher<GetApiCampaignsEmailOverview200>(
            { url: `/api/campaigns/email/overview`, method: 'GET', params },
            options,
        );
    };

    /**
     * Set marketing_permission = true for a given percentage of outlet customers where user_id is null
     */
    const postApiMarketingSetPermissionByPercentage = (
        postApiMarketingSetPermissionByPercentageBody: PostApiMarketingSetPermissionByPercentageBody,
        options?: SecondParameter<typeof customFetcher<PostApiMarketingSetPermissionByPercentage200>>,
    ) => {
        return customFetcher<PostApiMarketingSetPermissionByPercentage200>(
            {
                url: `/api/marketing/set-permission-by-percentage`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiMarketingSetPermissionByPercentageBody,
            },
            options,
        );
    };

    /**
     * Create a new webhook for a specific event
     */
    const postApiWebhooks = (
        postApiWebhooksBody: PostApiWebhooksBody,
        options?: SecondParameter<typeof customFetcher<PostApiWebhooks201>>,
    ) => {
        return customFetcher<PostApiWebhooks201>(
            {
                url: `/api/webhooks`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiWebhooksBody,
            },
            options,
        );
    };

    /**
     * List all webhooks for an outlet
     */
    const getApiWebhooks = (
        params?: GetApiWebhooksParams,
        options?: SecondParameter<typeof customFetcher<GetApiWebhooks200>>,
    ) => {
        return customFetcher<GetApiWebhooks200>({ url: `/api/webhooks`, method: 'GET', params }, options);
    };

    /**
     * Update a webhook
     */
    const putApiWebhooksId = (
        id: number,
        putApiWebhooksIdBody: PutApiWebhooksIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiWebhooksId200>>,
    ) => {
        return customFetcher<PutApiWebhooksId200>(
            {
                url: `/api/webhooks/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiWebhooksIdBody,
            },
            options,
        );
    };

    /**
     * Delete a webhook (soft delete)
     */
    const deleteApiWebhooksId = (
        id: number,
        options?: SecondParameter<typeof customFetcher<DeleteApiWebhooksId200>>,
    ) => {
        return customFetcher<DeleteApiWebhooksId200>({ url: `/api/webhooks/${id}`, method: 'DELETE' }, options);
    };

    /**
     * Upsert a service subscription (create or update)
     */
    const postApiServiceSubscription = (
        postApiServiceSubscriptionBody: PostApiServiceSubscriptionBody,
        options?: SecondParameter<typeof customFetcher<PostApiServiceSubscription200 | PostApiServiceSubscription201>>,
    ) => {
        return customFetcher<PostApiServiceSubscription200 | PostApiServiceSubscription201>(
            {
                url: `/api/service-subscription`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiServiceSubscriptionBody,
            },
            options,
        );
    };

    /**
     * Edit a service subscription
     */
    const putApiServiceSubscriptionId = (
        id: string,
        putApiServiceSubscriptionIdBody: PutApiServiceSubscriptionIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiServiceSubscriptionId200>>,
    ) => {
        return customFetcher<PutApiServiceSubscriptionId200>(
            {
                url: `/api/service-subscription/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiServiceSubscriptionIdBody,
            },
            options,
        );
    };

    /**
     * Delete a service subscription
     */
    const deleteApiServiceSubscriptionId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiServiceSubscriptionId200>>,
    ) => {
        return customFetcher<DeleteApiServiceSubscriptionId200>(
            { url: `/api/service-subscription/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Get all subscriptions and transactions for a customer
     */
    const getApiServiceSubscriptionCustomer = (
        params: GetApiServiceSubscriptionCustomerParams,
        options?: SecondParameter<typeof customFetcher<GetApiServiceSubscriptionCustomer200>>,
    ) => {
        return customFetcher<GetApiServiceSubscriptionCustomer200>(
            { url: `/api/service-subscription/customer`, method: 'GET', params },
            options,
        );
    };

    /**
     * Create a new health declaration template
     */
    const postApiHealthDeclarationTemplates = (
        postApiHealthDeclarationTemplatesBody: PostApiHealthDeclarationTemplatesBody,
        options?: SecondParameter<typeof customFetcher<PostApiHealthDeclarationTemplates201>>,
    ) => {
        return customFetcher<PostApiHealthDeclarationTemplates201>(
            {
                url: `/api/health-declaration-templates`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiHealthDeclarationTemplatesBody,
            },
            options,
        );
    };

    /**
     * List health declaration templates with filters, sorting, and pagination
     */
    const getApiHealthDeclarationTemplates = (
        params?: GetApiHealthDeclarationTemplatesParams,
        options?: SecondParameter<typeof customFetcher<GetApiHealthDeclarationTemplates200>>,
    ) => {
        return customFetcher<GetApiHealthDeclarationTemplates200>(
            { url: `/api/health-declaration-templates`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get a health declaration template by ID
     */
    const getApiHealthDeclarationTemplateId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiHealthDeclarationTemplateId200>>,
    ) => {
        return customFetcher<GetApiHealthDeclarationTemplateId200>(
            { url: `/api/health-declaration-template/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * Update a health declaration template by ID
     */
    const putApiHealthDeclarationTemplateId = (
        id: string,
        putApiHealthDeclarationTemplateIdBody: PutApiHealthDeclarationTemplateIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiHealthDeclarationTemplateId200>>,
    ) => {
        return customFetcher<PutApiHealthDeclarationTemplateId200>(
            {
                url: `/api/health-declaration-template/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiHealthDeclarationTemplateIdBody,
            },
            options,
        );
    };

    /**
     * Delete a health declaration template by ID (soft delete)
     */
    const deleteApiHealthDeclarationTemplateId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiHealthDeclarationTemplateId200>>,
    ) => {
        return customFetcher<DeleteApiHealthDeclarationTemplateId200>(
            { url: `/api/health-declaration-template/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Bulk create and update health declaration templates. Use key "new" to create a template and template UUID keys to update existing templates.
     */
    const patchApiHealthDeclarationTemplatesBulk = (
        patchApiHealthDeclarationTemplatesBulkBody: PatchApiHealthDeclarationTemplatesBulkBody,
        options?: SecondParameter<typeof customFetcher<PatchApiHealthDeclarationTemplatesBulk200>>,
    ) => {
        return customFetcher<PatchApiHealthDeclarationTemplatesBulk200>(
            {
                url: `/api/health-declaration-templates/bulk`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiHealthDeclarationTemplatesBulkBody,
            },
            options,
        );
    };

    /**
     * Bulk delete health declaration templates by IDs (soft delete)
     */
    const deleteApiHealthDeclarationTemplatesBulk = (
        deleteApiHealthDeclarationTemplatesBulkBody: DeleteApiHealthDeclarationTemplatesBulkBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiHealthDeclarationTemplatesBulk200>>,
    ) => {
        return customFetcher<DeleteApiHealthDeclarationTemplatesBulk200>(
            {
                url: `/api/health-declaration-templates/bulk`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiHealthDeclarationTemplatesBulkBody,
            },
            options,
        );
    };

    /**
     * Create health declarations for all bookings in a group booking that have health declaration enabled
     */
    const postApiHealthDeclarationsGroupBookingGroupBookingUuid = (
        groupBookingUuid: string,
        options?: SecondParameter<typeof customFetcher<PostApiHealthDeclarationsGroupBookingGroupBookingUuid201>>,
    ) => {
        return customFetcher<PostApiHealthDeclarationsGroupBookingGroupBookingUuid201>(
            { url: `/api/health-declarations/group-booking/${groupBookingUuid}`, method: 'POST' },
            options,
        );
    };

    /**
     * Update health declaration (status, responseContent, review, resend, submit)
     */
    const putApiHealthDeclarationId = (
        id: string,
        putApiHealthDeclarationIdBody: PutApiHealthDeclarationIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiHealthDeclarationId200>>,
    ) => {
        return customFetcher<PutApiHealthDeclarationId200>(
            {
                url: `/api/health-declaration/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiHealthDeclarationIdBody,
            },
            options,
        );
    };

    /**
     * List health declarations with filters (bookingId, groupBookingUuid, status, etc.)
     */
    const getApiHealthDeclarations = (
        params?: GetApiHealthDeclarationsParams,
        options?: SecondParameter<typeof customFetcher<GetApiHealthDeclarations200>>,
    ) => {
        return customFetcher<GetApiHealthDeclarations200>(
            { url: `/api/health-declarations`, method: 'GET', params },
            options,
        );
    };

    /**
     * Send or resend health declaration email by booking ID
     */
    const postApiHealthDeclarationBookingBookingIdSendEmail = (
        bookingId: number,
        params?: PostApiHealthDeclarationBookingBookingIdSendEmailParams,
        options?: SecondParameter<typeof customFetcher<PostApiHealthDeclarationBookingBookingIdSendEmail200>>,
    ) => {
        return customFetcher<PostApiHealthDeclarationBookingBookingIdSendEmail200>(
            { url: `/api/health-declaration/booking/${bookingId}/send-email`, method: 'POST', params },
            options,
        );
    };

    /**
     * Patch employee opening hours for a specific date
     */
    const patchApiEmployeeOpeningHoursEmployeeId = (
        employeeId: number,
        patchApiEmployeeOpeningHoursEmployeeIdBody: PatchApiEmployeeOpeningHoursEmployeeIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiEmployeeOpeningHoursEmployeeId200Item[]>>,
    ) => {
        return customFetcher<PatchApiEmployeeOpeningHoursEmployeeId200Item[]>(
            {
                url: `/api/employee-opening-hours/${employeeId}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiEmployeeOpeningHoursEmployeeIdBody,
            },
            options,
        );
    };

    /**
     * Create a new advanced reminder template
     */
    const postApiServiceAdvancedReminderTemplates = (
        postApiServiceAdvancedReminderTemplatesBody: PostApiServiceAdvancedReminderTemplatesBody,
        options?: SecondParameter<typeof customFetcher<PostApiServiceAdvancedReminderTemplates201>>,
    ) => {
        return customFetcher<PostApiServiceAdvancedReminderTemplates201>(
            {
                url: `/api/service/advanced-reminder-templates`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiServiceAdvancedReminderTemplatesBody,
            },
            options,
        );
    };

    /**
     * List advanced reminder templates with pagination and filtering
     */
    const getApiServiceAdvancedReminderTemplates = (
        params?: GetApiServiceAdvancedReminderTemplatesParams,
        options?: SecondParameter<typeof customFetcher<GetApiServiceAdvancedReminderTemplates200>>,
    ) => {
        return customFetcher<GetApiServiceAdvancedReminderTemplates200>(
            { url: `/api/service/advanced-reminder-templates`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get advanced reminder template by ID
     */
    const getApiServiceAdvancedReminderTemplatesReminderTemplateId = (
        reminderTemplateId: string,
        options?: SecondParameter<typeof customFetcher<GetApiServiceAdvancedReminderTemplatesReminderTemplateId200>>,
    ) => {
        return customFetcher<GetApiServiceAdvancedReminderTemplatesReminderTemplateId200>(
            { url: `/api/service/advanced-reminder-templates/${reminderTemplateId}`, method: 'GET' },
            options,
        );
    };

    /**
     * Partially update an advanced reminder template. Only sent fields are updated; other columns remain unchanged.
     */
    const patchApiServiceAdvancedReminderTemplatesReminderTemplateId = (
        reminderTemplateId: string,
        patchApiServiceAdvancedReminderTemplatesReminderTemplateIdBody: PatchApiServiceAdvancedReminderTemplatesReminderTemplateIdBody,
        options?: SecondParameter<typeof customFetcher<PatchApiServiceAdvancedReminderTemplatesReminderTemplateId200>>,
    ) => {
        return customFetcher<PatchApiServiceAdvancedReminderTemplatesReminderTemplateId200>(
            {
                url: `/api/service/advanced-reminder-templates/${reminderTemplateId}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiServiceAdvancedReminderTemplatesReminderTemplateIdBody,
            },
            options,
        );
    };

    /**
     * Delete an advanced reminder template (soft delete)
     */
    const deleteApiServiceAdvancedReminderTemplatesReminderTemplateId = (
        reminderTemplateId: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiServiceAdvancedReminderTemplatesReminderTemplateId200>>,
    ) => {
        return customFetcher<DeleteApiServiceAdvancedReminderTemplatesReminderTemplateId200>(
            { url: `/api/service/advanced-reminder-templates/${reminderTemplateId}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Bulk create and update advanced reminder templates. Use key "new" to create a template and template UUID keys to update existing templates.
     */
    const patchApiServiceAdvancedReminderTemplatesBulk = (
        patchApiServiceAdvancedReminderTemplatesBulkBody: PatchApiServiceAdvancedReminderTemplatesBulkBody,
        options?: SecondParameter<typeof customFetcher<PatchApiServiceAdvancedReminderTemplatesBulk200>>,
    ) => {
        return customFetcher<PatchApiServiceAdvancedReminderTemplatesBulk200>(
            {
                url: `/api/service/advanced-reminder-templates/bulk`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiServiceAdvancedReminderTemplatesBulkBody,
            },
            options,
        );
    };

    /**
     * Bulk delete advanced reminder templates by IDs (soft delete)
     */
    const deleteApiServiceAdvancedReminderTemplatesBulk = (
        deleteApiServiceAdvancedReminderTemplatesBulkBody: DeleteApiServiceAdvancedReminderTemplatesBulkBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiServiceAdvancedReminderTemplatesBulk200>>,
    ) => {
        return customFetcher<DeleteApiServiceAdvancedReminderTemplatesBulk200>(
            {
                url: `/api/service/advanced-reminder-templates/bulk`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiServiceAdvancedReminderTemplatesBulkBody,
            },
            options,
        );
    };

    /**
     * List all app modules with their active status for the outlet
     */
    const getApiServiceAppModules = (options?: SecondParameter<typeof customFetcher<GetApiServiceAppModules200>>) => {
        return customFetcher<GetApiServiceAppModules200>({ url: `/api/service/app-modules`, method: 'GET' }, options);
    };

    /**
     * Enable or disable an app module for the outlet
     */
    const patchApiServiceAppModulesModuleKey = (
        moduleKey: string,
        patchApiServiceAppModulesModuleKeyBody: PatchApiServiceAppModulesModuleKeyBody,
        options?: SecondParameter<typeof customFetcher<PatchApiServiceAppModulesModuleKey200>>,
    ) => {
        return customFetcher<PatchApiServiceAppModulesModuleKey200>(
            {
                url: `/api/service/app-modules/${moduleKey}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiServiceAppModulesModuleKeyBody,
            },
            options,
        );
    };

    /**
     * List doctor portal notifications for the outlet. Supports pagination and optional filters by doctorUuid and read status.
     */
    const getApiDoctorsPortalNotifications = (
        params?: GetApiDoctorsPortalNotificationsParams,
        options?: SecondParameter<typeof customFetcher<GetApiDoctorsPortalNotifications200>>,
    ) => {
        return customFetcher<GetApiDoctorsPortalNotifications200>(
            { url: `/api/doctors-portal/notifications`, method: 'GET', params },
            options,
        );
    };

    /**
     * Mark notifications as read. Pass notificationIds to mark specific notifications. Pass readAll: true to mark all unread for the outlet; readAll: false has no effect.
     */
    const patchApiDoctorsPortalNotificationsRead = (
        patchApiDoctorsPortalNotificationsReadBody: PatchApiDoctorsPortalNotificationsReadBody,
        options?: SecondParameter<typeof customFetcher<PatchApiDoctorsPortalNotificationsRead200>>,
    ) => {
        return customFetcher<PatchApiDoctorsPortalNotificationsRead200>(
            {
                url: `/api/doctors-portal/notifications/read`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiDoctorsPortalNotificationsReadBody,
            },
            options,
        );
    };

    /**
     * List doctor outlet activity logs for the outlet. Supports pagination, filter by doctorUuid, sort (sortBy, sortOrder), and date range (fromDate, toDate).
     */
    const getApiDoctorsPortalLogs = (
        params?: GetApiDoctorsPortalLogsParams,
        options?: SecondParameter<typeof customFetcher<GetApiDoctorsPortalLogs200>>,
    ) => {
        return customFetcher<GetApiDoctorsPortalLogs200>(
            { url: `/api/doctors-portal/logs`, method: 'GET', params },
            options,
        );
    };

    /**
     * List outlet messages (valid date range, not deleted). Supports sort (sortBy, sortOrder), filter (priority, keyword in title/content), and optional doctorUuid (verifies doctor is LINKED before returning).
     */
    const getApiDoctorsPortalMessages = (
        params?: GetApiDoctorsPortalMessagesParams,
        options?: SecondParameter<typeof customFetcher<GetApiDoctorsPortalMessages200>>,
    ) => {
        return customFetcher<GetApiDoctorsPortalMessages200>(
            { url: `/api/doctors-portal/messages`, method: 'GET', params },
            options,
        );
    };

    /**
     * Mark multiple doctor-outlet messages as read by message IDs (scoped to authenticated outlet).
     */
    const patchApiDoctorsPortalMessagesReadBulk = (
        patchApiDoctorsPortalMessagesReadBulkBody: PatchApiDoctorsPortalMessagesReadBulkBody,
        options?: SecondParameter<typeof customFetcher<PatchApiDoctorsPortalMessagesReadBulk200>>,
    ) => {
        return customFetcher<PatchApiDoctorsPortalMessagesReadBulk200>(
            {
                url: `/api/doctors-portal/messages/read-bulk`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: patchApiDoctorsPortalMessagesReadBulkBody,
            },
            options,
        );
    };

    /**
     * List doctors that have at least one doctor-outlet invitation for this outlet (includes deleted invitations). Returns doctor details plus invitation status and status-specific fields: invitedBy/invitedAt (invited), linkedAt (linked), rejectedAt (rejected), unlinkedBy/unlinkedAt (self_unlinked, removed).
     */
    const getApiDoctorsPortalDoctors = (
        params?: GetApiDoctorsPortalDoctorsParams,
        options?: SecondParameter<typeof customFetcher<GetApiDoctorsPortalDoctors200>>,
    ) => {
        return customFetcher<GetApiDoctorsPortalDoctors200>(
            { url: `/api/doctors-portal/doctors`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get read-only directory tree for a doctor. Returns nested directories and files for the given doctor ID.
     */
    const getApiDoctorsPortalDoctorsDoctorIdDirectories = (
        doctorId: string,
        options?: SecondParameter<typeof customFetcher<GetApiDoctorsPortalDoctorsDoctorIdDirectories200>>,
    ) => {
        return customFetcher<GetApiDoctorsPortalDoctorsDoctorIdDirectories200>(
            { url: `/api/doctors-portal/doctors/${doctorId}/directories`, method: 'GET' },
            options,
        );
    };

    /**
     * Send invitation email to a doctor by email. Doctor must exist and not already be linked to this outlet.
     */
    const postApiDoctorsPortalInvite = (
        postApiDoctorsPortalInviteBody: PostApiDoctorsPortalInviteBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalInvite201>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalInvite201>(
            {
                url: `/api/doctors-portal/invite`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalInviteBody,
            },
            options,
        );
    };

    /**
     * Remove doctor from outlet. Sets invitation status to REMOVED and deletedAt; soft-deletes the linked employee (outlet_employee_id) if present.
     */
    const deleteApiDoctorsPortalDoctorsDoctorUuid = (
        doctorUuid: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiDoctorsPortalDoctorsDoctorUuid200>>,
    ) => {
        return customFetcher<DeleteApiDoctorsPortalDoctorsDoctorUuid200>(
            { url: `/api/doctors-portal/doctors/${doctorUuid}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * Request OTP for doctor portal signup. Sends verification code to email.
     */
    const postApiDoctorsPortalPublicSignupRequestOtp = (
        postApiDoctorsPortalPublicSignupRequestOtpBody: PostApiDoctorsPortalPublicSignupRequestOtpBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicSignupRequestOtp201>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicSignupRequestOtp201>(
            {
                url: `/api/doctors-portal/public/signup/request-otp`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicSignupRequestOtpBody,
            },
            options,
        );
    };

    /**
     * Resend OTP for doctor portal signup. Requires a pending signup for the email.
     */
    const postApiDoctorsPortalPublicSignupResendOtp = (
        postApiDoctorsPortalPublicSignupResendOtpBody: PostApiDoctorsPortalPublicSignupResendOtpBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicSignupResendOtp200>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicSignupResendOtp200>(
            {
                url: `/api/doctors-portal/public/signup/resend-otp`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicSignupResendOtpBody,
            },
            options,
        );
    };

    /**
     * Verify OTP and complete doctor signup. Creates doctor user and returns doctorUuid.
     */
    const postApiDoctorsPortalPublicSignupVerifyOtp = (
        postApiDoctorsPortalPublicSignupVerifyOtpBody: PostApiDoctorsPortalPublicSignupVerifyOtpBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicSignupVerifyOtp201>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicSignupVerifyOtp201>(
            {
                url: `/api/doctors-portal/public/signup/verify-otp`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicSignupVerifyOtpBody,
            },
            options,
        );
    };

    /**
     * Doctor portal login. Validates email and password. If MFA trusted (remember me within 60 days), returns access token. Otherwise sends OTP and returns loginIntentToken for verify-otp.
     */
    const postApiDoctorsPortalPublicLogin = (
        postApiDoctorsPortalPublicLoginBody: PostApiDoctorsPortalPublicLoginBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicLogin200>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicLogin200>(
            {
                url: `/api/doctors-portal/public/login`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicLoginBody,
            },
            options,
        );
    };

    /**
     * Verify login OTP and issue access token. If rememberMe was set at login, MFA is trusted for 60 days.
     */
    const postApiDoctorsPortalPublicLoginVerifyOtp = (
        postApiDoctorsPortalPublicLoginVerifyOtpBody: PostApiDoctorsPortalPublicLoginVerifyOtpBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicLoginVerifyOtp200>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicLoginVerifyOtp200>(
            {
                url: `/api/doctors-portal/public/login/verify-otp`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicLoginVerifyOtpBody,
            },
            options,
        );
    };

    /**
     * Resend login OTP. Requires valid loginIntentToken from login response.
     */
    const postApiDoctorsPortalPublicLoginResendOtp = (
        postApiDoctorsPortalPublicLoginResendOtpBody: PostApiDoctorsPortalPublicLoginResendOtpBody,
        options?: SecondParameter<typeof customFetcher<PostApiDoctorsPortalPublicLoginResendOtp200>>,
    ) => {
        return customFetcher<PostApiDoctorsPortalPublicLoginResendOtp200>(
            {
                url: `/api/doctors-portal/public/login/resend-otp`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDoctorsPortalPublicLoginResendOtpBody,
            },
            options,
        );
    };

    /**
     * Upload multiple files. Send as multipart/form-data with optional field "directoryPath" (to uplaod at custom path)
     */
    const postApiFilesUpload = (options?: SecondParameter<typeof customFetcher<PostApiFilesUpload201>>) => {
        return customFetcher<PostApiFilesUpload201>({ url: `/api/files/upload`, method: 'POST' }, options);
    };

    /**
     * Soft-delete multiple files by ID
     */
    const deleteApiFiles = (
        deleteApiFilesBody: DeleteApiFilesBody,
        options?: SecondParameter<typeof customFetcher<DeleteApiFiles200>>,
    ) => {
        return customFetcher<DeleteApiFiles200>(
            {
                url: `/api/files`,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                data: deleteApiFilesBody,
            },
            options,
        );
    };

    /**
     * Get sample CSV file for a given import type. Returns semicolon-delimited CSV with 2 sample rows. Valid types: customers, services, bookings, journals.
     */
    const getApiImportDataSampleType = (
        type: 'customers' | 'services' | 'bookings' | 'journals',
        params?: GetApiImportDataSampleTypeParams,
        options?: SecondParameter<typeof customFetcher<unknown>>,
    ) => {
        return customFetcher<unknown>({ url: `/api/import-data/sample/${type}`, method: 'GET', params }, options);
    };

    /**
     * List import notifications (import logs) open, newest first. Includes outlet name, createdAt, updatedAt, readAt (null if unread), and unreadCount.
     */
    const getApiImportDataNotifications = (
        params?: GetApiImportDataNotificationsParams,
        options?: SecondParameter<typeof customFetcher<GetApiImportDataNotifications200>>,
    ) => {
        return customFetcher<GetApiImportDataNotifications200>(
            { url: `/api/import-data/notifications`, method: 'GET', params },
            options,
        );
    };

    /**
     * Mark an import notification (import log) as read. Pass the log UUID, or the literal ALL (any case) to mark all unread notifications as read.
     */
    const postApiImportDataNotificationsIdRead = (
        id: string,
        options?: SecondParameter<typeof customFetcher<PostApiImportDataNotificationsIdRead200>>,
    ) => {
        return customFetcher<PostApiImportDataNotificationsIdRead200>(
            { url: `/api/import-data/notifications/${id}/read`, method: 'POST' },
            options,
        );
    };

    /**
     * Download error CSV for a failed import by import log id (open). Filename includes outlet name. Returns 404 if log not found or no error CSV.
     */
    const getApiImportDataLogsIdErrorCsv = (id: string, options?: SecondParameter<typeof customFetcher<unknown>>) => {
        return customFetcher<unknown>({ url: `/api/import-data/logs/${id}/error-csv`, method: 'GET' }, options);
    };

    /**
     * Get services, service groups, and addons table column metadata
     */
    const getApiImportDataServicesMetadata = (
        options?: SecondParameter<typeof customFetcher<GetApiImportDataServicesMetadata200>>,
    ) => {
        return customFetcher<GetApiImportDataServicesMetadata200>(
            { url: `/api/import-data/services/metadata`, method: 'GET' },
            options,
        );
    };

    /**
 * Import services via multipart: one key "mapping" (JSON: field name → CSV column index) and one key "file" (CSV). 
  Processing runs asynchronously (Bull/Redis): 202 returns immediately with jobId and logId; poll GET /import-data/notifications for status.

  Pass outlet_id in query to import into that outlet.
 
  If importMode=RESET_AND_ADD, all existing services for the outlet will be deleted before importing new ones.
 
  If importMode=ADD or not provided, new services will be added without deleting existing ones.
 
  Empty/missing group_name = no group.
 
  service_addons = comma-separated addon names.

 */
    const postApiImportDataServices = (
        postApiImportDataServicesBody: PostApiImportDataServicesBody,
        params: PostApiImportDataServicesParams,
        options?: SecondParameter<typeof customFetcher<PostApiImportDataServices202>>,
    ) => {
        const formData = new FormData();
        formData.append(`mapping`, postApiImportDataServicesBody.mapping);
        if (postApiImportDataServicesBody.formats !== undefined) {
            formData.append(`formats`, postApiImportDataServicesBody.formats);
        }
        formData.append(`file`, postApiImportDataServicesBody.file);

        return customFetcher<PostApiImportDataServices202>(
            {
                url: `/api/import-data/services`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
                params,
            },
            options,
        );
    };

    /**
     * Get customers table column metadata for import
     */
    const getApiImportDataCustomersMetadata = (
        options?: SecondParameter<typeof customFetcher<GetApiImportDataCustomersMetadata200>>,
    ) => {
        return customFetcher<GetApiImportDataCustomersMetadata200>(
            { url: `/api/import-data/customers/metadata`, method: 'GET' },
            options,
        );
    };

    /**
     * Import customers via multipart: one key "mapping" (JSON: field name → CSV column index) and one key "file" (CSV). Processing is asynchronous (202 + jobId/logId; poll notifications). CSV must include phone_number column. Pass outlet_id in query to import into that outlet. If shouldUpdate=true, existing customers with same phone number will be updated instead of rejected. Note: phone_number is required in CSV when shouldUpdate=true.
     */
    const postApiImportDataCustomers = (
        postApiImportDataCustomersBody: PostApiImportDataCustomersBody,
        params: PostApiImportDataCustomersParams,
        options?: SecondParameter<typeof customFetcher<PostApiImportDataCustomers202>>,
    ) => {
        const formData = new FormData();
        if (postApiImportDataCustomersBody.mapping !== undefined) {
            formData.append(`mapping`, postApiImportDataCustomersBody.mapping);
        }
        if (postApiImportDataCustomersBody.file !== undefined) {
            formData.append(`file`, postApiImportDataCustomersBody.file);
        }

        return customFetcher<PostApiImportDataCustomers202>(
            {
                url: `/api/import-data/customers`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
                params,
            },
            options,
        );
    };

    /**
     * Get logical booking import column metadata (booking + booking_details + customer linkage). booking_datetime_end can be derived from booking_datetime_start + duration_min (or duration_text). Supports employee_name mapping.
     */
    const getApiImportDataBookingsMetadata = (
        options?: SecondParameter<typeof customFetcher<GetApiImportDataBookingsMetadata200>>,
    ) => {
        return customFetcher<GetApiImportDataBookingsMetadata200>(
            { url: `/api/import-data/bookings/metadata`, method: 'GET' },
            options,
        );
    };

    /**
     * Import bookings via multipart: key "mapping" (JSON: booking field → CSV column index) and key "file" (semicolon-delimited CSV). Processing is asynchronous (202 + jobId/logId; poll notifications). Supports ghost_import, force and update_existing flags, similar to legacy Python import. If booking_datetime_end is missing, it is derived from booking_datetime_start + duration_min (or duration_text). employee_name is resolved to an existing employee; when ghost_import=true, missing employee names are created and attached automatically. Query employee_id is optional fallback when employee_name is missing/unresolved.
     */
    const postApiImportDataBookings = (
        postApiImportDataBookingsBody: PostApiImportDataBookingsBody,
        params: PostApiImportDataBookingsParams,
        options?: SecondParameter<typeof customFetcher<PostApiImportDataBookings202>>,
    ) => {
        const formData = new FormData();
        formData.append(`mapping`, postApiImportDataBookingsBody.mapping);
        if (postApiImportDataBookingsBody.formats !== undefined) {
            formData.append(`formats`, postApiImportDataBookingsBody.formats);
        }
        formData.append(`file`, postApiImportDataBookingsBody.file);

        return customFetcher<PostApiImportDataBookings202>(
            {
                url: `/api/import-data/bookings`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
                params,
            },
            options,
        );
    };

    /**
     * Get journal import metadata for a layout (single_file or two_file). Returns per-file columns, joins, and datetime format helpers.
     */
    const getApiImportDataJournalsMetadata = (
        params?: GetApiImportDataJournalsMetadataParams,
        options?: SecondParameter<typeof customFetcher<GetApiImportDataJournalsMetadata200>>,
    ) => {
        return customFetcher<GetApiImportDataJournalsMetadata200>(
            { url: `/api/import-data/journals/metadata`, method: 'GET', params },
            options,
        );
    };

    /**
 * Import journals via multipart. layout=single_file uses file+mapping; layout=two_file uses file_journals+mapping_journals and file_customers+mapping_customers.
  layout=onlinebooq uses file_customers+mapping_customers+drive_folder_url; worker fetches notes/photos from Google Drive.
  Processing is asynchronous (202 + jobId/logId). journal_entry/title are Fernet-encrypted; post=true on insert.
  join_by=phone|id controls CSV merge / customer lookup. create_customer=true creates missing customers then imports.
 */
    const postApiImportDataJournals = (
        postApiImportDataJournalsBody: PostApiImportDataJournalsBody,
        params: PostApiImportDataJournalsParams,
        options?: SecondParameter<typeof customFetcher<PostApiImportDataJournals202>>,
    ) => {
        const formData = new FormData();
        if (postApiImportDataJournalsBody.mapping !== undefined) {
            formData.append(`mapping`, postApiImportDataJournalsBody.mapping);
        }
        if (postApiImportDataJournalsBody.mapping_journals !== undefined) {
            formData.append(`mapping_journals`, postApiImportDataJournalsBody.mapping_journals);
        }
        if (postApiImportDataJournalsBody.mapping_customers !== undefined) {
            formData.append(`mapping_customers`, postApiImportDataJournalsBody.mapping_customers);
        }
        if (postApiImportDataJournalsBody.formats !== undefined) {
            formData.append(`formats`, postApiImportDataJournalsBody.formats);
        }
        if (postApiImportDataJournalsBody.joins !== undefined) {
            formData.append(`joins`, postApiImportDataJournalsBody.joins);
        }
        if (postApiImportDataJournalsBody.file !== undefined) {
            formData.append(`file`, postApiImportDataJournalsBody.file);
        }
        if (postApiImportDataJournalsBody.file_journals !== undefined) {
            formData.append(`file_journals`, postApiImportDataJournalsBody.file_journals);
        }
        if (postApiImportDataJournalsBody.file_customers !== undefined) {
            formData.append(`file_customers`, postApiImportDataJournalsBody.file_customers);
        }
        if (postApiImportDataJournalsBody.drive_folder_url !== undefined) {
            formData.append(`drive_folder_url`, postApiImportDataJournalsBody.drive_folder_url);
        }

        return customFetcher<PostApiImportDataJournals202>(
            {
                url: `/api/import-data/journals`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
                params,
            },
            options,
        );
    };

    /**
     * Get communication templates by JSON body: identifiers and optional modes arrays. For each (identifier, mode) returns default (outlet_id null) and outlet-specific row when present.
     */
    const postApiCommunicationTemplates = (
        postApiCommunicationTemplatesBody: PostApiCommunicationTemplatesBody,
        options?: SecondParameter<typeof customFetcher<PostApiCommunicationTemplates200>>,
    ) => {
        return customFetcher<PostApiCommunicationTemplates200>(
            {
                url: `/api/communication/templates`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiCommunicationTemplatesBody,
            },
            options,
        );
    };

    /**
     * Create a new data processing agreement
     */
    const postApiDataProcessingAgreements = (
        postApiDataProcessingAgreementsBody: PostApiDataProcessingAgreementsBody,
        options?: SecondParameter<typeof customFetcher<PostApiDataProcessingAgreements201>>,
    ) => {
        return customFetcher<PostApiDataProcessingAgreements201>(
            {
                url: `/api/data-processing-agreements`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDataProcessingAgreementsBody,
            },
            options,
        );
    };

    /**
     * List data processing agreements with filters, sorting, and pagination
     */
    const getApiDataProcessingAgreements = (
        params?: GetApiDataProcessingAgreementsParams,
        options?: SecondParameter<typeof customFetcher<GetApiDataProcessingAgreements200>>,
    ) => {
        return customFetcher<GetApiDataProcessingAgreements200>(
            { url: `/api/data-processing-agreements`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get a data processing agreement by ID
     */
    const getApiDataProcessingAgreementId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiDataProcessingAgreementId200>>,
    ) => {
        return customFetcher<GetApiDataProcessingAgreementId200>(
            { url: `/api/data-processing-agreement/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * Update a data processing agreement by ID
     */
    const putApiDataProcessingAgreementId = (
        id: string,
        putApiDataProcessingAgreementIdBody: PutApiDataProcessingAgreementIdBody,
        options?: SecondParameter<typeof customFetcher<PutApiDataProcessingAgreementId200>>,
    ) => {
        return customFetcher<PutApiDataProcessingAgreementId200>(
            {
                url: `/api/data-processing-agreement/${id}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: putApiDataProcessingAgreementIdBody,
            },
            options,
        );
    };

    /**
     * Delete a data processing agreement by ID
     */
    const deleteApiDataProcessingAgreementId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<DeleteApiDataProcessingAgreementId200>>,
    ) => {
        return customFetcher<DeleteApiDataProcessingAgreementId200>(
            { url: `/api/data-processing-agreement/${id}`, method: 'DELETE' },
            options,
        );
    };

    /**
     * List acceptances for a data processing agreement
     */
    const getApiDataProcessingAgreementIdAcceptances = (
        id: string,
        params?: GetApiDataProcessingAgreementIdAcceptancesParams,
        options?: SecondParameter<typeof customFetcher<GetApiDataProcessingAgreementIdAcceptances200>>,
    ) => {
        return customFetcher<GetApiDataProcessingAgreementIdAcceptances200>(
            { url: `/api/data-processing-agreement/${id}/acceptances`, method: 'GET', params },
            options,
        );
    };

    /**
     * Get payment plan info
     */
    const getApiPaymentPlan = (options?: SecondParameter<typeof customFetcher<GetApiPaymentPlan200>>) => {
        return customFetcher<GetApiPaymentPlan200>({ url: `/api/payment-plan`, method: 'GET' }, options);
    };

    /**
     * Get authenticated outlet subscription details including employees, SMS usage, and next charge
     */
    const getApiSubscriptionDetails = (
        options?: SecondParameter<typeof customFetcher<GetApiSubscriptionDetails200>>,
    ) => {
        return customFetcher<GetApiSubscriptionDetails200>(
            { url: `/api/subscription/details`, method: 'GET' },
            options,
        );
    };

    /**
     * Save outlet billing address into additional_data.billing_address without removing other additional_data keys
     */
    const postApiBillingInfo = (
        postApiBillingInfoBody: PostApiBillingInfoBody,
        options?: SecondParameter<typeof customFetcher<PostApiBillingInfo200>>,
    ) => {
        return customFetcher<PostApiBillingInfo200>(
            {
                url: `/api/billing-info`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiBillingInfoBody,
            },
            options,
        );
    };

    /**
     * Get Billwerk payment invoices for the authenticated outlet
     */
    const getApiSubscriptionInvoices = (
        options?: SecondParameter<typeof customFetcher<GetApiSubscriptionInvoices200>>,
    ) => {
        return customFetcher<GetApiSubscriptionInvoices200>(
            { url: `/api/subscription/invoices`, method: 'GET' },
            options,
        );
    };

    /**
     * Generate and download a Billwerk subscription invoice PDF
     */
    const getApiSubscriptionDownloadInvoiceId = (
        id: string,
        options?: SecondParameter<typeof customFetcher<GetApiSubscriptionDownloadInvoiceId200>>,
    ) => {
        return customFetcher<GetApiSubscriptionDownloadInvoiceId200>(
            { url: `/api/subscription/download-invoice/${id}`, method: 'GET' },
            options,
        );
    };

    /**
     * Accept a data processing agreement (records outlet acceptance)
     */
    const postApiDataProcessingAgreementIdAccept = (
        id: string,
        postApiDataProcessingAgreementIdAcceptBody: PostApiDataProcessingAgreementIdAcceptBody,
        options?: SecondParameter<typeof customFetcher<PostApiDataProcessingAgreementIdAccept201>>,
    ) => {
        return customFetcher<PostApiDataProcessingAgreementIdAccept201>(
            {
                url: `/api/data-processing-agreement/${id}/accept`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: postApiDataProcessingAgreementIdAcceptBody,
            },
            options,
        );
    };

    /**
     * List pending data processing agreements for the outlet (active, started, not yet accepted by this outlet)
     */
    const getApiDataProcessingAgreementsPending = (
        options?: SecondParameter<typeof customFetcher<GetApiDataProcessingAgreementsPending200>>,
    ) => {
        return customFetcher<GetApiDataProcessingAgreementsPending200>(
            { url: `/api/data-processing-agreements/pending`, method: 'GET' },
            options,
        );
    };

    return {
        getHealth,
        getReady,
        getApiMessageLogsOutletId,
        postApiProductCategories,
        getApiProductCategories,
        putApiCatalogSequence,
        putApiProductCategoriesId,
        deleteApiProductCategoriesId,
        getApiUnits,
        postApiUnits,
        getApiUnitsId,
        putApiUnitsId,
        deleteApiUnitsId,
        postApiProduct,
        getApiProductsId,
        putApiProductId,
        deleteApiProducts,
        putApiUpdateProducts,
        getApiProductsListing,
        postApiSupplier,
        getApiSupplierId,
        putApiSupplierId,
        deleteApiSupplierId,
        getApiListSuppliers,
        postApiStock,
        getApiCategoryListPrintIdType,
        getApiSupplierListPrintType,
        getApiProductListPrintType,
        getApiPaymentsChargeSubscription,
        postApiPaymentsWebhook,
        postApiPaymentsSubscriptionPay,
        postApiPaymentsSubscriptionStart,
        putApiPaymentsSubscriptionEdit,
        getApiPaymentsSubscriptionOutletOutletId,
        getApiPaymentsSubscriptionCreateSuccessPaymentId,
        getApiPaymentsSubscriptionCreateCancelPaymentId,
        getApiPaymentsCardCreateSuccess,
        getApiPaymentsCardCreateCancel,
        deleteApiPaymentsSubscriptionDelete,
        postApiPaymentsSubscriptionCreate,
        postApiPaymentsSubscriptionRenewalOverdue,
        getApiPaymentsCard,
        postApiPaymentsCard,
        deleteApiPaymentsCardId,
        postApiSale,
        getApiSaleId,
        getApiSalesList,
        getApiSalesDetailsId,
        getApiPreviousSalesItemsCustomerId,
        getApiGetCustomerLedgerId,
        getApiGetcreditsales,
        postApiSendSalesEmail,
        deleteApiSalesId,
        putApiCreditSaleId,
        putApiEditSalesId,
        getApiSalesListPrintType,
        postApiMakeCardPayment,
        postApiAbortCardPayment,
        getApiDirectWebstorePayments,
        postApiDirectWebstorePaymentsTransactionIdCredit,
        getApiTerminalPaymentLogPaymentId,
        getApiInvoiceIdType,
        getApiGiftcardInvoiceIdType,
        postApiDiscount,
        putApiDiscountId,
        deleteApiDiscountId,
        getApiListDiscounts,
        postApiBookingDiscount,
        getApiGenerateDiscountCode,
        postApiCheckBookingDiscount,
        getApiBookingDiscountId,
        putApiBookingDiscountId,
        deleteApiBookingDiscountId,
        getApiListBookingDiscounts,
        postApiTax,
        getApiTax,
        postApiItemTax,
        getApiItemTax,
        postApiCashDrawerOpen,
        getApiCashDrawerEmployeeSummary,
        postApiCashDrawerClose,
        getApiCashDrawerCashDrawerIdDineroPayload,
        getApiBookingsExport,
        getApiBookingsNoShowReminder,
        patchApiBookingsNoShowId,
        postApiExpense,
        getApiExpenseId,
        putApiExpenseId,
        deleteApiExpenseId,
        getApiExpenses,
        getApiExpenseCategories,
        getApiAdvanceJournalFormats,
        getApiAdvanceJournalFormatsId,
        getApiAdvanceJournalProviders,
        postApiAdvanceJournalProviders,
        getApiAdvanceJournalProvidersId,
        getApiAdvanceJournalModels,
        postApiAdvanceJournalJobs,
        getApiAdvanceJournalJobsId,
        getApiCustomers,
        getApiCustomerId,
        getApiCustomerIdSalesOverview,
        getApiCustomerIdType,
        getApiCustomersExport,
        getApiGlobalSearch,
        postApiCustomerGroups,
        getApiCustomerGroups,
        putApiCustomerGroupsId,
        getApiCustomerGroupsId,
        deleteApiCustomerGroupsId,
        postApiCustomerGroupsIdCustomers,
        deleteApiCustomerGroupsIdCustomers,
        getApiCustomerGroupsIdMembers,
        getApiCustomersCustomerIdGroups,
        postApiGiftCards,
        getApiGiftCards,
        getApiGiftCardsId,
        patchApiGiftCardsId,
        deleteApiGiftCardsId,
        getApiGiftCardsCodeCode,
        getApiGiftCardsSettings,
        putApiGiftCardsSettings,
        patchApiGiftCardsIdStatus,
        postApiGiftCardsIdUse,
        postApiGiftCardsSendEmail,
        getApiGiftCardsListType,
        postApiGiftCardsOnline,
        getApiGiftCardsOnlineType,
        getApiGiftCardOnlineId,
        putApiGiftCardsOnlineId,
        deleteApiGiftCardsOnlineId,
        postApiBundleOffers,
        getApiBundleOffers,
        getApiBundleOffersId,
        putApiBundleOffersId,
        deleteApiBundleOffersId,
        getApiBundleOffersSoldIdType,
        postApiSoldBundleOffersSendEmail,
        getApiSoldBundleOffersIdHistory,
        getApiBundleOffersCodeBundleOfferCode,
        patchApiBundleOffersIdStatus,
        patchApiSoldBundleOffersId,
        getApiBundleOffersSettings,
        putApiBundleOffersSettings,
        postApiBundleOffersUse,
        getApiBundleOfferServiceList,
        getApiServicesExport,
        getApiServicesDeposit,
        patchApiServicesDeposit,
        getApiServiceGroupsIdDrivingFees,
        patchApiServiceGroupsIdDrivingFees,
        postApiServicesSync,
        putApiServicesEmployeeAssignEmployeeId,
        getApiServicesServiceIdFormulas,
        postApiServicesServiceIdFormulas,
        putApiServicesServiceIdFormulas,
        getApiServicesServiceIdFormulasFormulaId,
        putApiServicesServiceIdFormulasFormulaId,
        deleteApiServicesServiceIdFormulasFormulaId,
        getApiStatisticsAppointments,
        getApiStatisticsServices,
        getApiStatisticsGrouped,
        getApiStatisticsSales,
        getApiStatisticsSalesSummary,
        getApiStatisticsBundleOffers,
        getApiStatisticsDiscountCodes,
        getApiStatisticsAppointmentsByTime,
        getApiStatisticsExportAppointments,
        getApiStatisticsExportServices,
        getApiStatisticsExportGrouped,
        getApiStatisticsExportAppointmentsByTime,
        getApiStatisticsExportDiscountCodes,
        getApiAnalyticsBookings,
        getApiAnalyticsEarnings,
        getApiAnalyticsCustomers,
        getApiAnalyticsAdsPerformance,
        getApiInsightsSalesType,
        getApiInsightsWeeklyTurnoverType,
        getApiInsightsSummaryItemTypeType,
        getApiInsightsSalesDetailsItemTypeIdType,
        getApiInsightsEmployeePaymentsType,
        getApiInsightsSalesEmployeeIdPaymentTypeType,
        getApiInsightsStockReports,
        getApiInsightsTaxReportsType,
        getApiInsightsCustomers,
        getApiInsightsZipcodeStatistics,
        getApiInsightsTopCustomers,
        getApiInsightsCustomerStatistics,
        getApiInsightsUniqueCustomers,
        getApiInsightsCustomerOutstanding,
        getApiInsightsGiftCards,
        getApiInsightsPunchCards,
        postApiMobilepayCreateMobilepayOrder,
        getApiMobilepayPaymentStatusReference,
        postApiMobilepayWebhook,
        postApiIotValidateToken,
        postApiGatewayapiWebhook,
        postApiGatewayapiWebhookCampaignId,
        getApiEmailUnsubscribe,
        postApiEmailUnsubscribeConfirm,
        getApiCashDrawerIdType,
        getApiNoShowIdType,
        getApiBooking,
        patchApiBookingStatusUpdate,
        getApiDineroRefreshToken,
        getApiDineroOrganizations,
        getApiDineroOrganizationsOrganizationIdAccounts,
        putApiDineroConfig,
        getApiDineroWebhook,
        postApiDineroWebhook,
        getApiAddons,
        deleteApiAddonsAddonId,
        postApiAddonsUpsert,
        getApiAddonsList,
        getApiBillyExport,
        getApiIotDevices,
        postApiIotDevices,
        putApiIotDevicesDeviceId,
        deleteApiIotDevicesDeviceId,
        getApiIotConnectionStatus,
        getApiGoogleCalendarAuthUrl,
        getApiGoogleCalendarCallback,
        postApiGoogleCalendarDisconnect,
        getApiGoogleCalendarStatus,
        postApiGoogleCalendarBookingSync,
        postApiGoogleCalendarBookingSyncByGroupUuid,
        getApiGoogleCalendarBookingStatusByGroupUuid,
        postApiGoogleCalendarSyncSchedule,
        postApiGoogleCalendarSyncHolidays,
        patchApiGoogleCalendarSettings,
        getApiGoogleCalendarWebhook,
        postApiGoogleCalendarWebhook,
        getApiCalendlyAuthUrl,
        getApiCalendlyCallback,
        postApiCalendlyDisconnect,
        getApiCalendlyStatus,
        deleteApiCalendlyWebhookSubscriptions,
        postApiCalendlyWebhook,
        postApiEconomicConnect,
        postApiEconomicDisconnect,
        getApiEconomicConfig,
        putApiEconomicConfig,
        getApiEconomicSetupData,
        postApiEconomicSyncSales,
        postApiCprLookup,
        postApiLprFormRequests,
        getApiLprFormRequests,
        getApiLprSettings,
        putApiLprSettings,
        getApiLprTreatmentMappings,
        postApiLprTreatmentMappings,
        putApiLprTreatmentMappingsBulk,
        deleteApiLprTreatmentMappingsBulk,
        putApiLprTreatmentMappingsId,
        deleteApiLprTreatmentMappingsId,
        postApiLprSksCodesSearch,
        getApiLprReportsSummary,
        getApiLprReports,
        postApiLprReportsSubmitAll,
        getApiLprReportsId,
        patchApiLprReportsId,
        postApiLprReportsIdSubmit,
        postApiLprReportsIdUndo,
        postApiLprReportsIdRemove,
        postApiLprReportsIdRestore,
        postApiInspectionGroupBookingGroupBookingUuidCreateSales,
        getApiTrustpilotConfig,
        postApiTrustpilot,
        postApiTrustpilotDisconnect,
        postApiTrustpilotSendTest,
        getApiKlaviyoConfig,
        postApiKlaviyo,
        postApiKlaviyoDisconnect,
        postApiKlaviyoSyncCustomer,
        getApiCampaigns,
        postApiCampaigns,
        getApiCampaignsId,
        putApiCampaignsId,
        deleteApiCampaignsId,
        patchApiCampaignsIdStatus,
        postApiCampaignsIdTrigger,
        getApiCampaignsTestCronJob,
        getApiRecipients,
        postApiCampaignsStatistics,
        getApiCampaignsCampaignIdStatisticsRecipients,
        putApiCampaignsCampaignIdStatisticsRecipients,
        postApiCampaignsIdSendTestEmail,
        getApiTriggerTemplates,
        getApiCampaignsEmailOverview,
        postApiMarketingSetPermissionByPercentage,
        postApiWebhooks,
        getApiWebhooks,
        putApiWebhooksId,
        deleteApiWebhooksId,
        postApiServiceSubscription,
        putApiServiceSubscriptionId,
        deleteApiServiceSubscriptionId,
        getApiServiceSubscriptionCustomer,
        postApiHealthDeclarationTemplates,
        getApiHealthDeclarationTemplates,
        getApiHealthDeclarationTemplateId,
        putApiHealthDeclarationTemplateId,
        deleteApiHealthDeclarationTemplateId,
        patchApiHealthDeclarationTemplatesBulk,
        deleteApiHealthDeclarationTemplatesBulk,
        postApiHealthDeclarationsGroupBookingGroupBookingUuid,
        putApiHealthDeclarationId,
        getApiHealthDeclarations,
        postApiHealthDeclarationBookingBookingIdSendEmail,
        patchApiEmployeeOpeningHoursEmployeeId,
        postApiServiceAdvancedReminderTemplates,
        getApiServiceAdvancedReminderTemplates,
        getApiServiceAdvancedReminderTemplatesReminderTemplateId,
        patchApiServiceAdvancedReminderTemplatesReminderTemplateId,
        deleteApiServiceAdvancedReminderTemplatesReminderTemplateId,
        patchApiServiceAdvancedReminderTemplatesBulk,
        deleteApiServiceAdvancedReminderTemplatesBulk,
        getApiServiceAppModules,
        patchApiServiceAppModulesModuleKey,
        getApiDoctorsPortalNotifications,
        patchApiDoctorsPortalNotificationsRead,
        getApiDoctorsPortalLogs,
        getApiDoctorsPortalMessages,
        patchApiDoctorsPortalMessagesReadBulk,
        getApiDoctorsPortalDoctors,
        getApiDoctorsPortalDoctorsDoctorIdDirectories,
        postApiDoctorsPortalInvite,
        deleteApiDoctorsPortalDoctorsDoctorUuid,
        postApiDoctorsPortalPublicSignupRequestOtp,
        postApiDoctorsPortalPublicSignupResendOtp,
        postApiDoctorsPortalPublicSignupVerifyOtp,
        postApiDoctorsPortalPublicLogin,
        postApiDoctorsPortalPublicLoginVerifyOtp,
        postApiDoctorsPortalPublicLoginResendOtp,
        postApiFilesUpload,
        deleteApiFiles,
        getApiImportDataSampleType,
        getApiImportDataNotifications,
        postApiImportDataNotificationsIdRead,
        getApiImportDataLogsIdErrorCsv,
        getApiImportDataServicesMetadata,
        postApiImportDataServices,
        getApiImportDataCustomersMetadata,
        postApiImportDataCustomers,
        getApiImportDataBookingsMetadata,
        postApiImportDataBookings,
        getApiImportDataJournalsMetadata,
        postApiImportDataJournals,
        postApiCommunicationTemplates,
        postApiDataProcessingAgreements,
        getApiDataProcessingAgreements,
        getApiDataProcessingAgreementId,
        putApiDataProcessingAgreementId,
        deleteApiDataProcessingAgreementId,
        getApiDataProcessingAgreementIdAcceptances,
        getApiPaymentPlan,
        getApiSubscriptionDetails,
        postApiBillingInfo,
        getApiSubscriptionInvoices,
        getApiSubscriptionDownloadInvoiceId,
        postApiDataProcessingAgreementIdAccept,
        getApiDataProcessingAgreementsPending,
    };
};
export type GetHealthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getHealth']>>>;
export type GetReadyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getReady']>>>;
export type GetApiMessageLogsOutletIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiMessageLogsOutletId']>>
>;
export type PostApiProductCategoriesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiProductCategories']>>
>;
export type GetApiProductCategoriesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiProductCategories']>>
>;
export type PutApiCatalogSequenceResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiCatalogSequence']>>
>;
export type PutApiProductCategoriesIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiProductCategoriesId']>>
>;
export type DeleteApiProductCategoriesIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiProductCategoriesId']>>
>;
export type GetApiUnitsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiUnits']>>>;
export type PostApiUnitsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiUnits']>>>;
export type GetApiUnitsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiUnitsId']>>>;
export type PutApiUnitsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiUnitsId']>>>;
export type DeleteApiUnitsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiUnitsId']>>>;
export type PostApiProductResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiProduct']>>>;
export type GetApiProductsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiProductsId']>>>;
export type PutApiProductIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiProductId']>>>;
export type DeleteApiProductsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiProducts']>>>;
export type PutApiUpdateProductsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiUpdateProducts']>>
>;
export type GetApiProductsListingResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiProductsListing']>>
>;
export type PostApiSupplierResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiSupplier']>>>;
export type GetApiSupplierIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiSupplierId']>>>;
export type PutApiSupplierIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiSupplierId']>>>;
export type DeleteApiSupplierIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiSupplierId']>>
>;
export type GetApiListSuppliersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiListSuppliers']>>
>;
export type PostApiStockResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiStock']>>>;
export type GetApiCategoryListPrintIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCategoryListPrintIdType']>>
>;
export type GetApiSupplierListPrintTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSupplierListPrintType']>>
>;
export type GetApiProductListPrintTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiProductListPrintType']>>
>;
export type GetApiPaymentsChargeSubscriptionResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsChargeSubscription']>>
>;
export type PostApiPaymentsWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsWebhook']>>
>;
export type PostApiPaymentsSubscriptionPayResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsSubscriptionPay']>>
>;
export type PostApiPaymentsSubscriptionStartResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsSubscriptionStart']>>
>;
export type PutApiPaymentsSubscriptionEditResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiPaymentsSubscriptionEdit']>>
>;
export type GetApiPaymentsSubscriptionOutletOutletIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsSubscriptionOutletOutletId']>>
>;
export type GetApiPaymentsSubscriptionCreateSuccessPaymentIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsSubscriptionCreateSuccessPaymentId']>>
>;
export type GetApiPaymentsSubscriptionCreateCancelPaymentIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsSubscriptionCreateCancelPaymentId']>>
>;
export type GetApiPaymentsCardCreateSuccessResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsCardCreateSuccess']>>
>;
export type GetApiPaymentsCardCreateCancelResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsCardCreateCancel']>>
>;
export type DeleteApiPaymentsSubscriptionDeleteResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiPaymentsSubscriptionDelete']>>
>;
export type PostApiPaymentsSubscriptionCreateResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsSubscriptionCreate']>>
>;
export type PostApiPaymentsSubscriptionRenewalOverdueResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsSubscriptionRenewalOverdue']>>
>;
export type GetApiPaymentsCardResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentsCard']>>
>;
export type PostApiPaymentsCardResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiPaymentsCard']>>
>;
export type DeleteApiPaymentsCardIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiPaymentsCardId']>>
>;
export type PostApiSaleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiSale']>>>;
export type GetApiSaleIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiSaleId']>>>;
export type GetApiSalesListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiSalesList']>>>;
export type GetApiSalesDetailsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSalesDetailsId']>>
>;
export type GetApiPreviousSalesItemsCustomerIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiPreviousSalesItemsCustomerId']>>
>;
export type GetApiGetCustomerLedgerIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGetCustomerLedgerId']>>
>;
export type GetApiGetcreditsalesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGetcreditsales']>>
>;
export type PostApiSendSalesEmailResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiSendSalesEmail']>>
>;
export type DeleteApiSalesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiSalesId']>>>;
export type PutApiCreditSaleIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiCreditSaleId']>>
>;
export type PutApiEditSalesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiEditSalesId']>>>;
export type GetApiSalesListPrintTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSalesListPrintType']>>
>;
export type PostApiMakeCardPaymentResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiMakeCardPayment']>>
>;
export type PostApiAbortCardPaymentResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiAbortCardPayment']>>
>;
export type GetApiDirectWebstorePaymentsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDirectWebstorePayments']>>
>;
export type PostApiDirectWebstorePaymentsTransactionIdCreditResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDirectWebstorePaymentsTransactionIdCredit']>>
>;
export type GetApiTerminalPaymentLogPaymentIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiTerminalPaymentLogPaymentId']>>
>;
export type GetApiInvoiceIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInvoiceIdType']>>
>;
export type GetApiGiftcardInvoiceIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftcardInvoiceIdType']>>
>;
export type PostApiDiscountResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiDiscount']>>>;
export type PutApiDiscountIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiDiscountId']>>>;
export type DeleteApiDiscountIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiDiscountId']>>
>;
export type GetApiListDiscountsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiListDiscounts']>>
>;
export type PostApiBookingDiscountResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiBookingDiscount']>>
>;
export type GetApiGenerateDiscountCodeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGenerateDiscountCode']>>
>;
export type PostApiCheckBookingDiscountResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCheckBookingDiscount']>>
>;
export type GetApiBookingDiscountIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBookingDiscountId']>>
>;
export type PutApiBookingDiscountIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiBookingDiscountId']>>
>;
export type DeleteApiBookingDiscountIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiBookingDiscountId']>>
>;
export type GetApiListBookingDiscountsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiListBookingDiscounts']>>
>;
export type PostApiTaxResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiTax']>>>;
export type GetApiTaxResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiTax']>>>;
export type PostApiItemTaxResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiItemTax']>>>;
export type GetApiItemTaxResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiItemTax']>>>;
export type PostApiCashDrawerOpenResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCashDrawerOpen']>>
>;
export type GetApiCashDrawerEmployeeSummaryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCashDrawerEmployeeSummary']>>
>;
export type PostApiCashDrawerCloseResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCashDrawerClose']>>
>;
export type GetApiCashDrawerCashDrawerIdDineroPayloadResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCashDrawerCashDrawerIdDineroPayload']>>
>;
export type GetApiBookingsExportResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBookingsExport']>>
>;
export type GetApiBookingsNoShowReminderResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBookingsNoShowReminder']>>
>;
export type PatchApiBookingsNoShowIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiBookingsNoShowId']>>
>;
export type PostApiExpenseResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiExpense']>>>;
export type GetApiExpenseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiExpenseId']>>>;
export type PutApiExpenseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiExpenseId']>>>;
export type DeleteApiExpenseIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiExpenseId']>>
>;
export type GetApiExpensesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiExpenses']>>>;
export type GetApiExpenseCategoriesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiExpenseCategories']>>
>;
export type GetApiAdvanceJournalFormatsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalFormats']>>
>;
export type GetApiAdvanceJournalFormatsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalFormatsId']>>
>;
export type GetApiAdvanceJournalProvidersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalProviders']>>
>;
export type PostApiAdvanceJournalProvidersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiAdvanceJournalProviders']>>
>;
export type GetApiAdvanceJournalProvidersIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalProvidersId']>>
>;
export type GetApiAdvanceJournalModelsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalModels']>>
>;
export type PostApiAdvanceJournalJobsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiAdvanceJournalJobs']>>
>;
export type GetApiAdvanceJournalJobsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAdvanceJournalJobsId']>>
>;
export type GetApiCustomersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomers']>>>;
export type GetApiCustomerIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerId']>>>;
export type GetApiCustomerIdSalesOverviewResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerIdSalesOverview']>>
>;
export type GetApiCustomerIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerIdType']>>
>;
export type GetApiCustomersExportResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomersExport']>>
>;
export type GetApiGlobalSearchResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGlobalSearch']>>
>;
export type PostApiCustomerGroupsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCustomerGroups']>>
>;
export type GetApiCustomerGroupsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerGroups']>>
>;
export type PutApiCustomerGroupsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiCustomerGroupsId']>>
>;
export type GetApiCustomerGroupsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerGroupsId']>>
>;
export type DeleteApiCustomerGroupsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiCustomerGroupsId']>>
>;
export type PostApiCustomerGroupsIdCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCustomerGroupsIdCustomers']>>
>;
export type DeleteApiCustomerGroupsIdCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiCustomerGroupsIdCustomers']>>
>;
export type GetApiCustomerGroupsIdMembersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomerGroupsIdMembers']>>
>;
export type GetApiCustomersCustomerIdGroupsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCustomersCustomerIdGroups']>>
>;
export type PostApiGiftCardsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiGiftCards']>>>;
export type GetApiGiftCardsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCards']>>>;
export type GetApiGiftCardsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardsId']>>>;
export type PatchApiGiftCardsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiGiftCardsId']>>
>;
export type DeleteApiGiftCardsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiGiftCardsId']>>
>;
export type GetApiGiftCardsCodeCodeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardsCodeCode']>>
>;
export type GetApiGiftCardsSettingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardsSettings']>>
>;
export type PutApiGiftCardsSettingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiGiftCardsSettings']>>
>;
export type PatchApiGiftCardsIdStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiGiftCardsIdStatus']>>
>;
export type PostApiGiftCardsIdUseResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGiftCardsIdUse']>>
>;
export type PostApiGiftCardsSendEmailResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGiftCardsSendEmail']>>
>;
export type GetApiGiftCardsListTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardsListType']>>
>;
export type PostApiGiftCardsOnlineResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGiftCardsOnline']>>
>;
export type GetApiGiftCardsOnlineTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardsOnlineType']>>
>;
export type GetApiGiftCardOnlineIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGiftCardOnlineId']>>
>;
export type PutApiGiftCardsOnlineIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiGiftCardsOnlineId']>>
>;
export type DeleteApiGiftCardsOnlineIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiGiftCardsOnlineId']>>
>;
export type PostApiBundleOffersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiBundleOffers']>>
>;
export type GetApiBundleOffersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOffers']>>
>;
export type GetApiBundleOffersIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOffersId']>>
>;
export type PutApiBundleOffersIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiBundleOffersId']>>
>;
export type DeleteApiBundleOffersIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiBundleOffersId']>>
>;
export type GetApiBundleOffersSoldIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOffersSoldIdType']>>
>;
export type PostApiSoldBundleOffersSendEmailResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiSoldBundleOffersSendEmail']>>
>;
export type GetApiSoldBundleOffersIdHistoryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSoldBundleOffersIdHistory']>>
>;
export type GetApiBundleOffersCodeBundleOfferCodeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOffersCodeBundleOfferCode']>>
>;
export type PatchApiBundleOffersIdStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiBundleOffersIdStatus']>>
>;
export type PatchApiSoldBundleOffersIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiSoldBundleOffersId']>>
>;
export type GetApiBundleOffersSettingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOffersSettings']>>
>;
export type PutApiBundleOffersSettingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiBundleOffersSettings']>>
>;
export type PostApiBundleOffersUseResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiBundleOffersUse']>>
>;
export type GetApiBundleOfferServiceListResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiBundleOfferServiceList']>>
>;
export type GetApiServicesExportResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServicesExport']>>
>;
export type GetApiServicesDepositResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServicesDeposit']>>
>;
export type PatchApiServicesDepositResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiServicesDeposit']>>
>;
export type GetApiServiceGroupsIdDrivingFeesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServiceGroupsIdDrivingFees']>>
>;
export type PatchApiServiceGroupsIdDrivingFeesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiServiceGroupsIdDrivingFees']>>
>;
export type PostApiServicesSyncResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiServicesSync']>>
>;
export type PutApiServicesEmployeeAssignEmployeeIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiServicesEmployeeAssignEmployeeId']>>
>;
export type GetApiServicesServiceIdFormulasResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServicesServiceIdFormulas']>>
>;
export type PostApiServicesServiceIdFormulasResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiServicesServiceIdFormulas']>>
>;
export type PutApiServicesServiceIdFormulasResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiServicesServiceIdFormulas']>>
>;
export type GetApiServicesServiceIdFormulasFormulaIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServicesServiceIdFormulasFormulaId']>>
>;
export type PutApiServicesServiceIdFormulasFormulaIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiServicesServiceIdFormulasFormulaId']>>
>;
export type DeleteApiServicesServiceIdFormulasFormulaIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiServicesServiceIdFormulasFormulaId']>>
>;
export type GetApiStatisticsAppointmentsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsAppointments']>>
>;
export type GetApiStatisticsServicesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsServices']>>
>;
export type GetApiStatisticsGroupedResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsGrouped']>>
>;
export type GetApiStatisticsSalesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsSales']>>
>;
export type GetApiStatisticsSalesSummaryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsSalesSummary']>>
>;
export type GetApiStatisticsBundleOffersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsBundleOffers']>>
>;
export type GetApiStatisticsDiscountCodesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsDiscountCodes']>>
>;
export type GetApiStatisticsAppointmentsByTimeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsAppointmentsByTime']>>
>;
export type GetApiStatisticsExportAppointmentsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsExportAppointments']>>
>;
export type GetApiStatisticsExportServicesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsExportServices']>>
>;
export type GetApiStatisticsExportGroupedResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsExportGrouped']>>
>;
export type GetApiStatisticsExportAppointmentsByTimeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsExportAppointmentsByTime']>>
>;
export type GetApiStatisticsExportDiscountCodesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiStatisticsExportDiscountCodes']>>
>;
export type GetApiAnalyticsBookingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAnalyticsBookings']>>
>;
export type GetApiAnalyticsEarningsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAnalyticsEarnings']>>
>;
export type GetApiAnalyticsCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAnalyticsCustomers']>>
>;
export type GetApiAnalyticsAdsPerformanceResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiAnalyticsAdsPerformance']>>
>;
export type GetApiInsightsSalesTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsSalesType']>>
>;
export type GetApiInsightsWeeklyTurnoverTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsWeeklyTurnoverType']>>
>;
export type GetApiInsightsSummaryItemTypeTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsSummaryItemTypeType']>>
>;
export type GetApiInsightsSalesDetailsItemTypeIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsSalesDetailsItemTypeIdType']>>
>;
export type GetApiInsightsEmployeePaymentsTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsEmployeePaymentsType']>>
>;
export type GetApiInsightsSalesEmployeeIdPaymentTypeTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsSalesEmployeeIdPaymentTypeType']>>
>;
export type GetApiInsightsStockReportsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsStockReports']>>
>;
export type GetApiInsightsTaxReportsTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsTaxReportsType']>>
>;
export type GetApiInsightsCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsCustomers']>>
>;
export type GetApiInsightsZipcodeStatisticsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsZipcodeStatistics']>>
>;
export type GetApiInsightsTopCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsTopCustomers']>>
>;
export type GetApiInsightsCustomerStatisticsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsCustomerStatistics']>>
>;
export type GetApiInsightsUniqueCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsUniqueCustomers']>>
>;
export type GetApiInsightsCustomerOutstandingResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsCustomerOutstanding']>>
>;
export type GetApiInsightsGiftCardsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsGiftCards']>>
>;
export type GetApiInsightsPunchCardsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiInsightsPunchCards']>>
>;
export type PostApiMobilepayCreateMobilepayOrderResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiMobilepayCreateMobilepayOrder']>>
>;
export type GetApiMobilepayPaymentStatusReferenceResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiMobilepayPaymentStatusReference']>>
>;
export type PostApiMobilepayWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiMobilepayWebhook']>>
>;
export type PostApiIotValidateTokenResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiIotValidateToken']>>
>;
export type PostApiGatewayapiWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGatewayapiWebhook']>>
>;
export type PostApiGatewayapiWebhookCampaignIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGatewayapiWebhookCampaignId']>>
>;
export type GetApiEmailUnsubscribeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiEmailUnsubscribe']>>
>;
export type PostApiEmailUnsubscribeConfirmResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiEmailUnsubscribeConfirm']>>
>;
export type GetApiCashDrawerIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCashDrawerIdType']>>
>;
export type GetApiNoShowIdTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiNoShowIdType']>>
>;
export type GetApiBookingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiBooking']>>>;
export type PatchApiBookingStatusUpdateResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiBookingStatusUpdate']>>
>;
export type GetApiDineroRefreshTokenResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDineroRefreshToken']>>
>;
export type GetApiDineroOrganizationsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDineroOrganizations']>>
>;
export type GetApiDineroOrganizationsOrganizationIdAccountsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDineroOrganizationsOrganizationIdAccounts']>>
>;
export type PutApiDineroConfigResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiDineroConfig']>>
>;
export type GetApiDineroWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDineroWebhook']>>
>;
export type PostApiDineroWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDineroWebhook']>>
>;
export type GetApiAddonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiAddons']>>>;
export type DeleteApiAddonsAddonIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiAddonsAddonId']>>
>;
export type PostApiAddonsUpsertResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiAddonsUpsert']>>
>;
export type GetApiAddonsListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiAddonsList']>>>;
export type GetApiBillyExportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiBillyExport']>>>;
export type GetApiIotDevicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiIotDevices']>>>;
export type PostApiIotDevicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiIotDevices']>>>;
export type PutApiIotDevicesDeviceIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiIotDevicesDeviceId']>>
>;
export type DeleteApiIotDevicesDeviceIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiIotDevicesDeviceId']>>
>;
export type GetApiIotConnectionStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiIotConnectionStatus']>>
>;
export type GetApiGoogleCalendarAuthUrlResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGoogleCalendarAuthUrl']>>
>;
export type GetApiGoogleCalendarCallbackResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGoogleCalendarCallback']>>
>;
export type PostApiGoogleCalendarDisconnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarDisconnect']>>
>;
export type GetApiGoogleCalendarStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGoogleCalendarStatus']>>
>;
export type PostApiGoogleCalendarBookingSyncResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarBookingSync']>>
>;
export type PostApiGoogleCalendarBookingSyncByGroupUuidResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarBookingSyncByGroupUuid']>>
>;
export type GetApiGoogleCalendarBookingStatusByGroupUuidResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGoogleCalendarBookingStatusByGroupUuid']>>
>;
export type PostApiGoogleCalendarSyncScheduleResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarSyncSchedule']>>
>;
export type PostApiGoogleCalendarSyncHolidaysResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarSyncHolidays']>>
>;
export type PatchApiGoogleCalendarSettingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiGoogleCalendarSettings']>>
>;
export type GetApiGoogleCalendarWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiGoogleCalendarWebhook']>>
>;
export type PostApiGoogleCalendarWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiGoogleCalendarWebhook']>>
>;
export type GetApiCalendlyAuthUrlResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCalendlyAuthUrl']>>
>;
export type GetApiCalendlyCallbackResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCalendlyCallback']>>
>;
export type PostApiCalendlyDisconnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCalendlyDisconnect']>>
>;
export type GetApiCalendlyStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCalendlyStatus']>>
>;
export type DeleteApiCalendlyWebhookSubscriptionsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiCalendlyWebhookSubscriptions']>>
>;
export type PostApiCalendlyWebhookResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCalendlyWebhook']>>
>;
export type PostApiEconomicConnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiEconomicConnect']>>
>;
export type PostApiEconomicDisconnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiEconomicDisconnect']>>
>;
export type GetApiEconomicConfigResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiEconomicConfig']>>
>;
export type PutApiEconomicConfigResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiEconomicConfig']>>
>;
export type GetApiEconomicSetupDataResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiEconomicSetupData']>>
>;
export type PostApiEconomicSyncSalesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiEconomicSyncSales']>>
>;
export type PostApiCprLookupResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiCprLookup']>>>;
export type PostApiLprFormRequestsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprFormRequests']>>
>;
export type GetApiLprFormRequestsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprFormRequests']>>
>;
export type GetApiLprSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprSettings']>>>;
export type PutApiLprSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiLprSettings']>>>;
export type GetApiLprTreatmentMappingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprTreatmentMappings']>>
>;
export type PostApiLprTreatmentMappingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprTreatmentMappings']>>
>;
export type PutApiLprTreatmentMappingsBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiLprTreatmentMappingsBulk']>>
>;
export type DeleteApiLprTreatmentMappingsBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiLprTreatmentMappingsBulk']>>
>;
export type PutApiLprTreatmentMappingsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiLprTreatmentMappingsId']>>
>;
export type DeleteApiLprTreatmentMappingsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiLprTreatmentMappingsId']>>
>;
export type PostApiLprSksCodesSearchResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprSksCodesSearch']>>
>;
export type GetApiLprReportsSummaryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprReportsSummary']>>
>;
export type GetApiLprReportsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprReports']>>>;
export type PostApiLprReportsSubmitAllResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprReportsSubmitAll']>>
>;
export type GetApiLprReportsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiLprReportsId']>>
>;
export type PatchApiLprReportsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiLprReportsId']>>
>;
export type PostApiLprReportsIdSubmitResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprReportsIdSubmit']>>
>;
export type PostApiLprReportsIdUndoResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprReportsIdUndo']>>
>;
export type PostApiLprReportsIdRemoveResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprReportsIdRemove']>>
>;
export type PostApiLprReportsIdRestoreResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiLprReportsIdRestore']>>
>;
export type PostApiInspectionGroupBookingGroupBookingUuidCreateSalesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiInspectionGroupBookingGroupBookingUuidCreateSales']>>
>;
export type GetApiTrustpilotConfigResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiTrustpilotConfig']>>
>;
export type PostApiTrustpilotResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiTrustpilot']>>>;
export type PostApiTrustpilotDisconnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiTrustpilotDisconnect']>>
>;
export type PostApiTrustpilotSendTestResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiTrustpilotSendTest']>>
>;
export type GetApiKlaviyoConfigResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiKlaviyoConfig']>>
>;
export type PostApiKlaviyoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiKlaviyo']>>>;
export type PostApiKlaviyoDisconnectResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiKlaviyoDisconnect']>>
>;
export type PostApiKlaviyoSyncCustomerResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiKlaviyoSyncCustomer']>>
>;
export type GetApiCampaignsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiCampaigns']>>>;
export type PostApiCampaignsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiCampaigns']>>>;
export type GetApiCampaignsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiCampaignsId']>>>;
export type PutApiCampaignsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiCampaignsId']>>>;
export type DeleteApiCampaignsIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiCampaignsId']>>
>;
export type PatchApiCampaignsIdStatusResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiCampaignsIdStatus']>>
>;
export type PostApiCampaignsIdTriggerResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCampaignsIdTrigger']>>
>;
export type GetApiCampaignsTestCronJobResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCampaignsTestCronJob']>>
>;
export type GetApiRecipientsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiRecipients']>>>;
export type PostApiCampaignsStatisticsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCampaignsStatistics']>>
>;
export type GetApiCampaignsCampaignIdStatisticsRecipientsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCampaignsCampaignIdStatisticsRecipients']>>
>;
export type PutApiCampaignsCampaignIdStatisticsRecipientsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiCampaignsCampaignIdStatisticsRecipients']>>
>;
export type PostApiCampaignsIdSendTestEmailResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCampaignsIdSendTestEmail']>>
>;
export type GetApiTriggerTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiTriggerTemplates']>>
>;
export type GetApiCampaignsEmailOverviewResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiCampaignsEmailOverview']>>
>;
export type PostApiMarketingSetPermissionByPercentageResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiMarketingSetPermissionByPercentage']>>
>;
export type PostApiWebhooksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['postApiWebhooks']>>>;
export type GetApiWebhooksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiWebhooks']>>>;
export type PutApiWebhooksIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['putApiWebhooksId']>>>;
export type DeleteApiWebhooksIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiWebhooksId']>>
>;
export type PostApiServiceSubscriptionResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiServiceSubscription']>>
>;
export type PutApiServiceSubscriptionIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiServiceSubscriptionId']>>
>;
export type DeleteApiServiceSubscriptionIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiServiceSubscriptionId']>>
>;
export type GetApiServiceSubscriptionCustomerResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServiceSubscriptionCustomer']>>
>;
export type PostApiHealthDeclarationTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiHealthDeclarationTemplates']>>
>;
export type GetApiHealthDeclarationTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiHealthDeclarationTemplates']>>
>;
export type GetApiHealthDeclarationTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiHealthDeclarationTemplateId']>>
>;
export type PutApiHealthDeclarationTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiHealthDeclarationTemplateId']>>
>;
export type DeleteApiHealthDeclarationTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiHealthDeclarationTemplateId']>>
>;
export type PatchApiHealthDeclarationTemplatesBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiHealthDeclarationTemplatesBulk']>>
>;
export type DeleteApiHealthDeclarationTemplatesBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiHealthDeclarationTemplatesBulk']>>
>;
export type PostApiHealthDeclarationsGroupBookingGroupBookingUuidResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiHealthDeclarationsGroupBookingGroupBookingUuid']>>
>;
export type PutApiHealthDeclarationIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiHealthDeclarationId']>>
>;
export type GetApiHealthDeclarationsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiHealthDeclarations']>>
>;
export type PostApiHealthDeclarationBookingBookingIdSendEmailResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiHealthDeclarationBookingBookingIdSendEmail']>>
>;
export type PatchApiEmployeeOpeningHoursEmployeeIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiEmployeeOpeningHoursEmployeeId']>>
>;
export type PostApiServiceAdvancedReminderTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiServiceAdvancedReminderTemplates']>>
>;
export type GetApiServiceAdvancedReminderTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServiceAdvancedReminderTemplates']>>
>;
export type GetApiServiceAdvancedReminderTemplatesReminderTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServiceAdvancedReminderTemplatesReminderTemplateId']>>
>;
export type PatchApiServiceAdvancedReminderTemplatesReminderTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiServiceAdvancedReminderTemplatesReminderTemplateId']>>
>;
export type DeleteApiServiceAdvancedReminderTemplatesReminderTemplateIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiServiceAdvancedReminderTemplatesReminderTemplateId']>>
>;
export type PatchApiServiceAdvancedReminderTemplatesBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiServiceAdvancedReminderTemplatesBulk']>>
>;
export type DeleteApiServiceAdvancedReminderTemplatesBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiServiceAdvancedReminderTemplatesBulk']>>
>;
export type GetApiServiceAppModulesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiServiceAppModules']>>
>;
export type PatchApiServiceAppModulesModuleKeyResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiServiceAppModulesModuleKey']>>
>;
export type GetApiDoctorsPortalNotificationsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDoctorsPortalNotifications']>>
>;
export type PatchApiDoctorsPortalNotificationsReadResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiDoctorsPortalNotificationsRead']>>
>;
export type GetApiDoctorsPortalLogsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDoctorsPortalLogs']>>
>;
export type GetApiDoctorsPortalMessagesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDoctorsPortalMessages']>>
>;
export type PatchApiDoctorsPortalMessagesReadBulkResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['patchApiDoctorsPortalMessagesReadBulk']>>
>;
export type GetApiDoctorsPortalDoctorsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDoctorsPortalDoctors']>>
>;
export type GetApiDoctorsPortalDoctorsDoctorIdDirectoriesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDoctorsPortalDoctorsDoctorIdDirectories']>>
>;
export type PostApiDoctorsPortalInviteResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalInvite']>>
>;
export type DeleteApiDoctorsPortalDoctorsDoctorUuidResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiDoctorsPortalDoctorsDoctorUuid']>>
>;
export type PostApiDoctorsPortalPublicSignupRequestOtpResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicSignupRequestOtp']>>
>;
export type PostApiDoctorsPortalPublicSignupResendOtpResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicSignupResendOtp']>>
>;
export type PostApiDoctorsPortalPublicSignupVerifyOtpResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicSignupVerifyOtp']>>
>;
export type PostApiDoctorsPortalPublicLoginResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicLogin']>>
>;
export type PostApiDoctorsPortalPublicLoginVerifyOtpResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicLoginVerifyOtp']>>
>;
export type PostApiDoctorsPortalPublicLoginResendOtpResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDoctorsPortalPublicLoginResendOtp']>>
>;
export type PostApiFilesUploadResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiFilesUpload']>>
>;
export type DeleteApiFilesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiFiles']>>>;
export type GetApiImportDataSampleTypeResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataSampleType']>>
>;
export type GetApiImportDataNotificationsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataNotifications']>>
>;
export type PostApiImportDataNotificationsIdReadResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiImportDataNotificationsIdRead']>>
>;
export type GetApiImportDataLogsIdErrorCsvResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataLogsIdErrorCsv']>>
>;
export type GetApiImportDataServicesMetadataResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataServicesMetadata']>>
>;
export type PostApiImportDataServicesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiImportDataServices']>>
>;
export type GetApiImportDataCustomersMetadataResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataCustomersMetadata']>>
>;
export type PostApiImportDataCustomersResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiImportDataCustomers']>>
>;
export type GetApiImportDataBookingsMetadataResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataBookingsMetadata']>>
>;
export type PostApiImportDataBookingsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiImportDataBookings']>>
>;
export type GetApiImportDataJournalsMetadataResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiImportDataJournalsMetadata']>>
>;
export type PostApiImportDataJournalsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiImportDataJournals']>>
>;
export type PostApiCommunicationTemplatesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiCommunicationTemplates']>>
>;
export type PostApiDataProcessingAgreementsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDataProcessingAgreements']>>
>;
export type GetApiDataProcessingAgreementsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDataProcessingAgreements']>>
>;
export type GetApiDataProcessingAgreementIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDataProcessingAgreementId']>>
>;
export type PutApiDataProcessingAgreementIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['putApiDataProcessingAgreementId']>>
>;
export type DeleteApiDataProcessingAgreementIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['deleteApiDataProcessingAgreementId']>>
>;
export type GetApiDataProcessingAgreementIdAcceptancesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDataProcessingAgreementIdAcceptances']>>
>;
export type GetApiPaymentPlanResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApi>['getApiPaymentPlan']>>>;
export type GetApiSubscriptionDetailsResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSubscriptionDetails']>>
>;
export type PostApiBillingInfoResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiBillingInfo']>>
>;
export type GetApiSubscriptionInvoicesResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSubscriptionInvoices']>>
>;
export type GetApiSubscriptionDownloadInvoiceIdResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiSubscriptionDownloadInvoiceId']>>
>;
export type PostApiDataProcessingAgreementIdAcceptResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['postApiDataProcessingAgreementIdAccept']>>
>;
export type GetApiDataProcessingAgreementsPendingResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof getApi>['getApiDataProcessingAgreementsPending']>>
>;
